<template>
<div>
  <div v-if="currentstep == 18">
    <body class="builder-page">
      <div class="top-header">
        <div class="top-left">
          <div class="logo">
            <a href="/Dashboard">
              <img src="../../assets/CC-Logo-White.svg" alt>
            </a>
          </div>
        </div>
      </div>
      <div class="resume-builder-main">
        <div class="resume-builder-right resume-builder-choose">
          <div class="content">
            <h3>How do you want to build your resume?</h3>
            <div class="resume-build">
              <a
                href="javascript:void(0);"
                @click="haveResume('no')"
                class="resume-block first-box"
              >
                <span>
                  <i class="material-icons">add</i>
                </span>
                <span class="checkmark-active">
                  <i class="material-icons">done</i>
                </span>
                <h4>Create A New Resume</h4>
                <p>We will help you create a resume step by step</p>
              </a>
              <div>
                <a
                  href="javascript:void(0);"
                  @click="haveResume('yes')"
                  class="resume-block second-box"
                >
                  <span>
                    <i class="material-icons">upload</i>
                  </span>
                  <span class="checkmark-active">
                    <i class="material-icons">done</i>
                  </span>
                  <h4>I Already Have A Resume</h4>
                  <p>We will transfer everything to your new template</p>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </body>
  </div>
  <div v-if="currentstep == 19">
    <body class="builder-page">
      <div class="top-header">
        <div class="top-left">
          <div class="logo">
            <a href="/Dashboard">
              <img src="../../assets/CC-Logo-White.svg" alt>
            </a>
          </div>
        </div>
      </div>
      <div class="resume-builder-main">
        <div class="resume-builder-right resume-builder-choose">
          <div class="content">
            <div class="resume-build">
              <div class="resume-block custom-browse box">
                <!-- <span class="icon-close">
                <i class="material-icons">close</i>
                </span>-->

                <label for="file-5">
                  <h4>Upload My Resume</h4>
                  <div class="upload-icon">
                    <i class="material-icons">upload</i>
                  </div>

                  <!-- <div class="primary-btn">Browse</div> -->
                  <input
                    type="file"
                    name="file-5"
                    id="file-5"
                    @change="validateResumeFile"
                    class="inputfile inputfile-4 primary-btn"
                  >
                  <div class="format-names">
                    <strong v-if="filename != ''">{{ filename }}</strong>
                    <br>
                    <strong>Acceptable file types:</strong>
                    <br>DOC, DOCX, PDF, HTM, RTF, TXT
                  </div>
                </label>
              </div>
            </div>
          </div>
          <div class="btn-sec">
            <a @click="back(currentstep)" class="btn-secondary md-ink-ripple">Back</a>
            <a href="#" @click="Submitupload" class="btn-primary md-ink-ripple">Continue</a>
          </div>
        </div>
      </div>
    </body>
  </div>
  <div v-if="currentstep == 22">
    <body class="builder-page">
      <div class="top-header">
        <div class="top-left">
          <div class="logo">
            <a href="/Dashboard">
              <img src="../../assets/CC-Logo-White.svg" alt>
            </a>
          </div>
        </div>
      </div>
      <div class="resume-builder-main">
        <div class="resume-builder-right resume-builder-choose">
          <div class="content">
            <h3>Do you want to personalize your resume?</h3>
            <h4 class="text-center">Do you have a job description?</h4>
            <div class="resume-build">
              <a
                href="javascript:void(0);"
                @click="haveJobdesc('yes')"
                class="resume-block first-box"
              >
                <span class="checkmark-active">
                  <i class="material-icons">done</i>
                </span>
                <h4>Yes</h4>
                <!-- <p>We will help to customize your resume</p> -->
              </a>
              <div>
                <a
                  href="javascript:void(0);"
                  @click="haveJobdesc('no')"
                  class="resume-block second-box"
                >
                  <span class="checkmark-active">
                    <i class="material-icons">done</i>
                  </span>
                  <h4>No</h4>
                  <!-- <p>We will transfer everything to your new template</p> -->
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </body>
  </div>
  <div v-if="currentstep == 21">
    <body class="builder-page">
      <div class="top-header">
        <div class="top-left">
          <div class="logo">
            <a href="/Dashboard">
              <img src="../../assets/CC-Logo-White.svg" alt>
            </a>
          </div>
        </div>
        <div class="top-right">
          <a class="menu-toggle" href="#">
            <i class="material-icons">menu</i>
          </a>
        </div>
      </div>
      <div class="resume-builder-main">
        <div class="resume-builder-right resume-builder-choose">
          <div class="content">
            <div class="resume-build">
              <!-- <span class="icon-close">
                <i class="material-icons">close</i>
              </span>-->

              <label>
                <h4>Enter Job description</h4>
                <textarea v-model="Job_desc"></textarea>
              </label>
              <span
                v-if="err_jd"
                style="
                    color: red;
                    margin-top: 0px;
                    margin-bottom: 7px;
                    display: block;
                  "
              >Enter valid job description</span>
            </div>
          </div>
          <div class="btn-sec">
            <a @click="backfromjd" class="btn-secondary md-ink-ripple">Back</a>
            <a href="#" @click="submittocustomize" class="btn-primary md-ink-ripple">Personalize</a>
          </div>
        </div>
      </div>
    </body>
  </div>
  <div v-if="currentstep == 1">
    <body class="builder-page">
      <div class="top-header">
        <div class="top-left">
          <div class="logo">
            <a href="/Dashboard">
              <img src="../../assets/CC-Logo-White.svg" alt>
            </a>
          </div>
        </div>
        <div class="top-right">
          <a class="menu-toggle" href="#">
            <i class="material-icons">menu</i>
          </a>
        </div>
      </div>
      <div class="resume-builder-main">
        <div class="resume-builder-left">
          <!--<div class="logo">
                <a href="#"><img src="images/builder/CC-Logo-White.svg" alt="" /></a>
          </div>-->
          <div class="resume-section">
            <h3>Resume Sections</h3>
            <div class="logo">
              <a href="/Dashboard">
                <img src="/img/CC-Logo-White.1144d714.svg" alt>
              </a>
            </div>
            <ul>
              <li class="active">
                <a @click.prevent="Jumptoheading" href>
                  <span>1</span> Heading
                </a>
              </li>
              <li>
                <a @click.prevent="Jumptowork" href>
                  <span>2</span> Experience
                </a>
              </li>
              <li>
                <a @click.prevent="Jumptoeducation" href>
                  <span>3</span> Education
                </a>
              </li>
              <li>
                <a @click.prevent="Jumptoskill" href>
                  <span>4</span> Skills
                </a>
              </li>
              <li>
                <a @click.prevent="Jumptosummary" href>
                  <span>5</span>Summary
                </a>
              </li>
              <li>
                <a @click.prevent="Jumptooptional" href>
                  <span>6</span> Others
                </a>
              </li>
              <li>
                <a @click.prevent="Jumptofinal" href>
                  <span>7</span> Finalize
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div class="resume-builder-right">
          <!--<div class="top">
                <a class="menu-toggle" href="#"><i class="material-icons">menu</i></a>
          </div>-->
          <div class="content">
            <h3>Let's Start with your Resume Heading</h3>
            <p>We suggest including an email and phone number.</p>
            <div class="form-section">
              <div class="left-form">
                <div class="headingSection">
                  <div class="uploadSection">
                    <div class="upload-img">
                      <div class="img-box">
                        <img id="imgPreview" :src="temp_pic" alt>
                      </div>
                      <label class="btn-secondary md-ink-ripple" for="fileUpload">Upload Image</label>
                      <input
                        style="display: none"
                        type="file"
                        name="fileUpload"
                        @change="previewFiles"
                        id="fileUpload"
                        accept="image/*"
                      >
                    </div>
                  </div>
                  <div class="headingContent">
                    <div class="row">
                      <div class="col-xl-6">
                        <div class="form-group">
                          <label>
                            First Name
                            <span class="required">*</span>
                          </label>
                          <input
                            class="form-control"
                            v-model="First_Name"
                            @input="err_name = false;showselectedcv()"
                            v-on:keypress="validateKeyPress(event)"
                            type="text"
                            name
                            placeholder="e.g. Rahul"
                          >
                        </div>
                        <span
                          v-if="err_name"
                          style="
                          color: red;
                          margin-top: 0px;
                          margin-bottom: 7px;
                          display: block;
                        "
                        >Enter valid first name</span>
                      </div>
                      <div class="col-xl-6">
                        <div class="form-group">
                          <label>Surname</label>
                          <input
                            class="form-control"
                            type="text"
                            v-model="Last_Name"
                            @input="showselectedcv()"
                            v-on:keypress="validateKeyPress(event)"
                            name
                            placeholder="e.g. Sharma"
                          >
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-group">
                          <label>
                            Profession
                            <span class="required">*</span>
                          </label>
                          <input
                            class="form-control"
                            type="text"
                            @input="err_prof = false;showselectedcv()"
                            v-model="Profession"
                            v-on:keypress="validateKeyPress(event)"
                            name
                            placeholder="e.g. Software Engineer"
                          >
                        </div>
                        <span
                          v-if="err_prof"
                          style="
                          color: red;
                          margin-top: 0px;
                          margin-bottom: 7px;
                          display: block;
                        "
                        >Enter valid profession</span>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-xl-3">
                        <div class="form-group">
                          <label>Pincode</label>
                          <input
                            class="form-control"
                            type="number"
                            v-on:keypress="isPincode(event)"
                            v-model="Pin_code"
                            @input="populatecitycountry()"
                            name
                            placeholder="302006"
                          >
                        </div>
                      </div>
                      <div class="col-xl-3">
                        <div class="form-group">
                          <label>Country</label>
                          <input
                            class="form-control"
                            type="text"
                            v-model="Country"
                            v-on:keypress="validateKeyPress(event)"
                            @input="showselectedcv()"
                            name
                            placeholder="India"
                          >
                        </div>
                      </div>
                      <div class="col-xl-6">
                        <div class="form-group">
                          <label>City</label>
                          <!-- <input
                        class="form-control"
                        v-model="City"
                        type="text"
                        v-on:keypress="validateKeyPress(event)"
                        name
                        placeholder="Jaipur"
                          >-->
                          <multiselect
                            v-model="City"
                            :options="cities"
                            :taggable="true"
                            @tag="onTagcity($event)"
                            :multiple="false"
                          ></multiselect>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-xl-6">
                        <div class="form-group">
                          <label>Phone</label>
                          <input
                            class="form-control"
                            type="number"
                            v-on:keypress="isNumber(event)"
                            v-model="Phone"
                            @input="err_phone = false;showselectedcv()"
                            name
                            placeholder="e.g. 9876543210"
                          >
                        </div>
                        <span
                          v-if="err_phone"
                          style="
                          color: red;
                          margin-top: 0px;
                          margin-bottom: 7px;
                          display: block;
                        "
                        >Enter valid phone number</span>
                      </div>
                      <div class="col-xl-6">
                        <div class="form-group">
                          <label>
                            Email
                            <span class="required">*</span>
                          </label>
                          <input
                            class="form-control"
                            type="email"
                            name
                            v-model="Email"
                            @input="EmailCheck;showselectedcv()"
                            placeholder="e.g. sharma@gmail.com"
                          >
                        </div>
                        <span
                          v-if="err_email_regex"
                          style="
                          color: red;
                          margin-top: 0px;
                          margin-bottom: 7px;
                          display: block;
                        "
                        >Enter valid email address</span>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-xl-6">
                        <div class="form-group">
                          <label>Address</label>
                          <input
                            class="form-control"
                            type="text"
                            name
                            v-model="Address"
                            @input="showselectedcv()"
                            placeholder
                          >
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-xl-6">
                        <div>
                          <a @click="AddSociallink" class="add-social-links add">
                            <span v-if="issocial">
                              <i class="material-icons">add</i>Add Social Link(Optional)
                            </span>
                            <span v-if="!issocial">
                              <i class="material-icons">remove</i>Minimize
                            </span>
                          </a>
                        </div>
                      </div>
                    </div>
                    <div v-if="!issocial">
                      <div class="row">
                        <div class="col-xl-6">
                          <div class="form-group">
                            <label>LinkedIn</label>
                            <input
                              class="form-control"
                              type="text"
                              v-model="Linkedin"
                              @input="showselectedcv()"
                              name
                              placeholder
                            >
                          </div>
                        </div>
                        <div class="col-xl-6">
                          <div class="form-group">
                            <label>Twitter</label>
                            <input
                              class="form-control"
                              type="text"
                              v-model="Twitter"
                              @input="showselectedcv()"
                              name
                              placeholder
                            >
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-xl-6">
                          <div class="form-group">
                            <label>Website</label>
                            <input
                              class="form-control"
                              type="text"
                              v-model="Website"
                              @input="showselectedcv()"
                              name
                              placeholder
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="right-form">
                <div class="template-preview">
                  <div class="resume-template">
                    <div v-if="showResume">
                      <resumeonetemplate
                        ref="resumeone"
                        :parentObj="this"
                        :from="cvfrom"
                        :resume="resumeobj"
                      ></resumeonetemplate>
                    </div>
                    <div v-if="showResumetwo">
                      <resumetwotemplate
                        ref="resumetwo"
                        :parentObj="this"
                        :from="cvfrom"
                        :resume="resumeobj"
                      ></resumetwotemplate>
                    </div>
                    <div v-if="showResumethree">
                      <resumethreetemplate
                        ref="resumethree"
                        :parentObj="this"
                        :from="cvfrom"
                        :resume="resumeobj"
                      ></resumethreetemplate>
                    </div>
                    <div v-if="showResumefour">
                      <resumefourtemplate
                        ref="resumefour"
                        :parentObj="this"
                        :from="cvfrom"
                        :resume="resumeobj"
                      ></resumefourtemplate>
                    </div>
                    <div v-if="showResumefive">
                      <resumefivetemplate
                        ref="resumefive"
                        :parentObj="this"
                        :from="cvfrom"
                        :resume="resumeobj"
                      ></resumefivetemplate>
                    </div>
                    <div v-if="showResumesix">
                      <resumesixtemplate
                        ref="resumesix"
                        :parentObj="this"
                        :from="cvfrom"
                        :resume="resumeobj"
                      ></resumesixtemplate>
                    </div>
                    <div v-if="showResumeseven">
                      <resumeseventemplate
                        ref="resumeseven"
                        :parentObj="this"
                        :from="cvfrom"
                        :resume="resumeobj"
                      ></resumeseventemplate>
                    </div>
                    <div v-if="showResumeeight">
                      <resumeeighttemplate
                        ref="resumeeight"
                        :parentObj="this"
                        :from="cvfrom"
                        :resume="resumeobj"
                      ></resumeeighttemplate>
                    </div>
                    <div v-if="showResumenine">
                      <resumeninetemplate
                        ref="resumenine"
                        :parentObj="this"
                        :from="cvfrom"
                        :resume="resumeobj"
                      ></resumeninetemplate>
                    </div>
                    <div v-if="showResumetwelve">
                      <resumetwelvetemplate
                        ref="resumetwelve"
                        :parentObj="this"
                        :from="cvfrom"
                        :resume="resumeobj"
                      ></resumetwelvetemplate>
                    </div>
                  </div>
                  <div class="btn-select-template">
                    <a href="#" class="primary-btn preview" @click="previewResumeone">
                      <i class="material-icons">visibility</i> Preview
                    </a>

                    <a
                      class="TemplateBtn"
                      @click.prevent="Changetemplateprompt"
                      data-toggle="modal"
                      data-target="#ChnageTemplate"
                    >
                      <img src="../../assets/template.png" alt>
                      <span>
                        Change Template
                        <i class="material-icons">keyboard_arrow_down</i>
                      </span>
                    </a>
                  </div>
                </div>

                <!-- <div class="template-preview">
                    <img src="../../assets/view-resume.jpg" alt />
                    <img
                      class="shadow"
                      src="../../assets/transparent-black.png"
                      alt
                    />
                    <div class="btns">
                      <a
                        href="#"
                        class="primary-btn preview"
                        @click="previewResumeone"
                      >
                        <i class="material-icons">visibility</i> Preview
                      </a>

                      <select
                        v-model="template_name"
                        @change="showselectedcv"
                        class="form-control"
                      >
                        <option value="resume1.png">Template 1</option>
                        <option value="resume2.png">Template 2</option>
                        <option value="resume3.png">Template 3</option>
                        <option value="resume4.png">Template 4</option>
                      </select>
                    </div>
                </div>-->
              </div>
            </div>
          </div>

          <div class="btn-sec">
            <a @click="back(currentstep)" class="btn-secondary md-ink-ripple">Back</a>
            <a
              href="javascript:void(0);"
              @click="nextstep(currentstep)"
              class="btn-primary md-ink-ripple"
            >Next : Experience</a>
          </div>
        </div>
      </div>
      <div v-if="opencarousel" class="choose-template-sec">
        <span @click.prevent="opencarousel=false" class="material-icons popupclose">close</span>
        <carousel :items="5" v-if="opencarousel">
          <div
            @click.prevent="Handlecarousel(item)"
            v-for="(item, index) in cvTemplates"
            :key="index"
          >
            <img :src="item.img" :alt="item.name">
          </div>
        </carousel>
      </div>

      <!-- Optional JavaScript -->
      <!-- jQuery first, then Popper.js, then Bootstrap JS -->
    </body>
  </div>
  <div v-if="currentstep == 2">
    <body class="builder-page">
      <div class="top-header">
        <div class="top-left">
          <div class="logo">
            <a href="/Dashboard">
              <img src="../../assets/CC-Logo-White.svg" alt>
            </a>
          </div>
        </div>
        <div class="top-right">
          <a class="menu-toggle" href="#">
            <i class="material-icons">menu</i>
          </a>
        </div>
      </div>
      <div class="resume-builder-main">
        <div class="resume-builder-left">
          <!--<div class="logo">
                <a href="#"><img src="images/builder/CC-Logo-White.svg" alt="" /></a>
          </div>-->
          <div class="resume-section">
            <h3>Resume Sections</h3>
            <div class="logo">
              <a href="/Dashboard">
                <img src="/img/CC-Logo-White.1144d714.svg" alt>
              </a>
            </div>
            <ul>
              <li class="active">
                <a @click.prevent="Jumptoheading" href>
                  <span>1</span> Heading
                </a>
              </li>
              <li class="active">
                <a @click.prevent="Jumptowork" href>
                  <span>2</span> Experience
                </a>
              </li>
              <li>
                <a @click.prevent="Jumptoeducation" href>
                  <span>3</span> Education
                </a>
              </li>
              <li>
                <a @click.prevent="Jumptoskill" href>
                  <span>4</span> Skills
                </a>
              </li>
              <li>
                <a @click.prevent="Jumptosummary" href>
                  <span>5</span>Summary
                </a>
              </li>
              <li>
                <a @click.prevent="Jumptooptional" href>
                  <span>6</span> Others
                </a>
              </li>
              <li>
                <a @click.prevent="Jumptofinal" href>
                  <span>7</span> Finalize
                </a>
              </li>
            </ul>
          </div>
          <div class="resume-btn-sec">
            <!-- <a href="#" class="download-btn"><i class="material-icons">download</i> Download</a> -->
          </div>
        </div>

        <div class="resume-builder-right">
          <!--<div class="top">
                <a class="menu-toggle" href="#"><i class="material-icons">menu</i></a>
          </div>-->
          <div class="content">
            <h3>Tell us about your most recent job</h3>
            <p>We'll start there and work backward</p>
            <div class="form-section">
              <div class="left-form">
                <div class="row">
                  <div class="col-xl-6">
                    <div class="form-group">
                      <label>Job Title</label>
                      <div>
                        <!-- <input
                          v-model="filterName"
                          placeholder="Search..."
                          @input="GetJobTitle(filterName)"
                          class="form-control"
                        >
                        <select v-model="Job_Title" class="form-control">
                          <option
                            v-for="option in jobtitlelist"
                            :key="option"
                            :value="option"
                          >{{ option }}</option>
                        </select>-->
                        <multiselect
                          v-model="Job_Title"
                          :taggable="true"
                          @tag="onTagtitle($event)"
                          :options="jobtitlelist"
                          :multiple="false"
                        ></multiselect>
                      </div>
                    </div>
                  </div>
                  <div class="col-xl-6">
                    <div class="form-group">
                      <label>Employer</label>
                      <input
                        class="form-control"
                        v-model="Employer"
                        v-on:keypress="validateKeyPress(event)"
                        @input="showselectedcv()"
                        type="text"
                        name
                        placeholder="e.g. H & M"
                      >
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-xl-6">
                    <div class="form-group">
                      <label>City</label>
                      <!-- <input
                        class="form-control"
                        type="text"
                        v-model="Work_City"
                        name
                        placeholder="Jaipur"
                      >-->
                      <v-autocomplete
                        ref="geoLocation_autocomplete"
                        placeholder="City"
                        id="citywork"
                        name="location name"
                        data-vv-delay="300"
                        :auto-select-one-item="false"
                        :items="customers"
                        v-model="customer"
                        :get-label="getLabel"
                        :component-item="template"
                        @update-items="updateItems"
                        @item-selected="location_selected"
                      ></v-autocomplete>
                    </div>
                  </div>
                  <div class="col-xl-6">
                    <div class="form-group">
                      <label>Country</label>
                      <input
                        class="form-control"
                        type="text"
                        v-on:keypress="validateKeyPress(event)"
                        v-model="Work_Country"
                        @input="showselectedcv()"
                        name
                        placeholder="India"
                      >
                    </div>
                  </div>
                </div>
                <!-- <div class="row">
                  <div class="col-xl-6">
                    <div class="form-group">
                      <label>Start Date</label>
                      <input class="form-control" type="text" name placeholder="e.g. 08/08/2023">
                    </div>
                  </div>
                  <div class="col-xl-6">
                    <div class="form-group">
                      <label>End Date</label>
                      <input class="form-control" type="text" name placeholder="e.g. 08/08/2023">
                    </div>
                  </div>
                </div>-->
                <div v-if="mmyyyy" class="row">
                  <div>
                    <div class="form-group datepickerhold flatpickr" id="div_from_date_id">
                      <label>Start Date</label>
                      <input
                        id="start_date_id"
                        v-model="Start_Date"
                        class="form-control start_date"
                        data-input
                        tabindex="0"
                        type="text"
                        autocomplete="off"
                      >
                      <span class="date-field-in"></span>
                      <span
                        style="
                            color: red;
                            margin-top: 0px;
                            margin-bottom: 7px;
                            display: block;
                          "
                      >{{ start_date_message }}</span>
                    </div>
                  </div>
                  <div>
                    <div
                      class="form-group datepickerhold flatpickr"
                      v-bind:class="{ 'global-disabled': currentwork }"
                      id="div_end_date_id"
                    >
                      <label>End Date</label>
                      <input
                        id="end_date_id"
                        v-model="End_Date"
                        class="form-control start_date"
                        data-input
                        tabindex="0"
                        type="text"
                        autocomplete="off"
                      >

                      <span class="date-field-in"></span>
                      <span
                        style="
                            color: red;
                            margin-top: 0px;
                            margin-bottom: 7px;
                            display: block;
                          "
                      >{{ end_date_message }}</span>
                    </div>
                  </div>
                </div>
                <div v-else class="row">
                  <div>
                    <div class="form-group datepickerhold flatpickr" id="div_from_date_id">
                      <label>Start Date</label>
                      <input
                        id="start_date_id"
                        v-model="Start_Date"
                        class="form-control start_date"
                        data-input
                        tabindex="0"
                        type="text"
                        autocomplete="off"
                      >
                      <span class="date-field-in"></span>
                      <span
                        style="
                            color: red;
                            margin-top: 0px;
                            margin-bottom: 7px;
                            display: block;
                          "
                      >{{ start_date_message }}</span>
                    </div>
                  </div>
                  <div>
                    <div
                      class="form-group datepickerhold flatpickr"
                      v-bind:class="{ 'global-disabled': currentwork }"
                      id="div_end_date_id"
                    >
                      <label>End Date</label>
                      <input
                        id="end_date_id"
                        v-model="End_Date"
                        class="form-control start_date"
                        data-input
                        tabindex="0"
                        type="text"
                        autocomplete="off"
                      >

                      <span class="date-field-in"></span>
                      <span
                        style="
                            color: red;
                            margin-top: 0px;
                            margin-bottom: 7px;
                            display: block;
                          "
                      >{{ end_date_message }}</span>
                    </div>
                  </div>
                </div>
                <div class="form-check">
                  <label class="form-check-label">
                    <input type="checkbox" class="form-check-input" v-model="mmyyyy">
                    Date in MM/YYYY
                  </label>
                </div>
                <div class="form-check">
                  <label class="form-check-label">
                    <input type="checkbox" class="form-check-input" v-model="currentwork">
                    I currently work here
                  </label>
                </div>
              </div>
              <div class="right-form">
                <div class="template-preview">
                  <div class="resume-template">
                    <div v-if="showResume">
                      <resumeonetemplate
                        ref="resumeone"
                        :parentObj="this"
                        :from="cvfrom"
                        :resume="resumeobj"
                      ></resumeonetemplate>
                    </div>
                    <div v-if="showResumetwo">
                      <resumetwotemplate
                        ref="resumetwo"
                        :parentObj="this"
                        :from="cvfrom"
                        :resume="resumeobj"
                      ></resumetwotemplate>
                    </div>
                    <div v-if="showResumethree">
                      <resumethreetemplate
                        ref="resumethree"
                        :parentObj="this"
                        :from="cvfrom"
                        :resume="resumeobj"
                      ></resumethreetemplate>
                    </div>
                    <div v-if="showResumefour">
                      <resumefourtemplate
                        ref="resumefour"
                        :parentObj="this"
                        :from="cvfrom"
                        :resume="resumeobj"
                      ></resumefourtemplate>
                    </div>
                    <div v-if="showResumefive">
                      <resumefivetemplate
                        ref="resumefive"
                        :parentObj="this"
                        :from="cvfrom"
                        :resume="resumeobj"
                      ></resumefivetemplate>
                    </div>
                    <div v-if="showResumesix">
                      <resumesixtemplate
                        ref="resumesix"
                        :parentObj="this"
                        :from="cvfrom"
                        :resume="resumeobj"
                      ></resumesixtemplate>
                    </div>
                    <div v-if="showResumeseven">
                      <resumeseventemplate
                        ref="resumeseven"
                        :parentObj="this"
                        :from="cvfrom"
                        :resume="resumeobj"
                      ></resumeseventemplate>
                    </div>
                    <div v-if="showResumeeight">
                      <resumeeighttemplate
                        ref="resumeeight"
                        :parentObj="this"
                        :from="cvfrom"
                        :resume="resumeobj"
                      ></resumeeighttemplate>
                    </div>
                    <div v-if="showResumenine">
                      <resumeninetemplate
                        ref="resumenine"
                        :parentObj="this"
                        :from="cvfrom"
                        :resume="resumeobj"
                      ></resumeninetemplate>
                    </div>
                    <div v-if="showResumetwelve">
                      <resumetwelvetemplate
                        ref="resumetwelve"
                        :parentObj="this"
                        :from="cvfrom"
                        :resume="resumeobj"
                      ></resumetwelvetemplate>
                    </div>
                  </div>
                  <div class="btn-select-template">
                    <a href="#" class="primary-btn preview" @click="previewResumeone">
                      <i class="material-icons">visibility</i> Preview
                    </a>

                    <a
                      @click.prevent="Changetemplateprompt"
                      data-toggle="modal"
                      data-target="#ChnageTemplate"
                      class="TemplateBtn"
                    >
                      <img src="../../assets/template.png" alt>
                      <span>
                        Change Template
                        <i class="material-icons">keyboard_arrow_down</i>
                      </span>
                    </a>
                  </div>
                </div>
                <!-- <div class="template-preview">
                    <img src="../../assets/view-resume.jpg" alt />
                    <img
                      class="shadow"
                      src="../../assets/transparent-black.png"
                      alt
                    />
                    <div class="btns">
                      <a class="primary-btn preview" @click="previewResumeone">
                        <i class="material-icons">visibility</i> Preview
                      </a>
                      <select
                        v-model="template_name"
                        @change="showselectedcv"
                        class="form-control"
                      >
                        <option value="resume1.png">Template 1</option>
                        <option value="resume2.png">Template 2</option>
                        <option value="resume3.png">Template 3</option>
                        <option value="resume4.png">Template 4</option>
                      </select>
                    </div>
                </div>-->
              </div>
            </div>
          </div>

          <div class="btn-sec">
            <a @click="back(currentstep)" class="btn-secondary md-ink-ripple">Back</a>
            <a @click="nextstep(currentstep)" class="btn-primary md-ink-ripple">Save & Continue</a>
          </div>
        </div>
      </div>
    </body>
    <div v-if="opencarousel" class="choose-template-sec">
      <span @click.prevent="opencarousel=false" class="material-icons popupclose">close</span>
      <carousel :items="5" v-if="opencarousel">
        <div
          @click.prevent="Handlecarousel(item)"
          v-for="(item, index) in cvTemplates"
          :key="index"
        >
          <img :src="item.img" :alt="item.name">
        </div>
      </carousel>
    </div>
  </div>
  <div v-if="currentstep == 3">
    <body class="builder-page">
      <div class="top-header">
        <div class="top-left">
          <div class="logo">
            <a href="/Dashboard">
              <img src="../../assets/CC-Logo-White.svg" alt>
            </a>
          </div>
        </div>
        <div class="top-right">
          <a class="menu-toggle" href="#">
            <i class="material-icons">menu</i>
          </a>
        </div>
      </div>
      <div class="resume-builder-main">
        <div class="resume-builder-left">
          <!--<div class="logo">
                <a href="#"><img src="images/builder/CC-Logo-White.svg" alt="" /></a>
          </div>-->
          <div class="resume-section">
            <h3>Resume Sections</h3>
            <div class="logo">
              <a href="/Dashboard">
                <img src="/img/CC-Logo-White.1144d714.svg" alt>
              </a>
            </div>
            <ul>
              <li class="active">
                <a @click.prevent="Jumptoheading" href>
                  <span>1</span> Heading
                </a>
              </li>
              <li class="active">
                <a @click.prevent="Jumptowork" href>
                  <span>2</span> Experience
                </a>
              </li>
              <li>
                <a @click.prevent="Jumptoeducation" href>
                  <span>3</span> Education
                </a>
              </li>
              <li>
                <a @click.prevent="Jumptoskill" href>
                  <span>4</span> Skills
                </a>
              </li>
              <li>
                <a @click.prevent="Jumptosummary" href>
                  <span>5</span>Summary
                </a>
              </li>
              <li>
                <a @click.prevent="Jumptooptional" href>
                  <span>6</span> Others
                </a>
              </li>
              <li>
                <a @click.prevent="Jumptofinal" href>
                  <span>7</span> Finalize
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div class="resume-builder-right">
          <!--<div class="top">
                <a class="menu-toggle" href="#"><i class="material-icons">menu</i></a>
          </div>-->
          <div class="content skills-page">
            <div class="content-top-inner">
              <h3>Work Description</h3>
              <ul>
                <li>
                  <a @click="previewResumeone">
                    <img src="../../assets/preview-orange.png" alt> Preview
                  </a>
                </li>
                <li>
                  <a href="#">
                    <img src="../../assets/tips.png" alt> Tips
                  </a>
                </li>
              </ul>
            </div>

            <div class="form-section">
              <div class="left-form">
                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <label>Job title</label>
                      <div class="search">
                        <!-- <input class="form-control" type="text" name="" placeholder="Job Title" />
                        <button class="search-btn"><img src="../../assets/search-white.png" alt="" /></button>-->
                        <multiselect
                          v-model="filterName"
                          :options="jobtitlelist"
                          :taggable="true"
                          @tag="onTagtitle($event)"
                          :multiple="false"
                        ></multiselect>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-xl-5">
                    <div class="popular-search">
                      <h6>
                        <img src="../../assets/search.png" alt> Popular
                        Search
                      </h6>
                      <ul>
                        <li>
                          <a href="#">{{ filterName }}</a>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div class="col-xl-7">
                    <div class="ready-use-example">
                      <h6>Ready-to-use-examples</h6>
                      <div class="ready-use-scroll">
                        <div v-for="(data, index) in WorkDesc" class="box">
                          <div>
                            <i class="material-icons">star</i>
                            <div>
                              <p>Recommended</p>
                              <p>{{ data }}</p>
                            </div>
                          </div>
                          <a @click="addworkdesc(data)">
                            <i v-if="!description.includes(data)" class="fa fa-plus"></i>
                            <i v-if="description.includes(data)" class="fa fa-minus"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="right-form">
                <div >
                  <h5 class="ckeditor-heading" v-if="description!=''">Work description Added</h5>
                  <div class="box">
                    <ckeditor :editor="editor" v-model="description"></ckeditor>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="btn-sec">
            <a @click="back(currentstep)" class="btn-secondary md-ink-ripple">Back</a>
            <a
              href="#"
              @click="nextstep(currentstep)"
              class="btn-primary md-ink-ripple"
            >Save & Continue</a>
          </div>
        </div>
      </div>
    </body>
  </div>
  <div v-if="currentstep == 4">
    <div class="builder-page">
      <div class="top-header">
        <div class="top-left">
          <div class="logo">
            <a href="/Dashboard">
              <img src="../../assets/CC-Logo-White.svg" alt>
            </a>
          </div>
        </div>
        <div class="top-right">
          <a class="menu-toggle" href="#">
            <i class="material-icons">menu</i>
          </a>
        </div>
      </div>
      <div class="resume-builder-main">
        <div class="resume-builder-left">
          <div class="resume-section">
            <h3>Resume Sections</h3>
            <div class="logo">
              <a href="/Dashboard">
                <img src="/img/CC-Logo-White.1144d714.svg" alt>
              </a>
            </div>
            <ul>
              <li class="active aos-init aos-animate" data-aos="fade-up" data-aos-duration="200">
                <a @click.prevent="Jumptoheading" href>
                  <span>1</span> Heading
                </a>
              </li>
              <li class="active aos-init aos-animate" data-aos="fade-up" data-aos-duration="400">
                <a @click.prevent="Jumptowork" href>
                  <span>2</span> Experience
                </a>
              </li>
              <li class="aos-init" data-aos="fade-up" data-aos-duration="600">
                <a @click.prevent="Jumptoeducation" href>
                  <span>3</span> Education
                </a>
              </li>
              <li class="aos-init" data-aos="fade-up" data-aos-duration="800">
                <a @click.prevent="Jumptoskill" href>
                  <span>4</span> Skills
                </a>
              </li>
              <li data-aos="fade-up" data-aos-duration="1000" class="aos-init">
                <a @click.prevent="Jumptosummary" href>
                  <span>5</span>Summary
                </a>
              </li>
              <li data-aos="fade-up" data-aos-duration="1200" class="aos-init">
                <a @click.prevent="Jumptooptional" href>
                  <span>6</span> Others
                </a>
              </li>
              <li data-aos="fade-up" data-aos-duration="1200" class="aos-init">
                <a @click.prevent="Jumptofinal" href>
                  <span>7</span> Finalize
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div class="resume-builder-right">
          <div class="content">
            <h3>Work Experience</h3>

            <div class="form-section">
              <div class="left-form">
                <div v-for="(item, index) in work" class="details-fill-box">
                  <div class="fill-box-button">
                    <a data-toggle="tooltip" data-placement="top" title="Edit" class="edit-icon" @click="editworkv1(item.id, item)">
                      <i class="material-icons">edit</i>
                    </a>

                    <a data-toggle="tooltip" data-placement="top" title="Delete" class="delete-icon" @click="removeWork(index)">
                      <i class="material-icons">delete</i>
                    </a>
                  </div>
                  <div>
                    <strong>Job Title:</strong>
                    {{ item.jobtitle }}
                  </div>
                  <div>
                    <strong>Employer:</strong>
                    {{ item.employer }}
                  </div>
                  <div>
                    <strong>Start Date:</strong>
                    {{ item.startdate }}
                  </div>
                  <div>
                    <strong>End Date:</strong>
                    {{ item.enddate }}
                  </div>
                  <div>
                    <strong>Description:</strong>
                    <div v-html="item.description"></div>
                  </div>
                  <div>
                    <strong>City:</strong>
                    {{ item.city }}
                  </div>
                  <div>
                    <strong>Country:</strong>
                    {{ item.country }}
                  </div>
                  <div>
                    <hr>
                  </div>
                </div>

                <div class="resume-btn-sec">
                  <a class="btn-primary md-ink-ripple" @click="Addnew">
                    <i class="fa fa-plus"></i> Add New Work Experience
                  </a>
                  <a
                    v-if="work.length>0"
                    class="btn-primary md-ink-ripple"
                    @click="ReverseWork"
                  >Reverse</a>
                </div>
              </div>
              <div class="right-form"></div>
            </div>
          </div>
          <div class="btn-sec">
            <a @click="back(currentstep)" class="btn-secondary md-ink-ripple">Back</a>
            <a @click="nextstep(currentstep)" class="btn-primary md-ink-ripple">Next : Education</a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-if="currentstep == 5">
    <body class="builder-page">
      <div class="top-header">
        <div class="top-left">
          <div class="logo">
            <a href="/Dashboard">
              <img src="../../assets/CC-Logo-White.svg" alt>
            </a>
          </div>
        </div>
        <div class="top-right">
          <a class="menu-toggle" href="#">
            <i class="material-icons">menu</i>
          </a>
        </div>
      </div>
      <div class="resume-builder-main">
        <div class="resume-builder-left">
          <!--<div class="logo">
                <a href="#"><img src="images/builder/CC-Logo-White.svg" alt="" /></a>
          </div>-->
          <div class="resume-section">
            <h3>Resume Sections</h3>
            <div class="logo">
              <a href="/Dashboard">
                <img src="/img/CC-Logo-White.1144d714.svg" alt>
              </a>
            </div>
            <ul>
              <li class="active">
                <a @click.prevent="Jumptoheading" href>
                  <span>1</span> Heading
                </a>
              </li>
              <li class="active">
                <a @click.prevent="Jumptowork" href>
                  <span>2</span> Experience
                </a>
              </li>
              <li class="active">
                <a @click.prevent="Jumptoeducation" href>
                  <span>3</span> Education
                </a>
              </li>
              <li>
                <a @click.prevent="Jumptoskill" href>
                  <span>4</span> Skills
                </a>
              </li>
              <li>
                <a @click.prevent="Jumptosummary" href>
                  <span>5</span> Summary
                </a>
              </li>
              <li>
                <a @click.prevent="Jumptooptional" href>
                  <span>6</span> Others
                </a>
              </li>
              <li>
                <a @click.prevent="Jumptofinal" href>
                  <span>7</span> Finalize
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div class="resume-builder-right">
          <!--<div class="top">
                <a class="menu-toggle" href="#"><i class="material-icons">menu</i></a>
          </div>-->
          <div class="content">
            <h3>Tell us about your Education</h3>
            <p>
              Include every school, even if you're still there on didn't
              graduate.
            </p>
            <div class="form-section">
              <div class="left-form">
                <div class="row">
                  <div class="col-xl-6">
                    <div class="form-group">
                      <label>School Name</label>
                      <input
                        class="form-control"
                        type="text"
                        name
                        v-on:keypress="validateKeyPress(event)"
                        v-model="School_name"
                        @input="showselectedcv()"
                        placeholder="e.g. Oxford Software Institute"
                      >
                    </div>
                  </div>
                  <div class="col-xl-6">
                    <div class="form-group">
                      <label>School Location</label>
                      <!-- <input
                        class="form-control"
                        type="text"
                        v-model="School_loc"
                        v-on:keypress="validateKeyPress(event)"
                        name
                        placeholder="e.g. New Delhi, India"
                      >-->
                      <v-autocomplete
                        ref="geoLocationEd_autocomplete"
                        placeholder="City"
                        name="location name"
                        data-vv-delay="300"
                        :auto-select-one-item="false"
                        :items="customers"
                        v-model="customer_ed"
                        :get-label="getLabel"
                        :component-item="template"
                        @update-items="updateItems"
                        @item-selected="location_ED_selected"
                      ></v-autocomplete>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-xl-6">
                    <div class="form-group">
                      <label>Degree</label>
                      <input
                        class="form-control"
                        type="text"
                        v-model="School_degree"
                        v-on:keypress="validateKeyPress(event)"
                        @input="showselectedcv()"
                        name
                        placeholder="e.g. BCA"
                      >
                    </div>
                  </div>
                  <div class="col-xl-6">
                    <div class="form-group">
                      <label>Field of Study</label>
                      <input
                        class="form-control"
                        v-model="Field_study"
                        v-on:keypress="validateKeyPress(event)"
                        @input="showselectedcv()"
                        type="text"
                        name
                        placeholder="e.g. Financial Accounting"
                      >
                    </div>
                  </div>
                </div>
                <div v-if="grad_mmyyyy" class="row">
                  <div>
                    <div class="form-group datepickerhold flatpickr" id="div_gradfrom_date_id">
                      <label>Start Date</label>
                      <input
                        id="gradstart_date_id"
                        v-model="Grad_startdate"
                        class="form-control start_date"
                        data-input
                        tabindex="0"
                        type="text"
                        autocomplete="off"
                      >
                      <span class="date-field-in"></span>
                      <span
                        style="
                            color: red;
                            margin-top: 0px;
                            margin-bottom: 7px;
                            display: block;
                          "
                      >{{ start_date_message }}</span>
                    </div>
                  </div>
                  <div>
                    <div
                      class="form-group datepickerhold flatpickr"
                      v-bind:class="{ 'global-disabled': currentstudy }"
                      id="div_gradend_date_id"
                    >
                      <label>End Date</label>
                      <input
                        id="gradend_date_id"
                        v-model="Grad_Enddate"
                        class="form-control start_date"
                        data-input
                        tabindex="0"
                        type="text"
                        autocomplete="off"
                      >
                      <span class="date-field-in"></span>
                      <span
                        style="
                            color: red;
                            margin-top: 0px;
                            margin-bottom: 7px;
                            display: block;
                          "
                      >{{ end_date_message }}</span>
                    </div>
                  </div>
                </div>
                <div v-else class="row">
                  <div>
                    <div class="form-group datepickerhold flatpickr" id="div_gradfrom_date_id">
                      <label>Start Date</label>
                      <input
                        id="gradstart_date_id"
                        v-model="Grad_startdate"
                        class="form-control start_date"
                        data-input
                        tabindex="0"
                        type="text"
                        autocomplete="off"
                      >
                      <span class="date-field-in"></span>
                      <span
                        style="
                            color: red;
                            margin-top: 0px;
                            margin-bottom: 7px;
                            display: block;
                          "
                      >{{ start_date_message }}</span>
                    </div>
                  </div>
                  <div>
                    <div
                      class="form-group datepickerhold flatpickr"
                      v-bind:class="{ 'global-disabled': currentstudy }"
                      id="div_gradend_date_id"
                    >
                      <label>End Date</label>
                      <input
                        id="gradend_date_id"
                        v-model="Grad_Enddate"
                        class="form-control start_date"
                        data-input
                        tabindex="0"
                        type="text"
                        autocomplete="off"
                      >
                      <span class="date-field-in"></span>
                      <span
                        style="
                            color: red;
                            margin-top: 0px;
                            margin-bottom: 7px;
                            display: block;
                          "
                      >{{ end_date_message }}</span>
                    </div>
                  </div>
                </div>
                <div class="form-check">
                  <label class="form-check-label">
                    <input type="checkbox" class="form-check-input" v-model="grad_mmyyyy">
                    Date in MM/YYYY
                  </label>
                </div>
                <div class="form-check">
                  <label class="form-check-label">
                    <input type="checkbox" class="form-check-input" v-model="currentstudy">
                    I currently attend here
                  </label>
                </div>
                <div class="row">
                  <div class="col-xl-6"></div>
                  <div class="col-xl-6">
                    <div>
                      <a @click="AddEddesc" class="add-social-links add">
                        <span v-if="isEddesc">
                          <i class="material-icons">add</i> Add a description
                          to this section
                        </span>
                        <span v-if="!isEddesc">
                          <i class="material-icons">remove</i> Add a
                          description to this section
                        </span>
                      </a>
                    </div>
                  </div>
                </div>
                <div v-if="!isEddesc" class="input-container" style="display: block">
                  <div>
                    <div class="job-description-container mb-4 mt-2">
                      <label for="descriptionDropdown">Add description:</label>
                      <select
                        class="form-control"
                        id="descriptionDropdown"
                        @change="addeddescs"
                        v-model="Schooldesc"
                      >
                        <option disabled selected>Select a description</option>
                        <option value="Awarded [Award Name]">Awarded [Award Name]</option>
                        <option
                          value="Elected to [Elected Position] for [Student Organization, Fraternity or Sorority] in [Year]"
                        >Elected to [Elected Position] for [Student Organization, Fraternity or Sorority] in [Year]</option>
                        <option value="Completed professional development in [Subject]">
                          Completed professional development
                          in [Subject]
                        </option>
                        <option
                          value="Member of [Fraternity or Sorority Name]"
                        >Member of [Fraternity or Sorority Name]</option>
                        <option
                          value="Continuing education in [Subject]"
                        >Continuing education in [Subject]</option>
                        <option value="Member of [Student Organization or Club Name]">
                          Member of [Student Organization or
                          Club Name]
                        </option>
                        <option value="Received [Scholarship Name]">Received [Scholarship Name]</option>
                        <option value="Professional development completed in [Subject]">
                          Professional development completed
                          in [Subject]
                        </option>
                        <option
                          value="Dean List [Semester and Year]"
                        >Dean's List [Semester and Year]</option>
                        <option
                          value="Member of [Honors Society Name]"
                        >Member of [Honor's Society Name]</option>
                        <option value="Elected Captain of [Team]">Elected Captain of [Team]</option>
                      </select>
                    </div>
                  </div>
                  <div>
                    <div class="editor-container">
                      <ckeditor :editor="editor" v-model="School_desc"></ckeditor>
                    </div>
                  </div>
                </div>
              </div>
              <div class="right-form">
                <!-- <div class="template-preview">
                    <img src="../../assets/view-resume.jpg" alt />
                    <img
                      class="shadow"
                      src="../../assets/transparent-black.png"
                      alt
                    />

                    <div class="btns">
                      <a @click="previewResumeone" class="primary-btn preview">
                        <i class="material-icons">visibility</i> Preview
                      </a>
                      <select
                        v-model="template_name"
                        @change="showselectedcv"
                        class="form-control"
                      >
                        <option value="resume1.png">Template 1</option>
                        <option value="resume2.png">Template 2</option>
                        <option value="resume3.png">Template 3</option>
                        <option value="resume4.png">Template 4</option>
                      </select>
                    </div>
                </div>-->
                <div class="template-preview">
                  <div class="resume-template">
                    <div v-if="showResume">
                      <resumeonetemplate
                        ref="resumeone"
                        :parentObj="this"
                        :from="cvfrom"
                        :resume="resumeobj"
                      ></resumeonetemplate>
                    </div>
                    <div v-if="showResumetwo">
                      <resumetwotemplate
                        ref="resumetwo"
                        :parentObj="this"
                        :from="cvfrom"
                        :resume="resumeobj"
                      ></resumetwotemplate>
                    </div>
                    <div v-if="showResumethree">
                      <resumethreetemplate
                        ref="resumethree"
                        :parentObj="this"
                        :from="cvfrom"
                        :resume="resumeobj"
                      ></resumethreetemplate>
                    </div>
                    <div v-if="showResumefour">
                      <resumefourtemplate
                        ref="resumefour"
                        :parentObj="this"
                        :from="cvfrom"
                        :resume="resumeobj"
                      ></resumefourtemplate>
                    </div>
                    <div v-if="showResumefive">
                      <resumefivetemplate
                        ref="resumefive"
                        :parentObj="this"
                        :from="cvfrom"
                        :resume="resumeobj"
                      ></resumefivetemplate>
                    </div>
                    <div v-if="showResumesix">
                      <resumesixtemplate
                        ref="resumesix"
                        :parentObj="this"
                        :from="cvfrom"
                        :resume="resumeobj"
                      ></resumesixtemplate>
                    </div>
                    <div v-if="showResumeseven">
                      <resumeseventemplate
                        ref="resumeseven"
                        :parentObj="this"
                        :from="cvfrom"
                        :resume="resumeobj"
                      ></resumeseventemplate>
                    </div>
                    <div v-if="showResumeeight">
                      <resumeeighttemplate
                        ref="resumeeight"
                        :parentObj="this"
                        :from="cvfrom"
                        :resume="resumeobj"
                      ></resumeeighttemplate>
                    </div>
                    <div v-if="showResumenine">
                      <resumeninetemplate
                        ref="resumenine"
                        :parentObj="this"
                        :from="cvfrom"
                        :resume="resumeobj"
                      ></resumeninetemplate>
                    </div>
                    <div v-if="showResumetwelve">
                      <resumetwelvetemplate
                        ref="resumetwelve"
                        :parentObj="this"
                        :from="cvfrom"
                        :resume="resumeobj"
                      ></resumetwelvetemplate>
                    </div>
                  </div>
                  <div class="btn-select-template">
                    <a href="#" class="primary-btn preview" @click="previewResumeone">
                      <i class="material-icons">visibility</i> Preview
                    </a>

                    <a
                      @click.prevent="Changetemplateprompt"
                      data-toggle="modal"
                      data-target="#ChnageTemplate"
                      class="TemplateBtn"
                    >
                      <img src="../../assets/template.png" alt>
                      <span>
                        Change Template
                        <i class="material-icons">keyboard_arrow_down</i>
                      </span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="btn-sec">
            <a @click="back(currentstep)" class="btn-secondary md-ink-ripple">Back</a>
            <a @click="nextstep(currentstep)" class="btn-primary md-ink-ripple">Save & Continue</a>
          </div>
        </div>
      </div>
    </body>
    <div v-if="opencarousel" class="choose-template-sec">
      <span @click.prevent="opencarousel=false" class="material-icons popupclose">close</span>
      <carousel :items="5" v-if="opencarousel">
        <div
          @click.prevent="Handlecarousel(item)"
          v-for="(item, index) in cvTemplates"
          :key="index"
        >
          <img :src="item.img" :alt="item.name">
        </div>
      </carousel>
    </div>
  </div>
  <div v-if="currentstep == 6">
    <div class="builder-page">
      <div class="top-header">
        <div class="top-left">
          <div class="logo">
            <a href="/Dashboard">
              <img src="../../assets/CC-Logo-White.svg" alt>
            </a>
          </div>
        </div>
        <div class="top-right">
          <a class="menu-toggle" href="#">
            <i class="material-icons">menu</i>
          </a>
        </div>
      </div>
      <div class="resume-builder-main">
        <div class="resume-builder-left">
          <div class="resume-section">
            <h3>Resume Sections</h3>
            <div class="logo">
              <a href="/Dashboard">
                <img src="/img/CC-Logo-White.1144d714.svg" alt>
              </a>
            </div>
            <ul>
              <li class="active aos-init aos-animate" data-aos="fade-up" data-aos-duration="200">
                <a @click.prevent="Jumptoheading" href>
                  <span>1</span> Heading
                </a>
              </li>
              <li class="active aos-init aos-animate" data-aos="fade-up" data-aos-duration="400">
                <a @click.prevent="Jumptowork" href>
                  <span>2</span> Experience
                </a>
              </li>
              <li class="active aos-init aos-animate" data-aos="fade-up" data-aos-duration="600">
                <a @click.prevent="Jumptoeducation" href>
                  <span>3</span> Education
                </a>
              </li>
              <li class="aos-init" data-aos="fade-up" data-aos-duration="800">
                <a @click.prevent="Jumptoskill" href>
                  <span>4</span> Skills
                </a>
              </li>
              <li data-aos="fade-up" data-aos-duration="1000" class="aos-init">
                <a @click.prevent="Jumptosummary" href>
                  <span>5</span>Summary
                </a>
              </li>
              <li data-aos="fade-up" data-aos-duration="1200" class="aos-init">
                <a @click.prevent="Jumptooptional" href>
                  <span>6</span> Others
                </a>
              </li>
              <li data-aos="fade-up" data-aos-duration="1200" class="aos-init">
                <a @click.prevent="Jumptofinal" href>
                  <span>7</span> Finalize
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div class="resume-builder-right">
          <div class="content">
            <h3>Tell us about your Education</h3>
            <p>
              Include every school, even if you're still there on didn't
              graduate.
            </p>
            <div class="form-section">
              <div class="left-form">
                <div v-for="(item, index) in Education" class="details-fill-box">
                  <div class="fill-box-button">
                    <a data-toggle="tooltip" data-placement="top" title="Edit" class="edit-icon" @click="editeducationv1(item.id, item)">
                      <i class="material-icons">edit</i>
                    </a>

                    <a data-toggle="tooltip" data-placement="top" title="Delete" class="delete-icon" @click="removeEducation(index)">
                      <i class="material-icons">delete</i>
                    </a>
                  </div>
                  <div>
                    <strong>Field of study:</strong>
                    {{ item.field }}
                  </div>

                  <div>
                    <strong>Degree:</strong>
                    {{ item.degree }}
                  </div>

                  <div>
                    <strong>Description:</strong>
                    <div v-html="item.description"></div>
                  </div>

                  <div>
                    <strong>School Name:</strong>
                    {{ item.school_name }}
                  </div>
                  <div>
                    <strong>School Location:</strong>
                    {{ item.school_location }}
                  </div>

                  <div>
                    <strong>Start Date:</strong>
                    {{ item.grad_startdate }}
                  </div>
                  <div>
                    <strong>End Date:</strong>
                    {{ item.grad_enddate }}
                  </div>
                  <hr>
                </div>

                <div class="resume-btn-sec">
                  <a class="btn-primary md-ink-ripple" @click="AddnewEd">
                    <i class="fa fa-plus"></i> Add New Education
                  </a>
                </div>
              </div>
              <div class="right-form"></div>
            </div>
          </div>
          <div class="btn-sec">
            <a @click="back(currentstep)" class="btn-secondary md-ink-ripple">Back</a>
            <a @click="nextstep(currentstep)" class="btn-primary md-ink-ripple">Next : Skills</a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-if="currentstep == 7">
    <body class="builder-page">
      <div class="top-header">
        <div class="top-left">
          <div class="logo">
            <a href="/Dashboard">
              <img src="../../assets/CC-Logo-White.svg" alt>
            </a>
          </div>
        </div>
        <div class="top-right">
          <a class="menu-toggle" href="#">
            <i class="material-icons">menu</i>
          </a>
        </div>
      </div>
      <div class="resume-builder-main">
        <div class="resume-builder-left">
          <!--<div class="logo">
                <a href="#"><img src="images/builder/CC-Logo-White.svg" alt="" /></a>
          </div>-->
          <div class="resume-section">
            <h3>Resume Sections</h3>
            <div class="logo">
              <a href="/Dashboard">
                <img src="/img/CC-Logo-White.1144d714.svg" alt>
              </a>
            </div>
            <ul>
              <li class="active">
                <a @click.prevent="Jumptoheading" href>
                  <span>1</span> Heading
                </a>
              </li>
              <li class="active">
                <a @click.prevent="Jumptowork" href>
                  <span>2</span> Experience
                </a>
              </li>
              <li class="active">
                <a @click.prevent="Jumptoeducation" href>
                  <span>3</span> Education
                </a>
              </li>
              <li class="active">
                <a @click.prevent="Jumptoskill" href>
                  <span>4</span> Skills
                </a>
              </li>
              <li>
                <a @click.prevent="Jumptosummary" href>
                  <span>5</span>Summary
                </a>
              </li>
              <li>
                <a @click.prevent="Jumptooptional" href>
                  <span>6</span> Others
                </a>
              </li>
              <li>
                <a @click.prevent="Jumptofinal" href>
                  <span>7</span> Finalize
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div class="resume-builder-right">
          <!--<div class="top">
                <a class="menu-toggle" href="#"><i class="material-icons">menu</i></a>
          </div>-->
          <div class="content skills-page">
            <div class="content-top-inner">
              <h3>Skills</h3>
              <ul>
                <li>
                  <a @click="previewResumeone">
                    <img src="../../assets/preview-orange.png" alt> Preview
                  </a>
                </li>
                <li>
                  <a href="#">
                    <img src="../../assets/tips.png" alt> Tips
                  </a>
                </li>
              </ul>
            </div>

            <div class="form-section">
              <div class="left-form">
                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <label>Job Title</label>
                      <div class="search">
                        <multiselect
                          v-model="filterName"
                          :taggable="true"
                          @tag="onTagtitle($event)"
                          :options="jobtitlelist"
                          :multiple="false"
                        ></multiselect>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-xl-5">
                    <div class="popular-search">
                      <h6>
                        <img src="../../assets/search.png" alt> Popular
                        Search
                      </h6>
                      <ul>
                        <li class="active">
                          <a href="#">{{ filterName }}</a>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div class="col-xl-7">
                    <div class="ready-use-example">
                      <h6>Ready-to-use-examples</h6>
                      <div class="ready-use-scroll">
                        <div v-for="data in Skill_list" class="box">
                          <div>
                            <i class="material-icons">star</i>
                            <div>
                              <p>Recommended</p>
                              <p>{{ data }}</p>
                            </div>
                          </div>
                          <a @click="Addskill(data)">
                            <i v-if="!skillrepeat(data)" class="fa fa-plus"></i>
                            <i v-if="skillrepeat(data)" class="fa fa-minus"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="right-form">
                <div class="skill-add-sec">
                  <h5 v-if="skill.length>0">Skills Added</h5>
                  <div v-for="(data, index) in skill" class="box">
                    <input
                      class="form-control"
                      type="text"
                      v-model="data.text"
                      @input="showselectedcv"
                      name
                      placeholder="e.g. Hobbies"
                    >
                    <div class="star-rating">
                      <span
                        v-for="rating in ratings"
                        :key="rating"
                        @click="setRating(rating,data)"
                        :class="{ 'selected': rating <= data.rate }"
                      >
                        &#9733;
                        <!-- Unicode star character -->
                      </span>
                    </div>
                    <a class="delete-icon" @click="removeskill(index)">
                      <i class="material-icons">delete</i>
                    </a>
                  </div>
                  <a
                    href="javascript:void(0);"
                    v-if="skill.length>0"
                    class="btn-primary md-ink-ripple mt-3"
                    @click="addmoreskill()"
                  >
                    <i class="fa fa-plus"></i> Add more
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div class="btn-sec">
            <a @click="back(currentstep)" class="btn-secondary md-ink-ripple">Back</a>
            <a @click="nextstep(currentstep)" class="btn-primary md-ink-ripple">Next : Summary</a>
          </div>
        </div>
      </div>
    </body>
  </div>
  <div v-if="currentstep == 8">
    <body class="builder-page">
      <div class="top-header">
        <div class="top-left">
          <div class="logo">
            <a href="/Dashboard">
              <img src="../../assets/CC-Logo-White.svg" alt>
            </a>
          </div>
        </div>
        <div class="top-right">
          <a class="menu-toggle" href="#">
            <i class="material-icons">menu</i>
          </a>
        </div>
      </div>
      <div class="resume-builder-main">
        <div class="resume-builder-left">
          <!--<div class="logo">
                <a href="#"><img src="images/builder/CC-Logo-White.svg" alt="" /></a>
          </div>-->
          <div class="resume-section">
            <h3>Resume Sections</h3>
            <div class="logo">
              <a href="/Dashboard">
                <img src="/img/CC-Logo-White.1144d714.svg" alt>
              </a>
            </div>
            <ul>
              <li class="active">
                <a @click.prevent="Jumptoheading" href>
                  <span>1</span> Heading
                </a>
              </li>
              <li class="active">
                <a @click.prevent="Jumptowork" href>
                  <span>2</span> Experience
                </a>
              </li>
              <li class="active">
                <a @click.prevent="Jumptoeducation" href>
                  <span>3</span> Education
                </a>
              </li>
              <li class="active">
                <a @click.prevent="Jumptoskill" href>
                  <span>4</span> Skills
                </a>
              </li>
              <li class="active">
                <a @click.prevent="Jumptosummary" href>
                  <span>5</span>Summary
                </a>
              </li>
              <li>
                <a @click.prevent="Jumptooptional" href>
                  <span>6</span> Others
                </a>
              </li>
              <li>
                <a @click.prevent="Jumptofinal" href>
                  <span>7</span> Finalize
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div class="resume-builder-right">
          <!--<div class="top">
                <a class="menu-toggle" href="#"><i class="material-icons">menu</i></a>
          </div>-->
          <div class="content skills-page">
            <div class="content-top-inner">
              <h3>Summary</h3>
              <ul>
                <li>
                  <a @click="previewResumeone">
                    <img src="../../assets/preview-orange.png" alt> Preview
                  </a>
                </li>
                <li>
                  <a href="#">
                    <img src="../../assets/tips.png" alt> Tips
                  </a>
                </li>
              </ul>
            </div>

            <div class="form-section">
              <div class="left-form">
                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <label>Job Title</label>
                      <div class="search">
                        <multiselect
                          v-model="filterName"
                          :taggable="true"
                          @tag="onTagtitle($event)"
                          :options="jobtitlelist"
                          :multiple="false"
                        ></multiselect>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-xl-5">
                    <div class="popular-search">
                      <h6>
                        <img src="../../assets/search.png" alt> Popular
                        Search
                      </h6>
                      <ul>
                        <li class="active">
                          <a href="#">{{ filterName }}</a>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div class="col-xl-7">
                    <div class="ready-use-example">
                      <h6>Ready-to-use-examples</h6>
                      <div class="ready-use-scroll">
                        <div v-for="data in Summary_list" class="box">
                          <div>
                            <i class="material-icons">star</i>
                            <div>
                              <p>Recommended</p>
                              <p>{{ data }}</p>
                            </div>
                          </div>
                          <a @click="Addsummary(data)">
                            <i v-if="!summary.includes(data)" class="fa fa-plus"></i>
                            <i v-if="summary.includes(data)" class="fa fa-minus"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="right-form">
                <div>
                  <h5 class="ckeditor-heading" v-if="summary!=''">Summary Added</h5>
                  <div style="margin-top: 15px;" class="box">
                    <ckeditor :editor="editor" v-model="summary"></ckeditor>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="btn-sec">
            <a @click="back(currentstep)" class="btn-secondary md-ink-ripple">Back</a>
            <a @click="nextstep(currentstep)" class="btn-primary md-ink-ripple">Next : Others</a>
          </div>
        </div>
      </div>
    </body>
  </div>
  <div v-if="currentstep == 9">
    <body class="builder-page">
      <div class="top-header">
        <div class="top-left">
          <div class="logo">
            <a href="/Dashboard">
              <img src="../../assets/CC-Logo-White.svg" alt>
            </a>
          </div>
        </div>
        <div class="top-right">
          <a class="menu-toggle" href="#">
            <i class="material-icons">menu</i>
          </a>
        </div>
      </div>
      <div class="resume-builder-main">
        <div class="resume-builder-left">
          <!--<div class="logo">
                <a href="#"><img src="images/builder/CC-Logo-White.svg" alt="" /></a>
          </div>-->
          <div class="resume-section">
            <h3>Resume Sections</h3>
            <div class="logo">
              <a href="/Dashboard">
                <img src="/img/CC-Logo-White.1144d714.svg" alt>
              </a>
            </div>
            <ul>
              <li class="active" data-aos="fade-up" data-aos-duration="200">
                <a @click.prevent="Jumptoheading" href>
                  <span>1</span> Heading
                </a>
              </li>
              <li class="active" data-aos="fade-up" data-aos-duration="400">
                <a @click.prevent="Jumptowork" href>
                  <span>2</span> Experience
                </a>
              </li>
              <li class="active" data-aos="fade-up" data-aos-duration="600">
                <a @click.prevent="Jumptoeducation" href>
                  <span>3</span> Education
                </a>
              </li>
              <li class="active" data-aos="fade-up" data-aos-duration="800">
                <a @click.prevent="Jumptoskill" href>
                  <span>4</span> Skills
                </a>
              </li>
              <li class="active" data-aos="fade-up" data-aos-duration="1000">
                <a @click.prevent="Jumptosummary" href>
                  <span>5</span>Summary
                </a>
              </li>
              <li class="active" data-aos="fade-up" data-aos-duration="1200">
                <a @click.prevent="Jumptooptional" href>
                  <span>6</span> Others
                </a>
              </li>
              <li data-aos="fade-up" data-aos-duration="1200">
                <a @click.prevent="Jumptofinal" href>
                  <span>7</span> Finalize
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div class="resume-builder-right">
          <!--<div class="top">
                <a class="menu-toggle" href="#"><i class="material-icons">menu</i></a>
          </div>-->
          <div class="content" data-aos="fade-up" data-aos-duration="800">
            <p>These sections are optional.</p>
            <div class="form-section">
              <div class="left-form">
                <div class="row">
                  <div class="col-xl-6 checkbox-sec">
                    <div class="form-check">
                      <input type="checkbox" value id="flexCheckDefault" v-model="isaccomplishment">
                      <label for="flexCheckDefault">Accomplishments</label>
                    </div>
                    <div class="form-check">
                      <input type="checkbox" value id="flexCheckDefault" v-model="isaffilation">
                      <label for="flexCheckDefault">Affiliations</label>
                    </div>
                    <div class="form-check">
                      <input type="checkbox" value id="flexCheckDefault" v-model="isadditional">
                      <label for="flexCheckDefault">Additional Information</label>
                    </div>
                    <div class="form-check">
                      <input type="checkbox" value id="flexCheckDefault" v-model="issoftware">
                      <label for="flexCheckDefault">Software</label>
                    </div>
                    <div class="form-check">
                      <input type="checkbox" value id="flexCheckDefault" v-model="islang">
                      <label for="flexCheckDefault">Languages</label>
                    </div>
                    <div class="form-check">
                      <input type="checkbox" value id="flexCheckDefault" v-model="iscertificate">
                      <label for="flexCheckDefault">Certifications</label>
                    </div>
                    <div class="form-check">
                      <input type="checkbox" value id="flexCheckDefault" v-model="isintrest">
                      <label for="flexCheckDefault">Interests</label>
                    </div>
                    <div class="form-check">
                      <input type="checkbox" value v-model="isown">
                      <label>Add Your Own</label>
                    </div>
                  </div>
                  <div class="col-xl-6">
                    <div class="add-own-check"></div>
                    <div
                      v-if="isown"
                      class="form-group input-button-mines"
                      v-for="(data, index) in add_your_own_json"
                    >
                      <div>
                        <input
                          class="form-control"
                          type="text"
                          v-model="data.title"
                          @input="showselectedcv"
                          name
                          placeholder="e.g. Hobbies"
                        >
                      </div>
                      <a class="btn-primary md-ink-ripple" @click="removeyourown(index)">
                        <i class="fa fa-minus"></i>
                      </a>
                    </div>
                    <div class="btn-area-sec">
                      <a class="btn-primary md-ink-ripple" @click="Addyourown">
                        <i class="fa fa-plus"></i> Add
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div class="right-form">
                <!-- <div class="template-preview">
                    <img src="../../assets/view-resume.jpg" alt />
                    <img
                      class="shadow"
                      src="../../assets/transparent-black.png"
                      alt
                    />
                    <div class="btns">
                      <a
                        @click.prevent="previewResumeone"
                        class="primary-btn preview"
                      >
                        <i class="material-icons">visibility</i> Preview
                      </a>
                      <select
                        v-model="template_name"
                        @change="showselectedcv"
                        class="form-control"
                      >
                        <option value="resume1.png">Template 1</option>
                        <option value="resume2.png">Template 2</option>
                        <option value="resume3.png">Template 3</option>
                        <option value="resume4.png">Template 4</option>
                      </select>
                    </div>
                </div>-->
                <div class="template-preview">
                  <div class="resume-template">
                    <div v-if="showResume">
                      <resumeonetemplate
                        ref="resumeone"
                        :parentObj="this"
                        :from="cvfrom"
                        :resume="resumeobj"
                      ></resumeonetemplate>
                    </div>
                    <div v-if="showResumetwo">
                      <resumetwotemplate
                        ref="resumetwo"
                        :parentObj="this"
                        :from="cvfrom"
                        :resume="resumeobj"
                      ></resumetwotemplate>
                    </div>
                    <div v-if="showResumethree">
                      <resumethreetemplate
                        ref="resumethree"
                        :parentObj="this"
                        :from="cvfrom"
                        :resume="resumeobj"
                      ></resumethreetemplate>
                    </div>
                    <div v-if="showResumefour">
                      <resumefourtemplate
                        ref="resumefour"
                        :parentObj="this"
                        :from="cvfrom"
                        :resume="resumeobj"
                      ></resumefourtemplate>
                    </div>
                    <div v-if="showResumefive">
                      <resumefivetemplate
                        ref="resumefive"
                        :parentObj="this"
                        :from="cvfrom"
                        :resume="resumeobj"
                      ></resumefivetemplate>
                    </div>
                    <div v-if="showResumesix">
                      <resumesixtemplate
                        ref="resumesix"
                        :parentObj="this"
                        :from="cvfrom"
                        :resume="resumeobj"
                      ></resumesixtemplate>
                    </div>
                    <div v-if="showResumeseven">
                      <resumeseventemplate
                        ref="resumeseven"
                        :parentObj="this"
                        :from="cvfrom"
                        :resume="resumeobj"
                      ></resumeseventemplate>
                    </div>
                    <div v-if="showResumeeight">
                      <resumeeighttemplate
                        ref="resumeeight"
                        :parentObj="this"
                        :from="cvfrom"
                        :resume="resumeobj"
                      ></resumeeighttemplate>
                    </div>
                    <div v-if="showResumenine">
                      <resumeninetemplate
                        ref="resumenine"
                        :parentObj="this"
                        :from="cvfrom"
                        :resume="resumeobj"
                      ></resumeninetemplate>
                    </div>
                    <div v-if="showResumetwelve">
                      <resumetwelvetemplate
                        ref="resumetwelve"
                        :parentObj="this"
                        :from="cvfrom"
                        :resume="resumeobj"
                      ></resumetwelvetemplate>
                    </div>
                  </div>
                  <div class="btn-select-template">
                    <a href="#" class="primary-btn preview" @click="previewResumeone">
                      <i class="material-icons">visibility</i> Preview
                    </a>

                    <a
                      @click.prevent="Changetemplateprompt"
                      data-toggle="modal"
                      data-target="#ChnageTemplate"
                      class="TemplateBtn"
                    >
                      <img src="../../assets/template.png" alt>
                      <span>
                        Change Template
                        <i class="material-icons">keyboard_arrow_down</i>
                      </span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="btn-sec">
            <a @click="back(currentstep)" class="btn-secondary md-ink-ripple">Back</a>
            <a @click="nextstep(currentstep)" class="btn-primary md-ink-ripple">Save & Continue</a>
          </div>
        </div>
      </div>
    </body>
    <div v-if="opencarousel" class="choose-template-sec">
      <span @click.prevent="opencarousel=false" class="material-icons popupclose">close</span>
      <carousel :items="5" v-if="opencarousel">
        <div
          @click.prevent="Handlecarousel(item)"
          v-for="(item, index) in cvTemplates"
          :key="index"
        >
          <img :src="item.img" :alt="item.name">
        </div>
      </carousel>
    </div>
  </div>
  <div v-if="currentstep == 10">
    <body class="builder-page">
      <div class="top-header">
        <div class="top-left">
          <div class="logo">
            <a href="/Dashboard">
              <img src="../../assets/CC-Logo-White.svg" alt>
            </a>
          </div>
        </div>
        <div class="top-right">
          <a class="menu-toggle" href="#">
            <i class="material-icons">menu</i>
          </a>
        </div>
      </div>
      <div class="resume-builder-main">
        <div class="resume-builder-left">
          <!--<div class="logo">
                <a href="#"><img src="images/builder/CC-Logo-White.svg" alt="" /></a>
          </div>-->
          <div class="resume-section">
            <h3>Resume Sections</h3>
            <div class="logo">
              <a href="/Dashboard">
                <img src="/img/CC-Logo-White.1144d714.svg" alt>
              </a>
            </div>
            <ul>
              <li class="active">
                <a @click.prevent="Jumptoheading" href>
                  <span>1</span> Heading
                </a>
              </li>
              <li class="active">
                <a @click.prevent="Jumptowork" href>
                  <span>2</span> Experience
                </a>
              </li>
              <li class="active">
                <a @click.prevent="Jumptoeducation" href>
                  <span>3</span> Education
                </a>
              </li>
              <li class="active">
                <a @click.prevent="Jumptoskill" href>
                  <span>4</span> Skills
                </a>
              </li>
              <li class="active">
                <a @click.prevent="Jumptosummary" href>
                  <span>5</span>Summary
                </a>
              </li>
              <li class="active" data-aos="fade-up" data-aos-duration="1200">
                <a @click.prevent="Jumptooptional" href>
                  <span>6</span> Others
                </a>
              </li>
              <li>
                <a @click.prevent="Jumptofinal" href>
                  <span>7</span> Finalize
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div class="resume-builder-right">
          <!--<div class="top">
                <a class="menu-toggle" href="#"><i class="material-icons">menu</i></a>
          </div>-->
          <div class="content skills-page">
            <div class="content-top-inner">
              <h3>Accomplishments</h3>
              <ul>
                <li>
                  <a @click="previewResumeone">
                    <img src="../../assets/preview-orange.png" alt> Preview
                  </a>
                </li>
                <li>
                  <a href="#">
                    <img src="../../assets/tips.png" alt> Tips
                  </a>
                </li>
              </ul>
            </div>

            <div class="form-section">
              <div class="left-form">
                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <label>Job Title</label>
                      <div class="search">
                        <multiselect
                          v-model="filterName"
                          :taggable="true"
                          @tag="onTagtitle($event)"
                          :options="jobtitlelist"
                          :multiple="false"
                        ></multiselect>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-xl-5">
                    <div class="popular-search">
                      <h6>
                        <img src="../../assets/search.png" alt> Popular
                        Search
                      </h6>
                      <ul>
                        <li class="active">
                          <a href="#">{{ filterName }}</a>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div class="col-xl-7">
                    <div class="ready-use-example">
                      <h6>Ready-to-use-examples</h6>
                      <div class="ready-use-scroll">
                        <div v-for="data in acc_list" class="box">
                          <div>
                            <i class="material-icons">star</i>
                            <div>
                              <p>Recommended</p>
                              <p>{{ data }}</p>
                            </div>
                          </div>
                          <a @click="Addaccomplish(data)">
                            <i v-if="!accomplishments.includes(data)" class="fa fa-plus"></i>
                            <i v-if="accomplishments.includes(data)" class="fa fa-minus"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="right-form">
                <div class>
                  <h5 class="ckeditor-heading" v-if="accomplishments!=''">Accomplishments Added</h5>
                  <div class="box">
                    <ckeditor :editor="editor" v-model="accomplishments" ></ckeditor>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="btn-sec">
            <a @click="back(currentstep)" class="btn-secondary md-ink-ripple">Back</a>
            <a @click="nextstep(currentstep)" class="btn-primary md-ink-ripple">{{stepname}}</a>
          </div>
        </div>
      </div>
    </body>
  </div>
  <div v-if="currentstep == 11">
    <body class="builder-page">
      <div class="top-header">
        <div class="top-left">
          <div class="logo">
            <a href="/Dashboard">
              <img src="../../assets/CC-Logo-White.svg" alt>
            </a>
          </div>
        </div>
        <div class="top-right">
          <a class="menu-toggle" href="#">
            <i class="material-icons">menu</i>
          </a>
        </div>
      </div>
      <div class="resume-builder-main">
        <div class="resume-builder-left">
          <!--<div class="logo">
                <a href="#"><img src="images/builder/CC-Logo-White.svg" alt="" /></a>
          </div>-->
          <div class="resume-section">
            <h3>Resume Sections</h3>
            <div class="logo">
              <a href="/Dashboard">
                <img src="/img/CC-Logo-White.1144d714.svg" alt>
              </a>
            </div>
            <ul>
              <li class="active">
                <a @click.prevent="Jumptoheading" href>
                  <span>1</span> Heading
                </a>
              </li>
              <li class="active">
                <a @click.prevent="Jumptowork" href>
                  <span>2</span> Experience
                </a>
              </li>
              <li class="active">
                <a @click.prevent="Jumptoeducation" href>
                  <span>3</span> Education
                </a>
              </li>
              <li class="active">
                <a @click.prevent="Jumptoskill" href>
                  <span>4</span> Skills
                </a>
              </li>
              <li class="active">
                <a @click.prevent="Jumptosummary" href>
                  <span>5</span>Summary
                </a>
              </li>
              <li class="active" data-aos="fade-up" data-aos-duration="1200">
                <a @click.prevent="Jumptooptional" href>
                  <span>6</span> Others
                </a>
              </li>
              <li>
                <a @click.prevent="Jumptofinal" href>
                  <span>7</span> Finalize
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div class="resume-builder-right">
          <!--<div class="top">
                <a class="menu-toggle" href="#"><i class="material-icons">menu</i></a>
          </div>-->
          <div class="content skills-page">
            <div class="content-top-inner">
              <h3>Affiliations</h3>
              <ul>
                <li>
                  <a @click.prevent="previewResumeone">
                    <img src="../../assets/preview-orange.png" alt> Preview
                  </a>
                </li>
                <li>
                  <a href="#">
                    <img src="../../assets/tips.png" alt> Tips
                  </a>
                </li>
              </ul>
            </div>

            <div class="form-section">
              <div class="left-form">
                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <label>Job Title</label>
                      <div class="search">
                        <multiselect
                          v-model="filterName"
                          :taggable="true"
                          @tag="onTagtitle($event)"
                          :options="jobtitlelist"
                          :multiple="false"
                        ></multiselect>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-xl-5">
                    <div class="popular-search">
                      <h6>
                        <img src="../../assets/search.png" alt> Popular
                        Search
                      </h6>
                      <ul>
                        <li class="active">
                          <a href="#">{{ filterName }}</a>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div class="col-xl-7">
                    <div class="ready-use-example">
                      <h6>Ready-to-use-examples</h6>
                      <div class="ready-use-scroll">
                        <div v-for="data in aff_list" class="box">
                          <div>
                            <i class="material-icons">star</i>
                            <div>
                              <p>Recommended</p>
                              <p>{{ data }}</p>
                            </div>
                          </div>
                          <a @click="Addaffiliation(data)">
                            <i v-if="!affiliations.includes(data)" class="fa fa-plus"></i>
                            <i v-if="affiliations.includes(data)" class="fa fa-minus"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="right-form">
                <div>
                  <h5 class="ckeditor-heading" v-if="affiliations!=''">Affiliations Added</h5>
                  <div class="box">
                    <ckeditor v-model="affiliations" :editor="editor"></ckeditor>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="btn-sec">
            <a @click="back(currentstep)" class="btn-secondary md-ink-ripple">Back</a>
            <a @click="nextstep(currentstep)" class="btn-primary md-ink-ripple">{{stepname}}</a>
          </div>
        </div>
      </div>
    </body>
  </div>
  <div v-if="currentstep == 12">
    <body class="builder-page">
      <div class="top-header">
        <div class="top-left">
          <div class="logo">
            <a href="/Dashboard">
              <img src="../../assets/CC-Logo-White.svg" alt>
            </a>
          </div>
        </div>
        <div class="top-right">
          <a class="menu-toggle" href="#">
            <i class="material-icons">menu</i>
          </a>
        </div>
      </div>
      <div class="resume-builder-main">
        <div class="resume-builder-left">
          <!--<div class="logo">
                <a href="#"><img src="images/builder/CC-Logo-White.svg" alt="" /></a>
          </div>-->
          <div class="resume-section">
            <h3>Resume Sections</h3>
            <div class="logo">
              <a href="/Dashboard">
                <img src="/img/CC-Logo-White.1144d714.svg" alt>
              </a>
            </div>
            <ul>
              <li class="active">
                <a @click.prevent="Jumptoheading" href>
                  <span>1</span> Heading
                </a>
              </li>
              <li class="active">
                <a @click.prevent="Jumptowork" href>
                  <span>2</span> Experience
                </a>
              </li>
              <li class="active">
                <a @click.prevent="Jumptoeducation" href>
                  <span>3</span> Education
                </a>
              </li>
              <li class="active">
                <a @click.prevent="Jumptoskill" href>
                  <span>4</span> Skills
                </a>
              </li>
              <li class="active">
                <a @click.prevent="Jumptosummary" href>
                  <span>5</span>Summary
                </a>
              </li>
              <li class="active" data-aos="fade-up" data-aos-duration="1200">
                <a @click.prevent="Jumptooptional" href>
                  <span>6</span> Others
                </a>
              </li>
              <li>
                <a @click.prevent="Jumptofinal" href>
                  <span>7</span> Finalize
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div class="resume-builder-right">
          <!--<div class="top">
                <a class="menu-toggle" href="#"><i class="material-icons">menu</i></a>
          </div>-->
          <div class="content skills-page">
            <div class="content-top-inner">
              <h3>Additional information</h3>
              <ul>
                <li>
                  <a @click="previewResumeone">
                    <img src="../../assets/preview-orange.png" alt> Preview
                  </a>
                </li>
                <li>
                  <a href="#">
                    <img src="../../assets/tips.png" alt> Tips
                  </a>
                </li>
              </ul>
            </div>

            <div class="form-section">
              <div>
                <div class="box">
                  <ckeditor v-model="additionals" :editor="editor"></ckeditor>
                </div>
              </div>
            </div>
          </div>
          <div class="btn-sec">
            <a @click="back(currentstep)" href="#" class="btn-secondary md-ink-ripple">Back</a>
            <a @click="nextstep(currentstep)" class="btn-primary md-ink-ripple">{{stepname}}</a>
          </div>
        </div>
      </div>
    </body>
  </div>
  <div v-if="currentstep == 13">
    <body class="builder-page">
      <div class="top-header">
        <div class="top-left">
          <div class="logo">
            <a href="/Dashboard">
              <img src="../../assets/CC-Logo-White.svg" alt>
            </a>
          </div>
        </div>
        <div class="top-right">
          <a class="menu-toggle" href="#">
            <i class="material-icons">menu</i>
          </a>
        </div>
      </div>
      <div class="resume-builder-main">
        <div class="resume-builder-left">
          <!--<div class="logo">
                <a href="#"><img src="images/builder/CC-Logo-White.svg" alt="" /></a>
          </div>-->
          <div class="resume-section">
            <h3>Resume Sections</h3>
            <div class="logo">
              <a href="/Dashboard">
                <img src="/img/CC-Logo-White.1144d714.svg" alt>
              </a>
            </div>
            <ul>
              <li class="active">
                <a @click.prevent="Jumptoheading" href>
                  <span>1</span> Heading
                </a>
              </li>
              <li class="active">
                <a @click.prevent="Jumptowork" href>
                  <span>2</span> Experience
                </a>
              </li>
              <li class="active">
                <a @click.prevent="Jumptoeducation" href>
                  <span>3</span> Education
                </a>
              </li>
              <li class="active">
                <a @click.prevent="Jumptoskill" href>
                  <span>4</span> Skills
                </a>
              </li>
              <li class="active">
                <a @click.prevent="Jumptosummary" href>
                  <span>5</span>Summary
                </a>
              </li>
              <li class="active" data-aos="fade-up" data-aos-duration="1200">
                <a @click.prevent="Jumptooptional" href>
                  <span>6</span> Others
                </a>
              </li>
              <li>
                <a @click.prevent="Jumptofinal" href>
                  <span>7</span> Finalize
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div class="resume-builder-right">
          <!--<div class="top">
                <a class="menu-toggle" href="#"><i class="material-icons">menu</i></a>
          </div>-->
          <div class="content skills-page">
            <div class="content-top-inner">
              <h3>Softwares</h3>
              <ul>
                <li>
                  <a @click="previewResumeone">
                    <img src="../../assets/preview-orange.png" alt> Preview
                  </a>
                </li>
                <li>
                  <a href="#">
                    <img src="../../assets/tips.png" alt> Tips
                  </a>
                </li>
              </ul>
            </div>

            <div class="form-section">
              <div class="box">
                <ckeditor v-model="software" :editor="editor"></ckeditor>
              </div>
            </div>
          </div>
          <div class="btn-sec">
            <a @click="back(currentstep)" class="btn-secondary md-ink-ripple">Back</a>
            <a @click="nextstep(currentstep)" class="btn-primary md-ink-ripple">{{stepname}}</a>
          </div>
        </div>
      </div>
    </body>
  </div>
  <div v-if="currentstep == 14">
    <body class="builder-page">
      <div class="top-header">
        <div class="top-left">
          <div class="logo">
            <a href="/Dashboard">
              <img src="../../assets/CC-Logo-White.svg" alt>
            </a>
          </div>
        </div>
        <div class="top-right">
          <a class="menu-toggle" href="#">
            <i class="material-icons">menu</i>
          </a>
        </div>
      </div>
      <div class="resume-builder-main">
        <div class="resume-builder-left">
          <!--<div class="logo">
                <a href="#"><img src="images/builder/CC-Logo-White.svg" alt="" /></a>
          </div>-->
          <div class="resume-section">
            <h3>Resume Sections</h3>
            <div class="logo">
              <a href="/Dashboard">
                <img src="/img/CC-Logo-White.1144d714.svg" alt>
              </a>
            </div>
            <ul>
              <li class="active">
                <a @click.prevent="Jumptoheading" href>
                  <span>1</span> Heading
                </a>
              </li>
              <li class="active">
                <a @click.prevent="Jumptowork" href>
                  <span>2</span> Experience
                </a>
              </li>
              <li class="active">
                <a @click.prevent="Jumptoeducation" href>
                  <span>3</span> Education
                </a>
              </li>
              <li class="active">
                <a @click.prevent="Jumptoskill" href>
                  <span>4</span> Skills
                </a>
              </li>
              <li class="active">
                <a @click.prevent="Jumptosummary" href>
                  <span>5</span>Summary
                </a>
              </li>
              <li class="active" data-aos="fade-up" data-aos-duration="1200">
                <a @click.prevent="Jumptooptional" href>
                  <span>6</span> Others
                </a>
              </li>
              <li>
                <a @click.prevent="Jumptofinal" href>
                  <span>7</span> Finalize
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div class="resume-builder-right">
          <!--<div class="top">
                <a class="menu-toggle" href="#"><i class="material-icons">menu</i></a>
          </div>-->
          <div class="content skills-page">
            <div class="content-top-inner">
              <h3>Language</h3>
              <ul>
                <li>
                  <a @click="previewResumeone">
                    <img src="../../assets/preview-orange.png" alt> Preview
                  </a>
                </li>
                <li>
                  <a href="#">
                    <img src="../../assets/tips.png" alt> Tips
                  </a>
                </li>
              </ul>
            </div>

            <div class="form-section">
              <div >
                <div class="box">
                  <ckeditor v-model="language" :editor="editor"></ckeditor>
                </div>
              </div>
            </div>
          </div>
          <div class="btn-sec">
            <a @click="back(currentstep)" class="btn-secondary md-ink-ripple">Back</a>
            <a @click="nextstep(currentstep)" class="btn-primary md-ink-ripple">{{stepname}}</a>
          </div>
        </div>
      </div>
    </body>
  </div>
  <div v-if="currentstep == 15">
    <body class="builder-page">
      <div class="top-header">
        <div class="top-left">
          <div class="logo">
            <a href="/Dashboard">
              <img src="../../assets/CC-Logo-White.svg" alt>
            </a>
          </div>
        </div>
        <div class="top-right">
          <a class="menu-toggle" href="#">
            <i class="material-icons">menu</i>
          </a>
        </div>
      </div>
      <div class="resume-builder-main">
        <div class="resume-builder-left">
          <!--<div class="logo">
                <a href="#"><img src="images/builder/CC-Logo-White.svg" alt="" /></a>
          </div>-->
          <div class="resume-section">
            <h3>Resume Sections</h3>
            <div class="logo">
              <a href="/Dashboard">
                <img src="/img/CC-Logo-White.1144d714.svg" alt>
              </a>
            </div>
            <ul>
              <li class="active">
                <a @click.prevent="Jumptoheading" href>
                  <span>1</span> Heading
                </a>
              </li>
              <li class="active">
                <a @click.prevent="Jumptowork" href>
                  <span>2</span> Experience
                </a>
              </li>
              <li class="active">
                <a @click.prevent="Jumptoeducation" href>
                  <span>3</span> Education
                </a>
              </li>
              <li class="active">
                <a @click.prevent="Jumptoskill" href>
                  <span>4</span> Skills
                </a>
              </li>
              <li class="active">
                <a @click.prevent="Jumptosummary" href>
                  <span>5</span>Summary
                </a>
              </li>
              <li class="active" data-aos="fade-up" data-aos-duration="1200">
                <a @click.prevent="Jumptooptional" href>
                  <span>6</span> Others
                </a>
              </li>
              <li>
                <a @click.prevent="Jumptofinal" href>
                  <span>7</span> Finalize
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div class="resume-builder-right">
          <!--<div class="top">
                <a class="menu-toggle" href="#"><i class="material-icons">menu</i></a>
          </div>-->
          <div class="content skills-page">
            <div class="content-top-inner">
              <h3>Certification</h3>
              <ul>
                <li>
                  <a @click="previewResumeone">
                    <img src="../../assets/preview-orange.png" alt> Preview
                  </a>
                </li>
                <li>
                  <a href="#">
                    <img src="../../assets/tips.png" alt> Tips
                  </a>
                </li>
              </ul>
            </div>

            <div class="form-section">
              <div>
                <div class="box">
                  <ckeditor v-model="certificate" :editor="editor"></ckeditor>
                </div>
              </div>
            </div>
          </div>
          <div class="btn-sec">
            <a @click="back(currentstep)" class="btn-secondary md-ink-ripple">Back</a>
            <a @click="nextstep(currentstep)" class="btn-primary md-ink-ripple">{{stepname}}</a>
          </div>
        </div>
      </div>
    </body>
  </div>
  <div v-if="currentstep == 16">
    <body class="builder-page">
      <div class="top-header">
        <div class="top-left">
          <div class="logo">
            <a href="/Dashboard">
              <img src="../../assets/CC-Logo-White.svg" alt>
            </a>
          </div>
        </div>
        <div class="top-right">
          <a class="menu-toggle" href="#">
            <i class="material-icons">menu</i>
          </a>
        </div>
      </div>
      <div class="resume-builder-main">
        <div class="resume-builder-left">
          <!--<div class="logo">
                <a href="#"><img src="images/builder/CC-Logo-White.svg" alt="" /></a>
          </div>-->
          <div class="resume-section">
            <h3>Resume Sections</h3>
            <div class="logo">
              <a href="/Dashboard">
                <img src="/img/CC-Logo-White.1144d714.svg" alt>
              </a>
            </div>
            <ul>
              <li class="active">
                <a @click.prevent="Jumptoheading" href>
                  <span>1</span> Heading
                </a>
              </li>
              <li class="active">
                <a @click.prevent="Jumptowork" href>
                  <span>2</span> Experience
                </a>
              </li>
              <li class="active">
                <a @click.prevent="Jumptoeducation" href>
                  <span>3</span> Education
                </a>
              </li>
              <li class="active">
                <a @click.prevent="Jumptoskill" href>
                  <span>4</span> Skills
                </a>
              </li>
              <li class="active">
                <a @click.prevent="Jumptosummary" href>
                  <span>5</span> Summary
                </a>
              </li>
              <li class="active" data-aos="fade-up" data-aos-duration="1200">
                <a @click.prevent="Jumptooptional" href>
                  <span>6</span> Others
                </a>
              </li>
              <li>
                <a @click.prevent="Jumptofinal" href>
                  <span>7</span> Finalize
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div class="resume-builder-right">
          <!--<div class="top">
                <a class="menu-toggle" href="#"><i class="material-icons">menu</i></a>
          </div>-->
          <div class="content skills-page">
            <div class="content-top-inner">
              <h3>Interests</h3>
              <ul>
                <li>
                  <a @click="previewResumeone">
                    <img src="../../assets/preview-orange.png" alt> Preview
                  </a>
                </li>
                <li>
                  <a href="#">
                    <img src="../../assets/tips.png" alt> Tips
                  </a>
                </li>
              </ul>
            </div>

            <div class="form-section">
              <div >
                <div class="box">
                  <ckeditor v-model="intrest" :editor="editor"></ckeditor>
                </div>
              </div>
            </div>
          </div>
          <div class="btn-sec">
            <a @click="back(currentstep)" class="btn-secondary md-ink-ripple">Back</a>
            <a @click="nextstep(currentstep)" class="btn-primary md-ink-ripple">{{stepname}}</a>
          </div>
        </div>
      </div>
    </body>
  </div>
  <div v-if="currentstep == 20">
    <body class="builder-page">
      <div class="top-header">
        <div class="top-left">
          <div class="logo">
            <a href="/Dashboard">
              <img src="../../assets/CC-Logo-White.svg" alt>
            </a>
          </div>
        </div>
        <div class="top-right">
          <a class="menu-toggle" href="#">
            <i class="material-icons">menu</i>
          </a>
        </div>
      </div>
      <div class="resume-builder-main">
        <div class="resume-builder-left">
          <!--<div class="logo">
                <a href="#"><img src="images/builder/CC-Logo-White.svg" alt="" /></a>
          </div>-->
          <div class="resume-section">
            <h3>Resume Sections</h3>
            <div class="logo">
              <a href="/Dashboard">
                <img src="/img/CC-Logo-White.1144d714.svg" alt>
              </a>
            </div>
            <ul>
              <li class="active">
                <a @click.prevent="Jumptoheading" href>
                  <span>1</span> Heading
                </a>
              </li>
              <li class="active">
                <a @click.prevent="Jumptowork" href>
                  <span>2</span> Experience
                </a>
              </li>
              <li class="active">
                <a @click.prevent="Jumptoeducation" href>
                  <span>3</span> Education
                </a>
              </li>
              <li class="active">
                <a @click.prevent="Jumptoskill" href>
                  <span>4</span> Skills
                </a>
              </li>
              <li class="active">
                <a @click.prevent="Jumptosummary" href>
                  <span>5</span>Summary
                </a>
              </li>
              <li class="active" data-aos="fade-up" data-aos-duration="1200">
                <a @click.prevent="Jumptooptional" href>
                  <span>6</span> Others
                </a>
              </li>
              <li>
                <a @click.prevent="Jumptofinal" href>
                  <span>7</span> Finalize
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div class="resume-builder-right">
          <!--<div class="top">
                <a class="menu-toggle" href="#"><i class="material-icons">menu</i></a>
          </div>-->
          <div class="content skills-page">
            <div class="content-top-inner">
              <ul>
                <li>
                  <a @click="previewResumeone">
                    <img src="../../assets/preview-orange.png" alt> Preview
                  </a>
                </li>
                <li>
                  <a href="#">
                    <img src="../../assets/tips.png" alt> Tips
                  </a>
                </li>
              </ul>
            </div>

            <div class="form-section">
              <div>
              <div class="mb-5" v-for="(data, index) in add_your_own_json">
                <h3 class="mb-2">{{ data.title }}</h3>
                <div class="box">
                  <ckeditor v-model="data.body" :editor="editor"></ckeditor>
                </div>
              </div>
              </div>
            </div>
          </div>
          <div class="btn-sec">
            <a @click="back(currentstep)" class="btn-secondary md-ink-ripple">Back</a>
            <a @click="nextstep(currentstep)" class="btn-primary md-ink-ripple">{{stepname}}</a>
          </div>
        </div>
      </div>
    </body>
  </div>
  <div v-if="currentstep == 17">
    <body class="builder-page">
      <div class="top-header">
        <div class="top-left">
          <div class="logo">
            <a href="/Dashboard">
              <img src="../../assets/CC-Logo-White.svg" alt>
            </a>
          </div>
        </div>
        <div class="top-right">
          <a class="menu-toggle" href="#">
            <i class="material-icons">menu</i>
          </a>
        </div>
      </div>
      <div class="resume-builder-main">
        <div class="resume-builder-left">
          <!--<div class="logo">
                <a href="#"><img src="images/builder/CC-Logo-White.svg" alt="" /></a>
          </div>-->
          <div class="resume-section">
            <h3>Resume Sections</h3>
            <div class="logo">
              <a href="/Dashboard">
                <img src="/img/CC-Logo-White.1144d714.svg" alt>
              </a>
            </div>
            <ul>
              <li class="active" data-aos="fade-up" data-aos-duration="200">
                <a @click.prevent="Jumptoheading" href>
                  <span>1</span> Heading
                </a>
              </li>
              <li class="active" data-aos="fade-up" data-aos-duration="400">
                <a @click.prevent="Jumptowork" href>
                  <span>2</span> Experience
                </a>
              </li>
              <li class="active" data-aos="fade-up" data-aos-duration="600">
                <a @click.prevent="Jumptoeducation" href>
                  <span>3</span> Education
                </a>
              </li>
              <li class="active" data-aos="fade-up" data-aos-duration="800">
                <a @click.prevent="Jumptoskill" href>
                  <span>4</span> Skills
                </a>
              </li>
              <li class="active" data-aos="fade-up" data-aos-duration="1000">
                <a @click.prevent="Jumptosummary" href>
                  <span>5</span> Summary
                </a>
              </li>
              <li class="active" data-aos="fade-up" data-aos-duration="1200">
                <a @click.prevent="Jumptooptional" href>
                  <span>6</span> Others
                </a>
              </li>
              <li class="active" data-aos="fade-up" data-aos-duration="1200">
                <a @click.prevent="Jumptofinal" href>
                  <span>7</span> Finalize
                </a>
              </li>
            </ul>
          </div>
          <!-- <div class="resume-btn-sec">
                <a class="primary-btn" @click="currentstep=22">Revise your resume</a>
          </div>-->
        </div>

        <div class="resume-builder-right resume-preview">
          <!--<div class="top">
        <a class="menu-toggle" href="#"><i class="material-icons">menu</i></a>
          </div>-->
          <div class="resume-preview-inner" data-aos="fade-up" data-aos-duration="800">
            <div class="previewTop">
              <!-- <div class="resume-edit">
                <a href="javascript:void(0);">
                  [davidjohn_resume]
                  <i class="material-icons">edit</i>
                </a>
              </div>-->
              <!-- <div class="dropdown">
                        <span id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            More Options <i class="material-icons">keyboard_arrow_down</i>
                        </span>
                        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                            <a class="dropdown-item" href="#">Duplicate</a>
                            <a class="dropdown-item" href="#">Delete</a>
                        </div>
              </div>-->
            </div>
            <div class="resume-preview-section">
              <!-- <img src="Images/builder/resume-sample.png" alt="" /> -->
              <div v-if="showResume">
                <resumeonetemplate
                  ref="resumeone"
                  :parentObj="this"
                  :from="cvfrom"
                  :resume="resumeobj"
                  ::final="isfinal"
                ></resumeonetemplate>
              </div>
              <div v-if="showResumetwo">
                <resumetwotemplate
                  ref="resumetwo"
                  :parentObj="this"
                  :from="cvfrom"
                  :resume="resumeobj"
                  ::final="isfinal"
                ></resumetwotemplate>
              </div>
              <div v-if="showResumethree">
                <resumethreetemplate
                  ref="resumethree"
                  :parentObj="this"
                  :from="cvfrom"
                  :resume="resumeobj"
                  :final="isfinal"
                ></resumethreetemplate>
              </div>
              <div v-if="showResumefour">
                <resumefourtemplate
                  ref="resumefour"
                  :parentObj="this"
                  :from="cvfrom"
                  :resume="resumeobj"
                  :final="isfinal"
                ></resumefourtemplate>
              </div>
              <div v-if="showResumefive">
                <resumefivetemplate
                  ref="resumefive"
                  :parentObj="this"
                  :from="cvfrom"
                  :resume="resumeobj"
                  :final="isfinal"
                ></resumefivetemplate>
              </div>
              <div v-if="showResumesix">
                <resumesixtemplate
                  ref="resumesix"
                  :parentObj="this"
                  :from="cvfrom"
                  :resume="resumeobj"
                  :final="isfinal"
                ></resumesixtemplate>
              </div>
              <div v-if="showResumeseven">
                <resumeseventemplate
                  ref="resumeseven"
                  :parentObj="this"
                  :from="cvfrom"
                  :resume="resumeobj"
                  :final="isfinal"
                ></resumeseventemplate>
              </div>
              <div v-if="showResumeeight">
                <resumeeighttemplate
                  ref="resumeeight"
                  :parentObj="this"
                  :from="cvfrom"
                  :resume="resumeobj"
                  :final="isfinal"
                ></resumeeighttemplate>
              </div>
              <div v-if="showResumenine">
                <resumeninetemplate
                  ref="resumenine"
                  :parentObj="this"
                  :from="cvfrom"
                  :resume="resumeobj"
                  :final="isfinal"
                ></resumeninetemplate>
              </div>
              <div v-if="showResumetwelve">
                <resumetwelvetemplate
                  ref="resumetwelve"
                  :parentObj="this"
                  :from="cvfrom"
                  :resume="resumeobj"
                  :final="isfinal"
                ></resumetwelvetemplate>
              </div>
            </div>
          </div>
          <div class="bottom-preview">
            <div class="prview-box">
              <div class="btn-sec">
                <a @click="back(currentstep)" class="btn-secondary md-ink-ripple">Back</a>
                <ul class="bottom-preview-btn">
                  <li>
                    <a
                      @click.prevent="Changetemplateprompt"
                      data-toggle="modal"
                      data-target="#ChnageTemplate"
                    >
                      <img src="../../assets/template.png" alt>
                      <span>
                        Template
                        <i class="material-icons">keyboard_arrow_down</i>
                      </span>
                    </a>
                  </li>
                </ul>
                <a @click.prevent="Saveresume" class="btn-primary md-ink-ripple">Save</a>
              </div>
            </div>
            <!-- <div class="prview-box">
                    <label>Template</label>
                    <a href="javascript:void(0);"><span>Crisp</span> <i class="material-icons">keyboard_arrow_down</i></a>
            </div>-->
            <!-- <div class="prview-box">
                    <label>Color</label>
                    <ul>
                        <li><div class="white"><span></span></div></li>
                        <li class="active"><div class="blue"><span></span></div></li>
                    </ul>
                    <i class="material-icons">keyboard_arrow_right</i>
                    <input data-toggle="tooltip" data-placement="top" title="Customize" type="color" name=""/>
            </div>-->
          </div>
        </div>
      </div>

      <!--  <div class="choose-template-sec">

        <div class="owl-carousel owl-theme">
            <div class="item">
                <img src="Images/builder/view-resume.jpg" alt="" />
            </div>
            <div class="item">
                <img src="Images/builder/view-resume.jpg" alt="" />
            </div>
            <div class="item active">
                <img src="Images/builder/view-resume.jpg" alt="" />
            </div>
            <div class="item">
                <img src="Images/builder/view-resume.jpg" alt="" />
            </div>
            <div class="item ">
                <img src="Images/builder/view-resume.jpg" alt="" />
            </div>
            <div class="item">
                <img src="Images/builder/view-resume.jpg" alt="" />
            </div>
            <div class="item">
                <img src="Images/builder/view-resume.jpg" alt="" />
            </div>
            <div class="item">
                <img src="Images/builder/view-resume.jpg" alt="" />
            </div>
            <div class="item">
                <img src="Images/builder/view-resume.jpg" alt="" />
            </div>
            <div class="item">
                <img src="Images/builder/view-resume.jpg" alt="" />
            </div>
        </div>
      </div>-->

      <!-- <script>
        $(document).ready(function () {
            AOS.init();
            AOS.init({ disable: 'mobile' });
            $('[data-toggle="tooltip"]').tooltip()
            $(".menu-toggle").click(function () {
                $(".resume-builder-main").toggleClass('active');
            });
        });

        $(window).scroll(function () {
            if ($(this).scrollTop() > 50) {
                $('.resume-builder-right .top').addClass('fixed');
            } else {
                $('.resume-builder-right .top').removeClass('fixed');
            }
        });

        $(document).ready(function () {
            $(".bottom-preview .prview-box a.choose-template").click(function () {
                $(".choose-template-sec").toggleClass('active');
            });
        });


        $('.owl-carousel').owlCarousel({
            loop: true,
            margin: 10,
            responsiveClass: true,
            autoplay: false,
            nav: true,
            dots: false,
            responsive: {
                0: {
                    items: 1,
                },
                600: {
                    items: 3,
                },
                1000: {
                    items: 5,
                },
                1400: {
                    items: 6,
                },
                1600: {
                    items: 7,
                }
            }
        })
      </script>-->
      <div v-if="opencarousel" class="choose-template-sec">
        <span @click.prevent="opencarousel=false" class="material-icons popupclose">close</span>
        <carousel :items="5" v-if="opencarousel">
          <div
            @click.prevent="Handlecarousel(item)"
            v-for="(item, index) in cvTemplates"
            :key="index"
          >
            <img :src="item.img" :alt="item.name">
          </div>
        </carousel>
      </div>
    </body>
  </div>
  <!-- <div v-if="loader">
    <div class="processing_popup upload full-spinner" style="visibility: visible">
      <div class="spinner">
        <div class="bounce1"></div>
        <div class="bounce2"></div>
        <div class="bounce3"></div>
      </div>
    </div>
  </div>-->

  <div v-if="loader" class="template-loader-hiw hide">
    <div class="loader-overlay"></div>
    <div class="progress-bar-wrapper">
      <img
        src="../../assets/check-circle.svg"
        v-if="finished"
        alt="Check Circle"
        width="48"
        height="48"
        class="icon-check-circle hide"
      >
      <p class="progress-text step1">{{ loadermsg }}</p>
      <div v-if="!finished" class="progress-bar">
        <div class="progress-linear"></div>
        <div class="progress-gradient progress-animate"></div>
      </div>
    </div>
  </div>
  <transition name="fade">
    <Messages
      v-if="isdisplaymsg"
      :datamessage="sucessmsgtext"
      v-on:closemsg="closeMessage"
      v-bind:isVisible="isdisplaymsg"
    ></Messages>
  </transition>
  <ConfirmBox
    ref="confirmcomp"
    :showmodal="showCnfrmPopUp"
    :actionmessage="actionMsg"
    @cancelAction="ChooseNo()"
    @confirmAction="Delete()"
  ></ConfirmBox>
  <div
    class="modal fade imgPreview"
    id="ChnageTemplate"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalCenterTitle"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLongTitle">Change template</h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            @click.prevent="CancelTemplatechange"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-md-7 pr-0">
              <div class="ResumePreview">
                <div class="ResumeFullPreview">
                  <div v-if="popupresume==1">
                    <resumeonetemplate
                      ref="resumeone"
                      :parentObj="this"
                      :from="cvfrom"
                      :resume="resumeobj"
                    ></resumeonetemplate>
                  </div>
                  <div v-if="popupresume==2">
                    <resumetwotemplate
                      ref="resumetwo"
                      :parentObj="this"
                      :from="cvfrom"
                      :resume="resumeobj"
                    ></resumetwotemplate>
                  </div>
                  <div v-if="popupresume==3">
                    <resumethreetemplate
                      ref="resumethree"
                      :parentObj="this"
                      :from="cvfrom"
                      :resume="resumeobj"
                    ></resumethreetemplate>
                  </div>
                  <div v-if="popupresume==4">
                    <resumefourtemplate
                      ref="resumefour"
                      :parentObj="this"
                      :from="cvfrom"
                      :resume="resumeobj"
                    ></resumefourtemplate>
                  </div>
                  <div v-if="popupresume==5">
                    <resumefivetemplate
                      ref="resumefive"
                      :parentObj="this"
                      :from="cvfrom"
                      :resume="resumeobj"
                    ></resumefivetemplate>
                  </div>
                  <div v-if="popupresume==6">
                    <resumesixtemplate
                      ref="resumesix"
                      :parentObj="this"
                      :from="cvfrom"
                      :resume="resumeobj"
                    ></resumesixtemplate>
                  </div>
                  <div v-if="popupresume==7">
                    <resumeseventemplate
                      ref="resumeseven"
                      :parentObj="this"
                      :from="cvfrom"
                      :resume="resumeobj"
                    ></resumeseventemplate>
                  </div>
                  <div v-if="popupresume==8">
                    <resumeeighttemplate
                      ref="resumeeight"
                      :parentObj="this"
                      :from="cvfrom"
                      :resume="resumeobj"
                    ></resumeeighttemplate>
                  </div>
                  <div v-if="popupresume==9">
                    <resumeninetemplate
                      ref="resumenine"
                      :parentObj="this"
                      :from="cvfrom"
                      :resume="resumeobj"
                    ></resumeninetemplate>
                  </div>
                  <div v-if="popupresume==12">
                    <resumetwelvetemplate
                      ref="resumetwelve"
                      :parentObj="this"
                      :from="cvfrom"
                      :resume="resumeobj"
                    ></resumetwelvetemplate>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-5 pl-0">
              <div class="TemplateSelector">
                <div class="ColorPanel">
                  <span class="color-panel-title">Choose color:</span>

                  <ul class="color-selector">
                    <li>
                      <label class="color-selector-reset">
                        <span
                          @click.prevent="changeBackgroundColor(previousColor)"
                          class="color-selector-radio"
                          style="background:rgb(255, 255, 255);"
                        ></span>
                      </label>
                    </li>
                    <li>
                      <label title="Nobel Grey" class="label" :class="{'active':(hoveredColor=='#7d7d7d'||hoveredColor=='#34383c'||hoveredColor=='#e4e2de')}">
                        <span
                          class="color-selector-radio"                       
                          @click.prevent="changeBackgroundColor('#7d7d7d')"
                          style="background: rgb(125, 125, 125);"
                        ></span>
                      </label>
                      <ul class="color-dropdown">
                        <li>
                          <label title="Outer Space" class="label">
                            <span
                              class="color-selector-radio"
                              @click.prevent="changeBackgroundColor('#34383c')"
                              style="background: rgb(52, 56, 60);"
                            ></span>
                          </label>
                        </li>
                        <li>
                          <label title="Silver White" class="label">
                            <span
                              class="color-selector-radio"
                              style="background: rgb(228, 226, 222);"
                              @click.prevent="changeBackgroundColor('#e4e2de')"
                            ></span>
                          </label>
                        </li>
                      </ul>
                    </li>
                    <li>
                      <label
                        title="Oxford Blue"
                        class="label"
                        :class="{'active':(hoveredColor=='#102a73'||hoveredColor=='#a3b8de'||hoveredColor=='#394d6b')}"
                        
                        @click.prevent="changeBackgroundColor('#102a73')"
                      >
                        <span class="color-selector-radio" style="background: rgb(16, 42, 115);"></span>
                      </label>
                      <ul class="color-dropdown">
                        <li>
                          <label title="Steel Blue" class="label">
                            <span
                              class="color-selector-radio"
                              style="background: rgb(163, 184, 222);"
                              @click.prevent="changeBackgroundColor('#a3b8de')"
                            ></span>
                          </label>
                        </li>
                        <li>
                          <label title="Denim Blue" class="label">
                            <span
                              class="color-selector-radio"
                              style="background: rgb(57, 77, 107);"
                              @click.prevent="changeBackgroundColor('#394d6b')"
                            ></span>
                          </label>
                        </li>
                      </ul>
                    </li>
                    <li>
                      <label title="Olympic Blue" class="label" :class="{'active':(hoveredColor=='#2b98de'||hoveredColor=='#094d73'||hoveredColor=='#8ac3f5')}">
                        <span
                          class="color-selector-radio"
                          @click.prevent="changeBackgroundColor('#2b98de')"
                          style="background: rgb(43, 152, 222);"
                        ></span>
                      </label>
                      <ul class="color-dropdown">
                        <li>
                          <label title="Slate Blue" class="label">
                            <span
                              class="color-selector-radio"
                              @click.prevent="changeBackgroundColor('#094d73')"
                              style="background: rgb(9, 77, 115);"
                            ></span>
                          </label>
                        </li>
                        <li>
                          <label title="Carolina Blue" class="label">
                            <span
                              class="color-selector-radio"
                              style="background: rgb(138, 195, 245);"
                              @click.prevent="changeBackgroundColor('#8ac3f5')"
                            ></span>
                          </label>
                        </li>
                      </ul>
                    </li>
                    <li>
                      <label title="Turquoise" class="label"  :class="{'active':(hoveredColor=='#00bca3'||hoveredColor=='#016b5d'||hoveredColor=='#b5e8e2')}">
                        <span
                          class="color-selector-radio"
                          @click.prevent="changeBackgroundColor('#00bca3')"
                          style="background: rgb(0, 188, 163);"
                        ></span>
                      </label>
                      <ul class="color-dropdown">
                        <li>
                          <label title="Empress Teal" class="label">
                            <span
                              class="color-selector-radio"
                              @click.prevent="changeBackgroundColor('#016b5d')"
                              style="background: rgb(1, 107, 93);"
                            ></span>
                          </label>
                        </li>
                        <li>
                          <label title="Mint Teal" class="label">
                            <span
                              class="color-selector-radio"
                              style="background: rgb(181, 232, 226);"
                              @click.prevent="changeBackgroundColor('#b5e8e2')"
                            ></span>
                          </label>
                        </li>
                      </ul>
                    </li>
                    <li>
                      <label title="Jungle Green" class="label" :class="{'active':(hoveredColor=='#075700'||hoveredColor=='#b7d1ad'||hoveredColor=='#789c30')}">
                        <span
                          class="color-selector-radio"
                          @click.prevent="changeBackgroundColor('#075700')"
                          style="background: rgb(7, 87, 0);"
                        ></span>
                      </label>
                      <ul class="color-dropdown">
                        <li>
                          <label title="Pixie Green" class="label">
                            <span
                              class="color-selector-radio"
                              style="background: rgb(183, 209, 173);"
                              @click.prevent="changeBackgroundColor('#b7d1ad')"
                            ></span>
                          </label>
                        </li>
                        <li>
                          <label title="Moss Green" class="label">
                            <span
                              class="color-selector-radio"
                              style="background: rgb(120, 156, 48);"
                              @click.prevent="changeBackgroundColor('#789c30')"
                            ></span>
                          </label>
                        </li>
                      </ul>
                    </li>
                    <li>
                      <label title="Tuscan Yellow" class="label" :class="{'active':(hoveredColor=='#facd05'||hoveredColor=='#cd8b00'||hoveredColor=='#c4b08f')}">
                        <span
                          class="color-selector-radio"
                          style="background: rgb(250, 205, 5);"
                          @click.prevent="changeBackgroundColor('#facd05')"
                        ></span>
                      </label>
                      <ul class="color-dropdown">
                        <li>
                          <label title="Medallion" class="label">
                            <span
                              class="color-selector-radio"
                              style="background: rgb(205, 139, 0);"
                              @click.prevent="changeBackgroundColor('#cd8b00')"
                            ></span>
                            <!-- <input
                              type="radio"
                              aria-checked="false"
                              data-color="#cd8b00"
                              data-label="Medallion"
                              value="#cd8b00"
                              @mouseover="changeBackgroundColor('#cd8b00')"
                              
                             
                            >-->
                          </label>
                        </li>
                        <li>
                          <label title="Sand Dollar" class="label">
                            <span
                              class="color-selector-radio"
                              style="background: rgb(196, 176, 143);"
                              @click.prevent="changeBackgroundColor('#c4b08f')"
                            ></span>
                          </label>
                        </li>
                      </ul>
                    </li>
                    <li>
                      <label title="Indian Red" class="label" :class="{'active':(hoveredColor=='#9b3016'||hoveredColor=='#e37929'||hoveredColor=='#c46531')}">
                        <span
                          class="color-selector-radio"
                          style="background: rgb(155, 48, 22);"
                          @click.prevent="changeBackgroundColor('#9b3016')"
                        ></span>
                      </label>
                      <ul class="color-dropdown">
                        <li>
                          <label title="Orange Sunrise" class="label">
                            <span
                              class="color-selector-radio"
                              style="background: rgb(227, 121, 41);"
                              @click.prevent="changeBackgroundColor('#e37929')"
                            ></span>
                          </label>
                        </li>
                        <li>
                          <label title="Red Fox" class="label">
                            <span
                              class="color-selector-radio"
                              style="background: rgb(196, 101, 49);"
                              @click.prevent="changeBackgroundColor('#c46531')"
                            ></span>
                          </label>
                        </li>
                      </ul>
                    </li>
                    <li>
                      <label title="Contessa Rose" class="label" :class="{'active':(hoveredColor=='#f98c79'||hoveredColor=='#8c3c4b'||hoveredColor=='#f7bfb5')}">
                        <span
                          class="color-selector-radio"
                          style="background: rgb(249, 140, 121);"
                          @click.prevent="changeBackgroundColor('#f98c79')"
                        ></span>
                      </label>
                      <ul class="color-dropdown">
                        <li>
                          <label title="Camelot" class="label">
                            <span
                              class="color-selector-radio"
                              style="background: rgb(140, 60, 75);"
                              @click.prevent="changeBackgroundColor('#8c3c4b')"
                            ></span>
                          </label>
                        </li>
                        <li>
                          <label title="Azalea Pink" class="label">
                            <span
                              class="color-selector-radio"
                              style="background: rgb(247, 191, 181);"
                              @click.prevent="changeBackgroundColor('#f7bfb5')"
                            ></span>
                          </label>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </div>

                <div class="ResumePanel">
                  <div @click.prevent="popupresume=1" class="ThumbPreview" :class="{'active':(template_name=='resume1.png')}">
                    <div>
                      <resumeonetemplate
                        ref="resumeone"
                        :parentObj="this"
                        :from="cvfrom"
                        :resume="resumeobj"
                      ></resumeonetemplate>
                    </div>
                  </div>
                  <div @click.prevent="popupresume=2" class="ThumbPreview">
                    <div>
                      <resumetwotemplate
                        ref="resumetwo"
                        :parentObj="this"
                        :from="cvfrom"
                        :resume="resumeobj"
                      ></resumetwotemplate>
                    </div>
                  </div>
                  <div @click.prevent="popupresume=3" class="ThumbPreview">
                    <div>
                      <resumethreetemplate
                        ref="resumethree"
                        :parentObj="this"
                        :from="cvfrom"
                        :resume="resumeobj"
                      ></resumethreetemplate>
                    </div>
                  </div>
                  <div @click.prevent="popupresume=4" class="ThumbPreview">
                    <div>
                      <resumefourtemplate
                        ref="resumefour"
                        :parentObj="this"
                        :from="cvfrom"
                        :resume="resumeobj"
                      ></resumefourtemplate>
                    </div>
                  </div>
                  <div @click.prevent="popupresume=5" class="ThumbPreview">
                    <div>
                      <resumefivetemplate
                        ref="resumefive"
                        :parentObj="this"
                        :from="cvfrom"
                        :resume="resumeobj"
                      ></resumefivetemplate>
                    </div>
                  </div>
                  <div @click.prevent="popupresume=6" class="ThumbPreview">
                    <div>
                      <resumesixtemplate
                        ref="resumesix"
                        :parentObj="this"
                        :from="cvfrom"
                        :resume="resumeobj"
                      ></resumesixtemplate>
                    </div>
                  </div>
                  <div @click.prevent="popupresume=7" class="ThumbPreview">
                    <div>
                      <resumeseventemplate
                        ref="resumeseven"
                        :parentObj="this"
                        :from="cvfrom"
                        :resume="resumeobj"
                      ></resumeseventemplate>
                    </div>
                  </div>
                  <div @click.prevent="popupresume=8" class="ThumbPreview">
                    <div>
                      <resumeeighttemplate
                        ref="resumeeight"
                        :parentObj="this"
                        :from="cvfrom"
                        :resume="resumeobj"
                      ></resumeeighttemplate>
                    </div>
                  </div>
                  <div @click.prevent="popupresume=9" class="ThumbPreview">
                    <div>
                      <resumeninetemplate
                        ref="resumenine"
                        :parentObj="this"
                        :from="cvfrom"
                        :resume="resumeobj"
                      ></resumeninetemplate>
                    </div>
                  </div>
                  <div @click.prevent="popupresume=12" class="ThumbPreview">
                    <div>
                      <resumetwelvetemplate
                        ref="resumetwelve"
                        :parentObj="this"
                        :from="cvfrom"
                        :resume="resumeobj"
                      ></resumetwelvetemplate>
                    </div>
                  </div>
                </div>

                <div class="ResumeBottomPanel">
                  <button
                    type="button"
                    @click.prevent="HandleTemplatechange"
                    class="primary-btn"
                  >Select this template</button>
                  <button
                    type="button"
                    @click.prevent="CancelTemplatechange"
                    class="secondary-btn"
                  >Cancel</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- <resumeoneviewer
    ref="childRef"
    :resume="resumeobj"
    :parentObj="this"
    :showlist="showResume"
    :from="cvfrom"
    :final="isfinal"
  ></resumeoneviewer>-->
  <!-- <resumetwoviewer
    :resume="resumeobj"
    :parentObj="this"
    :showlist="showResumetwo"
    :from="cvfrom"
    :final="isfinal"
  ></resumetwoviewer>-->
  <div
    id="resumeprompt"
    role="dialog"
    tabindex="-1"
    class="modal fade imgPreview"
    aria-modal="true"
  >
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h3 class="modal-title mb-4">Resume Preview</h3>
          <button type="button" data-dismiss="modal" class="close">×</button>
        </div>
        <div class="modal-body">
          <resumeonetemplate :resume="resumeobj"></resumeonetemplate>
        </div>
      </div>
    </div>
  </div>
  <div
    id="resumetwoprompt"
    role="dialog"
    tabindex="-1"
    class="modal fade imgPreview"
    aria-modal="true"
  >
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h3 class="modal-title mb-4">Resume Preview</h3>
          <button type="button" data-dismiss="modal" class="close">×</button>
        </div>
        <div class="modal-body">
          <resumetwotemplate :resume="resumeobj"></resumetwotemplate>
        </div>
      </div>
    </div>
  </div>
  <div
    id="resumethreeprompt"
    role="dialog"
    tabindex="-1"
    class="modal fade imgPreview"
    aria-modal="true"
  >
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h3 class="modal-title mb-4">Resume Preview</h3>
          <button type="button" data-dismiss="modal" class="close">×</button>
        </div>
        <div class="modal-body">
          <resumethreetemplate :resume="resumeobj"></resumethreetemplate>
        </div>
      </div>
    </div>
  </div>
  <div
    id="resumefourprompt"
    role="dialog"
    tabindex="-1"
    class="modal fade imgPreview"
    aria-modal="true"
  >
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h3 class="modal-title mb-4">Resume Preview</h3>
          <button type="button" data-dismiss="modal" class="close">×</button>
        </div>
        <div class="modal-body">
          <resumefourtemplate :resume="resumeobj"></resumefourtemplate>
        </div>
      </div>
    </div>
  </div>
  <div
    id="resumefiveprompt"
    role="dialog"
    tabindex="-1"
    class="modal fade imgPreview"
    aria-modal="true"
  >
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h3 class="modal-title mb-4">Resume Preview</h3>
          <button type="button" data-dismiss="modal" class="close">×</button>
        </div>
        <div class="modal-body">
          <resumefivetemplate :resume="resumeobj"></resumefivetemplate>
        </div>
      </div>
    </div>
  </div>
  <div
    id="resumesixprompt"
    role="dialog"
    tabindex="-1"
    class="modal fade imgPreview"
    aria-modal="true"
  >
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h3 class="modal-title mb-4">Resume Preview</h3>
          <button type="button" data-dismiss="modal" class="close">×</button>
        </div>
        <div class="modal-body">
          <resumesixtemplate :resume="resumeobj"></resumesixtemplate>
        </div>
      </div>
    </div>
  </div>
  <div
    id="resumesevenprompt"
    role="dialog"
    tabindex="-1"
    class="modal fade imgPreview"
    aria-modal="true"
  >
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h3 class="modal-title mb-4">Resume Preview</h3>
          <button type="button" data-dismiss="modal" class="close">×</button>
        </div>
        <div class="modal-body">
          <resumeseventemplate :resume="resumeobj"></resumeseventemplate>
        </div>
      </div>
    </div>
  </div>
  <div
    id="resumeeightprompt"
    role="dialog"
    tabindex="-1"
    class="modal fade imgPreview"
    aria-modal="true"
  >
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h3 class="modal-title mb-4">Resume Preview</h3>
          <button type="button" data-dismiss="modal" class="close">×</button>
        </div>
        <div class="modal-body">
          <resumeeighttemplate :resume="resumeobj"></resumeeighttemplate>
        </div>
      </div>
    </div>
  </div>
  <div
    id="resumenineprompt"
    role="dialog"
    tabindex="-1"
    class="modal fade imgPreview"
    aria-modal="true"
  >
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h3 class="modal-title mb-4">Resume Preview</h3>
          <button type="button" data-dismiss="modal" class="close">×</button>
        </div>
        <div class="modal-body">
          <resumeninetemplate :resume="resumeobj"></resumeninetemplate>
        </div>
      </div>
    </div>
  </div>
  <div
    id="resumetwelveprompt"
    role="dialog"
    tabindex="-1"
    class="modal fade imgPreview"
    aria-modal="true"
  >
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h3 class="modal-title mb-4">Resume Preview</h3>
          <button type="button" data-dismiss="modal" class="close">×</button>
        </div>
        <div class="modal-body">
          <resumetwelvetemplate :resume="resumeobj"></resumetwelvetemplate>
        </div>
      </div>
    </div>
  </div>
</div>
</template>
<script>
import Axios from "axios";
import Multiselect from "vue-multiselect";
import rest_service from "@/api/rest_service_api.js";
import CKEditor from "@ckeditor/ckeditor5-vue2";
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

import Vue from "vue";
import moment from "moment";
import ItemTemplate from "@/components/AutocompleteTemplate/Geolocation.vue";
import "flatpickr/dist/flatpickr.css";
import resumeoneviewer from "@/components/resumeone.vue";
import resumetwoviewer from "@/components/resumetwo.vue";
import resumeonetemplate from "@/components/resumeTemplate/resumeone_template.vue";
import resumetwotemplate from "@/components/resumeTemplate/resumetwo_template.vue";
import resumethreetemplate from "@/components/resumeTemplate/resumethree_template.vue";
import resumefourtemplate from "@/components/resumeTemplate/resumefour_template.vue";
import resumefivetemplate from "@/components/resumeTemplate/resumefive_template.vue";
import resumesixtemplate from "@/components/resumeTemplate/resumesix_template.vue";
import resumeseventemplate from "@/components/resumeTemplate/resumeseven_template.vue";
import resumeeighttemplate from "@/components/resumeTemplate/resumeeight_template.vue";
import resumeninetemplate from "@/components/resumeTemplate/resumenine_template.vue";
import resumetwelvetemplate from "@/components/resumeTemplate/resumetwelve_template.vue";
import flatpickr from "flatpickr";
import Autocomplete from "v-autocomplete";
import ConfirmBox from "@/components/MessagePopup/ConfirmPopup";
import Messages from "@/components/MessagePopup/Messages";
import StarRating from "@/components/starrating.vue";
import carousel from "vue-owl-carousel";
// Import the necessary functions from date-fns
import { parse, format } from "date-fns";
Vue.use(flatpickr);
Vue.use(Autocomplete);
var customer = {
  description: "",
  matched_substrings: [{ length: 3, offset: 0 }],
  place_id: "ChIJ1dI391YYrjsRL5RdGCCN974",
  reference: "ChIJ1dI391YYrjsRL5RdGCCN974",
  structured_formatting: {
    main_text: "",
    main_text_matched_substrings: [{ length: 3, offset: 0 }],
    secondary_text: "Bengaluru, Karnataka, India"
  },
  terms: [
    { offset: 0, value: "Yelahanka" },
    { offset: 11, value: "Bengaluru" },
    { offset: 22, value: "Karnataka" },
    { offset: 33, value: countryname }
  ],
  types: ["sublocality_level_1", "sublocality", "political", "geocode"]
};
var customer_ed = {
  description: "",
  matched_substrings: [{ length: 3, offset: 0 }],
  place_id: "ChIJ1dI391YYrjsRL5RdGCCN974",
  reference: "ChIJ1dI391YYrjsRL5RdGCCN974",
  structured_formatting: {
    main_text: "",
    main_text_matched_substrings: [{ length: 3, offset: 0 }],
    secondary_text: "Bengaluru, Karnataka, India"
  },
  terms: [
    { offset: 0, value: "Yelahanka" },
    { offset: 11, value: "Bengaluru" },
    { offset: 22, value: "Karnataka" },
    { offset: 33, value: countryname }
  ],
  types: ["sublocality_level_1", "sublocality", "political", "geocode"]
};
var countryname = "";
export default {
  components: {
    Multiselect,
    ConfirmBox,
    Messages,
    ckeditor: CKEditor.component,
    resumetwotemplate,
    resumeonetemplate,
    resumethreetemplate,
    resumefourtemplate,
    resumefivetemplate,
    resumesixtemplate,
    resumeseventemplate,
    resumeeighttemplate,
    resumeninetemplate,
    resumetwelvetemplate,
    StarRating,
    carousel
  },
  data() {
    return {
      // editorConfig: {
      //   toolbar: {
      //     items: [
      //       "heading",
      //       "|",
      //       "bold",
      //       "italic",
      //       "|",
      //       "bulletedList",
      //       "numberedList",
      //       "|",
      //       "insertTable",
      //       "|",
      //       "imageUpload",
      //       "|",
      //       "undo",
      //       "redo"
      //     ]
      //   }
      // },
      editor: ClassicEditor,
      stepname: "Save & Continue",
      popupresume: 1,
      cvTemplates: [
        {
          img: "https://genamet-static-uploads.s3.amazonaws.com/CV/resume1.png",
          name: "resume1.png"
        },
        {
          img: "https://genamet-static-uploads.s3.amazonaws.com/CV/resume2.png",
          name: "resume2.png"
        },
        {
          img: "https://genamet-static-uploads.s3.amazonaws.com/CV/resume3.png",
          name: "resume3.png"
        },
        {
          img: "https://genamet-static-uploads.s3.amazonaws.com/CV/resume4.png",
          name: "resume4.png"
        },
        {
          img: "https://genamet-static-uploads.s3.amazonaws.com/CV/resume5.png",
          name: "resume5.png"
        },
        {
          img:
            "https://genamet-static-uploads.s3.amazonaws.com/CV/resume-6.jpg",
          name: "resume6.png"
        },
        {
          img:
            "https://genamet-static-uploads.s3.amazonaws.com/CV/resume-7.jpg",
          name: "resume7.png"
        },
        {
          img:
            "https://genamet-static-uploads.s3.amazonaws.com/CV/resume-8.jpg",
          name: "resume8.png"
        },
        {
          img:
            "https://genamet-static-uploads.s3.amazonaws.com/CV/resume-9.jpg",
          name: "resume9.png"
        },
        {
          img:
            "https://genamet-static-uploads.s3.amazonaws.com/CV/resume-12.jpg",
          name: "resume10.png"
        }
      ],
      opencarousel: false,
      selectedRating: 0,
      eddescs: [
        "Awarded [Award Name]",
        "Elected to [Elected Position] for [Student Organization, Fraternity or Sorority] in [Year]",
        "Completed professional development in [Subject]",
        "Member of [Fraternity or Sorority Name]",
        "Continuing education in [Subject]",
        "Member of [Student Organization or Club Name]",
        "Received [Scholarship Name]",
        "Professional development completed in [Subject]",
        "Dean's List [Semester and Year]",
        "Member of [Honor's Society Name]",
        "Elected Captain of [Team]"
      ],
      Schooldesc: "",
      isdisplaymsg: false,
      sucessmsgtext: "",
      what_index: 0,
      delete_what: "",
      actionMsg: "",
      showCnfrmPopUp: false,
      isJobdesc: false,
      Job_desc: "",
      currentstudy: false,
      currentwork: false,
      err_jd: false,
      err_email_regex: false,
      err_phone: false,
      err_name: false,
      err_prof: false,
      add_your_own_json: [],
      own_id: 1,
      countryname,
      Add_work: false,
      Add_ed: false,
      loader: false,
      finished: false,
      loadermsg: "",
      start_date_message: "",
      end_date_message: "",
      pic: "",
      template: ItemTemplate,
      temp_pic:
        "data:image/png;base64,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",
      currentstep: 0,
      resumeAlready: false,
      description: "",
      First_Name: "",
      Last_Name: "",
      Profession: "",
      City: "",
      Country: "",
      Pin_code: "",
      Phone: "",
      Email: "",
      Linkedin: "",
      Twitter: "",
      Website: "",
      Address: "",
      Work_id: 1,
      Job_Title: "",
      Employer: "",
      Work_City: "",
      Work_Country: "",
      Start_Date: "",
      mmyyyy: false,
      grad_mmyyyy: false,
      End_Date: moment(new Date()).format("DD/MM/YYYY"),
      Ed_id: 1,
      editeducation: false,
      editwork: false,
      School_loc: "",
      School_name: "",
      School_degree: "",
      Field_study: "",
      Grad_startdate: "",
      Grad_Enddate: moment(new Date()).format("DD/MM/YYYY"),
      School_desc: "",
      steps: [],
      jobtitlelist: [],
      filterName: "",
      WorkDesc: [],
      resumeobj: {
        profile: {
          linkedin: "",
          address: "",
          firstname: "",
          surname: "",
          email: "",
          pincode: "",
          profession: "",
          country: "India",
          city: "",
          phone: ""
        },
        skills: "",
        summary: "",
        pic:
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAATlBMVEX///+ZmZmWlpaQkJCUlJSbm5v4+PilpaXl5eXz8/O1tbWhoaH8/PzCwsLW1tapqanLy8vd3d2xsbHr6+vGxsbf39/Nzc3v7++6urqtra0jtpVVAAALJUlEQVR4nNVd27ajIAytqXhD0Wqt+v8/eqi21rsQQDj7adasGcoWEnIj3G6mETRRzYqsLbuQUkI8QigNu7LNClZHTWD89w0ijSv2THJKPOjhTfH5K0Lz5MmqOLU9WWkEFcs66q2IrdH/E9plrPpHy9mwNvT8U25znr4XtqyxPXUBBHVLfV+G3ISm79O2dnopY1YSqaXbWkxSstg2kW3ELKGK9L4kaeIeybRq9dAbSbaVS/o1ZR1S9A5I+h1zhWOTgXZ+A0fIXFCuUUJM0PuQJElkl14alZ45fj1Hr4wsbtYo0ahddjmCtXWsEiPit8HRTyoL/Lh+uYZfz/F6nRO86HX8eo70dak5F+XX8us55teJY3DlBp1QhOyiZWQGD8ATjoRdwC9ubfHrObbGTfJHaJMgpxg+jPJLn4ZNGAGK3tOgjRNbXsABEBrbqQ9rKmYOIGZ2Kt+h7sDETg0SNxZwACTaj0ZlEQTwff8+gP9J1WbQLoyRighycpC3BYs+oe00jljRhqBEE4hWI07FjAEvzx4bYfs0fmS5wuGj1cB5EfQ0IHwe+Ohp9AzxC0le2gj6aH7laQg7qEs0R18TxQJJEKAVc82rFsvRL3QQzJBJCGjF3fIGyxEyewRzObvjgfSp1SkWyP3zlD2RA6TJBIobFadkcGcV8sxVUzdIggnOakxxhqEKRYY7B9FmcfpEUcQf/RGOoIqpwVC/iDXgYpRc+Gq2FMPIBRCUGR6gvAlQNRYZ6ldDhDOFFHt1axi1UTHKDSX0oMNQfKF++Sn7Mw/Er3ADQ0dwIcWZUZKxmxijRiHUEz1JURpATttc8RsHuOD74oRQn8+NU6gSoogTwkQbwdsNp8iFRREXVyM6M9EVbp+Kigkqu6QrovAByuaHVmxwlBB4mvToF2mImYSYKghQ9raiOboGykD1iIj1hjtviWaCtxvqQ4sENSIUQS3m2hwo482DU0cqwEWEqP4agoCiGOZnM0F+OQ1BvRVw4nK2mxrUh/M8E6UuEW4q9DhMi/xuuYnUeooTmOP9VCHDstLOmRBwcSkPjowrZJ73XIGhgFPrhwZyhMzBYKIkAghQdg23PnY/ODI0o9ermAI9nz21gNwVyqmDXWCTJrtSU2KzeKbKIrFSA+XOeLjhOENTRZEBNvm8cz6jC2aIsUIzbP3AtmZo0MPlpgje0KXIZMuwQSZ7DapShW21Zdik6KIPI2b3APRX92AtOTifuh/MjM32BtJu87ZiDmmH/1z6vd8vcL5cP6luuYgVegl1R9lmDBVmtbS/FerT3WS4jCzGSM+3H8vFXco94Xl4GBcj/TB0UdOsYqcqBcBOnhbLY1plkzp54r8x26Yqm9RJq62f13SbYv2mAe5Z3gPDiQ+FS1WMcNB76jFJYtRqhfPOecAfQD2OpHgdzbkoxndev0NfRZN67kWiRtDvQI3aZnAumjjC//rBeMfpA7ciwhOG3/NC+VaoW1H9ybw+gqi8GdzKzEzxEZ9KdRzPqezaDIOTqCyGTmVIZ/gIooaR3MlyzzF8eYUIzWQoVyoVFtPqozVKntMIR6pNlug9KB2KxpmKoRXeqkbJN/zBiaqvFXofUflcHeBC5d4avS2i6462/erLDfROga5WMw5U0G5MKtdz7HxGs1wFvQl+UKPThmvYrWTfmVOjxfr7wO5thB1EqjGaGazeKNmZUq1xy3s2bwXtzoipRnuWsHSzaxdQaPEspiNauZ13MJ9MPYSxgI0blgeAVjGgv4Xrb8keAMpbp3tMbgtefNP5EN1Njw0/w8W31Y8Rqsa7N3Fpx4ETUCMMvQu7RpyB6gkWrHFV549TEFMML+recg5yMzSwd0kHHhEYW8M3THdREoG5XTrAaCcsIRBTuvQHU93MBGHstJji3ZEu1N2RThTUhE2zCc1dBYURGrBL3UJnwLdwCty3sNr42Dy4f6jZx3cN3MfXHKdxDVDojou4BmBa46UOAmqdMe/3gO9j747H+6DU+8kjjXkLTo7k7avGvxOXxlX9anOi0R4gjbbc09v8jLS8gceNOn0G67tIRIdzfeJCIFhWepyOvkJbPcAF0DED9TSsU+fYp21VY5Tgd8ZqhJWfAuvz+IoHIuT16UzxqBVlqE+jKNXTACnMvowSvNSiqO9IkdKVp9D8Q0yVSka4r4lSqGvz2yseDEtb/OXP4RYi1rsADelQMTDs6fipCkWm7DS37j8ENqXxSWbiVA3QK99Cq5BPhA1zRNV5X0sQS/F7TQIRyACtVWxCFBEbdbw0gxHE658kRLh5Y02B/J0Z7fWyIpBfiPHOjHTcW7QDo2ZISxPF/ldd9WuykK13myyEZKzmci3zhWRd7eT+odwdUmPXDc8hF/qcNsKUCe2fdyY0B6mujrNeSjI+om/SHzxDLaFPZyV2Eh4UdNbovSHhCM3bRogHawzdphSF+K3LRWW98DY12F5ADMKLuKgDFd6mGgvycRBei0VvE+FD39ClZnGIekIru0uwx5DBTi2iEIx+rnoMiUZrbJkzP4j5GOs+UWKWu5krzXIQuwC94f0I9Wsz2GxHHEKRs41+bUL/0ViPDxmI2DWbSyGUSDT+ZrQAYoF5bvZNFLBrNsTXAgSU4s5NwXMlZcm3X0Lg7N6RplMfymBnNhmcXoza60F7btVadZx+OFU1u97B6X2HlZ1gB2f218F9j7O+THcXVClXpveThTg4004W8e6CKuV77Zjh4ZXrk77698tIHOOE4aEsHRs2/4LhiWV5/L7Fv2B48r7F8VnzHxientmHEcl/wFAgmnt07P8HhgLez4GycZ+hkAN7kMRwn6HQm10H8TrnGYrGOne9E9cZCnt3u+8fOs5Q/P3D3TcsHWco85zsTtTVbYZS0eqdjLnTDCWrC7a7/DjNULbD0aYoOs1Q8k3nbVF0mCEiZbQVtHGXIaoVR7DWNs4yBFxaM15VA7rKELB91KKlQnWVIb5amZF/wZAo1BYsOlC6yVCt6+acopMMVduKzmrlXGSoXkc4DWo4yFBH3n1C0T2GegoLCt9Zhr6mUtdR3VgpYF9jLIzR17v4RcZNYbvoi1uTo9gQjSlp9jXgoBRvb2UGzTcXDyoH/Rrj1Sog0n6YVjx+E9Fc2/OLv91bi3Xe7VfJSMTVhAcf/UUIbRUs1ONnhsTAZ07Htn9ArCicIPu5c+j2mscYZcDzLSxjHfrjFzamC37CCH57bV1G3Po/KTH403ynjr/jFddVZqTF5HcN7dAvHr/oDeSPazimk8aYEBo/reJfZgqgvKLeNJo0VoRLhIP9VBoXR9M2TvMTQN1mzD64ZTjhmJhcxyiZ8LvSKo4mFRvglVpb0/yQRuWk1QDkl5ZgBy8642ikP82MH31dbWU0k6367jH00qsC4lc4Gz+z4dNUybQ/jg+JPj3+SGAS5OOybquwNUqmfY6A26saJDKNuP05G9aoLjudTTlrO9I3/FKRl2DZ5sucHhNGlMwSODA01UUNNbTdnY1GbK7fCK5z/DlJn5SF7Myiolx0ouOjWtEvW0jZsikXZ3nPn49KZIOl1eOZ35d99sDvmBtF1wPSqqXL7mrvDoi0y1jd7LTiS+OmZllHvVWvRADaCn2dSxGzZEWypwkk7JKsYI+oapo4jpumih6syJIuJLDRCJLTS5gbtwJWiFlJNvvkQd8Tk+9kQighXv/n7SaX/HuUrtIbENQt9ZGd8jhx2p62qXcBDWtDT65DJ19iL2yZK6pTAEH1VSGnt7C+Cqn6D4s3RxpX7JnklPQslofB8FeE5smT4Xu6OoGgiWquOduyC+lbzXBlQ8OubLl2raPG/ML9AWeBpRLXHWJQAAAAAElFTkSuQmCC",
        extraFields: {
          accomplishments_text: "None",
          affiliations_text: "None",
          additional_information_text: "None",
          software_text: "None",
          languages_text: "None",
          certifications_text: "None",
          interests_text: "None",
          add_your_own_json: []
        },
        Template: "resume1.png"
      },
      work: [],
      tempwork: [],
      Education: [],
      tempEducation: [],
      Skill_list: [],
      Summary_list: [],
      acc_list: [],
      aff_list: [],
      template_name: "resume1.png",
      skill: [],
      summary: "",
      affiliations: "",
      accomplishments: "",
      additionals: "",
      software: "",
      language: "",
      certificate: "",
      intrest: "",
      isEddesc: true,
      issocial: true,
      isaccomplishment: false,
      isaffilation: false,
      isown: false,
      isadditional: false,
      islang: false,
      issoftware: false,
      iscertificate: false,
      isintrest: false,
      showResume: true,
      showResumetwo: false,
      showResumefour: false,
      showResumefive: false,
      showResumethree: false,
      showResumesix: false,
      showResumeseven: false,
      showResumeeight: false,
      showResumenine: false,
      showResumetwelve: false,
      isfinal: false,
      cvfrom: "create",
      Unique_id: "",
      cities: [],
      customers: [],
      customer,
      customer_ed,
      filename: "",
      maxRating: 5,
      hoveredColor: "rgb(0, 151, 178)",
      previousColor: "rgb(0, 151, 178)"
    };
  },
  created() {
    if (localStorage.getItem("UserPackageDetails")) {
      var pckinfo = [];
      pckinfo = JSON.parse(localStorage.getItem("UserPackageDetails"));
      var access = false;
      pckinfo.forEach(t => {
        if (t.saveCv) {
          if (parseInt(t.noCvs) > parseInt(t.noCv)) {
            access = true;
            return;
          }
        }
      });
      if (access == false) {
        this.$router.push({ path: "ChangePlan" });
      }
    } else {
      this.$router.push({ path: "ChangePlan" });
    }
    this.currentstep = 18;
    this.getCountry();
    this.GetJobTitle();
    this.Unique_id = this.getguid();
  },
  updated() {
    $('[data-toggle="tooltip"]').tooltip();
   
    

    $(function () {
       $('[data-toggle="tooltip"]').tooltip({
           trigger : 'hover'
       });
     
       $('[data-toggle="tooltip"]').on('click', function () {
         $(this).tooltip('hide')
       });
    });
    $(document).ready(function() {
      $(".menu-toggle").click(function() {
        $(".resume-builder-main").toggleClass("active");
      });
    });

    $(window).scroll(function() {
      if ($(this).scrollTop() > 50) {
        $(".resume-builder-right .top").addClass("fixed");
      } else {
        $(".resume-builder-right .top").removeClass("fixed");
      }
    });
    if (this.mmyyyy) {
      this.StartDateChange();
    } else {
      this.StartDateChange_withdd();
    }
    if (this.grad_mmyyyy) {
      this.GradStartDateChange();
    } else {
      this.GradStartDateChange_withdd();
    }

    $("#gradstart_date_selected").addClass("t-valid");
    $("#gradend_date_selected").addClass("t-valid");
    $("#start_date_selected").addClass("t-valid");
    $("#end_date_selected").addClass("t-valid");
  },
  mounted() {
    

    $(document).ready(function() {
      $(".menu-toggle").click(function() {
        $(".resume-builder-main").toggleClass("active");
      });
    });

    $(window).scroll(function() {
      if ($(this).scrollTop() > 50) {
        $(".resume-builder-right .top").addClass("fixed");
      } else {
        $(".resume-builder-right .top").removeClass("fixed");
      }
    });
  },
  computed: {
    ratings() {
      return Array.from({ length: this.maxRating }, (_, i) => i + 1);
    }
  },

  methods: {
    changeBackgroundColor(color) {
      this.hoveredColor = color; // Update hovered color
      this.previewResume();
    },
    CancelTemplatechange() {
      this.hoveredColor = this.previousColor;
      this.showselectedcv();
      $("#ChnageTemplate").modal("hide");
    },
    HandleTemplatechange() {
      if (this.popupresume == 1) {
        this.template_name = "resume1.png";
      }
      if (this.popupresume == 2) {
        this.template_name = "resume2.png";
      }
      if (this.popupresume == 3) {
        this.template_name = "resume3.png";
      }
      if (this.popupresume == 4) {
        this.template_name = "resume4.png";
      }
      if (this.popupresume == 5) {
        this.template_name = "resume5.png";
      }
      if (this.popupresume == 6) {
        this.template_name = "resume6.png";
      }
      if (this.popupresume == 7) {
        this.template_name = "resume7.png";
      }
      if (this.popupresume == 8) {
        this.template_name = "resume8.png";
      }
      if (this.popupresume == 9) {
        this.template_name = "resume9.png";
      }
      if (this.popupresume == 12) {
        this.template_name = "resume10.png";
      }
      if (this.hoveredColor == "") {
        this.hoveredColor = this.previousColor;
      }
      this.showselectedcv();
      this.previousColor = this.hoveredColor;
      $("#ChnageTemplate").modal("hide");
    },
    setRating(rating, item) {
      item.rate = rating;
    },
    addmoreskill() {
      var self = this;
      var skilljson = {
        text: "",
        rate: 0
      };
      self.skill.push(skilljson);
    },
    closeMessage() {
      this.isdisplaymsg = false;
      // this.iserrormsg = false;
    },
    Jumptoheading() {
      this.currentstep = 1;
    },
    Jumptowork() {
      if (this.currentstep == 1) {
        var updatedFile = $("#imgPreview").prop("src");
        if (updatedFile != undefined) {
          this.temp_pic = updatedFile;
          let base64encoded = updatedFile.toString();
          const sIndex = base64encoded.indexOf(";") + "base64,".length + 1;
          base64encoded = base64encoded.substring(sIndex);
          this.pic = base64encoded;
        }
      }
      if (!this.validateprofile()) this.currentstep = 4;
    },
    Jumptoeducation() {
      if (this.currentstep == 1) {
        var updatedFile = $("#imgPreview").prop("src");
        if (updatedFile != undefined) {
          this.temp_pic = updatedFile;
          let base64encoded = updatedFile.toString();
          const sIndex = base64encoded.indexOf(";") + "base64,".length + 1;
          base64encoded = base64encoded.substring(sIndex);
          this.pic = base64encoded;
        }
      }
      if (!this.validateprofile()) this.currentstep = 6;
    },
    Jumptosummary() {
      if (this.currentstep == 1) {
        var updatedFile = $("#imgPreview").prop("src");
        if (updatedFile != undefined) {
          this.temp_pic = updatedFile;
          let base64encoded = updatedFile.toString();
          const sIndex = base64encoded.indexOf(";") + "base64,".length + 1;
          base64encoded = base64encoded.substring(sIndex);
          this.pic = base64encoded;
        }
      }
      if (!this.validateprofile()) this.currentstep = 8;
    },
    Jumptoskill() {
      if (this.currentstep == 1) {
        var updatedFile = $("#imgPreview").prop("src");
        if (updatedFile != undefined) {
          this.temp_pic = updatedFile;
          let base64encoded = updatedFile.toString();
          const sIndex = base64encoded.indexOf(";") + "base64,".length + 1;
          base64encoded = base64encoded.substring(sIndex);
          this.pic = base64encoded;
        }
      }
      if (!this.validateprofile()) this.currentstep = 7;
    },
    Jumptooptional() {
      if (this.currentstep == 1) {
        var updatedFile = $("#imgPreview").prop("src");
        if (updatedFile != undefined) {
          this.temp_pic = updatedFile;
          let base64encoded = updatedFile.toString();
          const sIndex = base64encoded.indexOf(";") + "base64,".length + 1;
          base64encoded = base64encoded.substring(sIndex);
          this.pic = base64encoded;
        }
      }
      if (!this.validateprofile()) this.currentstep = 9;
    },
    Jumptofinal() {
      if (this.currentstep == 1) {
        var updatedFile = $("#imgPreview").prop("src");
        if (updatedFile != undefined) {
          this.temp_pic = updatedFile;
          let base64encoded = updatedFile.toString();
          const sIndex = base64encoded.indexOf(";") + "base64,".length + 1;
          base64encoded = base64encoded.substring(sIndex);
          this.pic = base64encoded;
        }
      }
      if (!this.validateprofile()) {
        this.currentstep = 17;
        this.showselectedcv();
      }
    },
    Delete() {
      this.showCnfrmPopUp = false;
      if (this.delete_what == "Education") {
        this.Education.splice(this.what_index, 1);
        this.tempEducation.splice(this.what_index, 1);
        this.sucessmsgtext = "Deleted successfully";
        this.isdisplaymsg = true;
        setTimeout(xy => {
          this.closeMessage();
        }, 5000);
      }
      if (this.delete_what == "Work") {
        this.work.splice(this.what_index, 1);
        this.tempwork.splice(this.what_index, 1);
        this.sucessmsgtext = "Deleted successfully";
        this.isdisplaymsg = true;
        setTimeout(xy => {
          this.closeMessage();
        }, 5000);
      }
      if (this.delete_what == "Jd") {
        this.err_jd = false;
        this.currentstep = 17;
      }
      if (this.delete_what == "File") {
        this.submitfile();
      }
      if (this.delete_what == "FileNo") {
        this.submitfilesave_asitis();
      }
    },
    ChooseNo() {
      if (this.delete_what == "FileNo") {
        this.showCnfrmPopUp = false;
        this.$router.push({
          path: "/dashboard"
        });
      } else if (this.delete_what == "File") {
        this.showCnfrmPopUp = false;
        this.actionMsg = "Do you want to save the cv as it is?";
        this.delete_what = "FileNo";
        this.showCnfrmPopUp = true;
      } else {
        this.showCnfrmPopUp = false;
      }
    },
    Submitupload() {
      if (document.getElementById("file-5").files[0]) {
        this.actionMsg = "Do you want to edit the cv?";
        this.delete_what = "File";
        this.showCnfrmPopUp = true;
      }
    },
    removeEducation(index) {
      this.actionMsg = "Do you want to remove this education detail?";
      this.delete_what = "Education";
      this.what_index = index;
      this.showCnfrmPopUp = true;
    },
    removeWork(index) {
      this.actionMsg = "Do you want to remove this work experience detail?";
      this.delete_what = "Work";
      this.what_index = index;
      this.showCnfrmPopUp = true;
      // this.work.splice(index, 1);
    },
    validateprofile() {
      this.err_name = false;
      var check = false;
      if (this.First_Name == "") {
        this.err_name = true;
        check = true;
      }
      if (this.Profession == "") {
        this.err_prof = true;
        check = true;
      }
      if (this.Phone != "") {
        if (this.Phone.length < 10) {
          this.err_phone = true;
          check = true;
        }
      }
      if (this.EmailCheck()) {
        check = true;
      }
      return check;
    },
    EmailCheck() {
      if (this.Email != "") {
        if (!this.validateEmail(this.Email)) {
          this.err_email_regex = true;
          return true;
        } else {
          this.err_email_regex = false;
          return false;
        }
      } else {
        this.err_email_regex = true;
        return true;
      }
    },
    onTagcity(new_tag) {
      this.City = new_tag;
      this.showselectedcv();
    },
    onTageddesc(new_tag) {
      this.School_desc = new_tag;
      this.showselectedcv();
    },
    onTagtitle(event) {
      this.Job_Title = event;
      this.filterName = event;
    },
    validateEmail: function(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      var re2 = re.test(email);
      return re2;
    },
    Addyourown() {
      if (this.isown) {
        if (this.add_your_own_json.length > 0) {
          // this.add_your_own_json.forEach(o=>{
          //   if(o.title==''){
          //   }
          // })
        }
        this.own_id = this.own_id + 1;
        var own = { title: "", body: "", id: this.own_id };
        this.add_your_own_json.push(own);
      }
    },
    removeyourown(index) {
      this.add_your_own_json.splice(index, 1);
      this.showselectedcv();
    },
    Handlecarousel(item) {
      this.template_name = item.name;
      this.showselectedcv();
      this.opencarousel = false;
    },
    removeskill(index) {
      this.skill.splice(index, 1);
    },
    getLabel(item) {
      if (item) return item.description;
      else return item;
    },
    location_selected: function(item) {
      if (item) {
        this.customer = item;
        if (this.customer != null) {
          debugger;
          this.Work_City = this.customer.structured_formatting.main_text;
          this.Work_Country = this.customer.terms[
            this.customer.terms.length - 1
          ].value;
          this.showselectedcv();
        }
      }
    },
    location_ED_selected: function(item) {
      if (item) {
        this.customer_ed = item;
        if (this.customer_ed != null) {
          debugger;
          this.School_loc = this.customer_ed.description;
          this.showselectedcv();
          // this.Work_Country = this.customer_ed.terms[
          //   this.customer_ed.terms.length - 1
          // ].value;
        }
      }
    },
    updateItems(text) {
      if (text) {
        var self = this;
        debugger;
        Axios({
          method: "get",
          url: rest_service.baseURL + "/Anonymous/getgoogleplaces",
          // url: "https://localhost:7101/api/Anonymous/getgoogleplaces",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json"
          },
          params: {
            searchtext: text
          }
        })
          .then(function(response) {
            if (response) {
              self.customers = [];
              debugger;
              var converttojson = response.data.result;
              const parsed = JSON.parse(converttojson);
              var filtered_map_locations = parsed.predictions.filter(item => {
                return { description: item.description };
              });
              if (filtered_map_locations.length > 0) {
                self.customers = filtered_map_locations;
              }
            } else {
            }
          })
          .catch(function(error) {
            console.log(error);
            return error;
          });
      }
    },
    isPincode: function(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else if (evt.currentTarget._value.length >= 6) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    isNumber: function(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else if (evt.currentTarget._value.length >= 10) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    GradStartDateChange() {
      $("#gradstart_date_selected").addClass("t-valid");
      if (document.getElementById("div_gradfrom_date_id")) {
        var config = {
          locale: null,
          maxDate: "today",
          altInput: true,
          altFormat: "m/Y",
          //dateFormat: "d/m/Y",
          dateFormat: "m/Y", // Month and year format
          from: null,
          to: null,
          wrap: true
        };
        flatpickr(document.getElementById("div_gradfrom_date_id"), config);
      }
      if (document.getElementById("div_gradend_date_id")) {
        var config = {
          locale: null,
          maxDate: "today",
          altInput: true,
          minDate: document.getElementById("gradstart_date_id").value,
          altFormat: "m/Y",
          //dateFormat: "d/m/Y",
          dateFormat: "m/Y", // Month and year format

          from: null,
          to: null,
          wrap: true
        };
        flatpickr(document.getElementById("div_gradend_date_id"), config);

        this.verifyeddate_mmyyyy();

        this.start_date_message = null;
      }
    },
    GradStartDateChange_withdd() {
      $("#gradstart_date_selected").addClass("t-valid");
      if (document.getElementById("div_gradfrom_date_id")) {
        var config = {
          locale: null,
          maxDate: "today",
          altInput: true,
          altFormat: "d/m/Y",
          dateFormat: "d/m/Y",
          from: null,
          to: null,
          wrap: true
        };
        flatpickr(document.getElementById("div_gradfrom_date_id"), config);
      }
      if (document.getElementById("div_gradend_date_id")) {
        var config = {
          locale: null,
          maxDate: "today",
          altInput: true,
          minDate: document.getElementById("gradstart_date_id").value,
          altFormat: "d/m/Y",
          dateFormat: "d/m/Y",

          from: null,
          to: null,
          wrap: true
        };
        flatpickr(document.getElementById("div_gradend_date_id"), config);
      }
      this.verifyeddate();
    },
    StartDateChange_withdd() {
      $("#start_date_selected").addClass("t-valid");
      if (document.getElementById("div_from_date_id")) {
        var config = {
          locale: null,
          maxDate: "today",
          altInput: true,
          altFormat: "d/m/Y",
          dateFormat: "d/m/Y",
          from: null,
          to: null,
          wrap: true
        };
        flatpickr(document.getElementById("div_from_date_id"), config);
      }
      if (document.getElementById("div_end_date_id")) {
        var config = {
          locale: null,
          maxDate: "today",
          altInput: true,
          minDate: document.getElementById("start_date_id").value,
          altFormat: "d/m/Y",
          dateFormat: "d/m/Y",
          from: null,
          to: null,
          wrap: true
        };
        flatpickr(document.getElementById("div_end_date_id"), config);
      }
      this.verifywork_date();
    },
    StartDateChange() {
      debugger;
      $("#start_date_selected").addClass("t-valid");
      if (document.getElementById("div_from_date_id")) {
        var config = {
          locale: null,
          maxDate: "today",
          altInput: true,
          altFormat: "m/Y",
          // dateFormat: "d/m/Y",
          mode: "single",
          dateFormat: "m/Y", // Month and year format
          from: null,
          to: null,
          wrap: true
        };
        flatpickr(document.getElementById("div_from_date_id"), config);
      }
      if (document.getElementById("div_end_date_id")) {
        var config = {
          locale: null,
          maxDate: "today",
          altInput: true,
          minDate: document.getElementById("start_date_id").value,
          altFormat: "m/Y",
          // dateFormat: "d/m/Y",
          dateFormat: "m/Y", // Month and year format
          from: null,
          to: null,
          wrap: true
        };
        flatpickr(document.getElementById("div_end_date_id"), config);
      }
      this.verifyworkdate_mmyyyy();
      this.start_date_message = null;
    },

    EndDateChange() {
      $("#end_date_selected").addClass("t-valid");
      this.end_date_message = null;
    },
    gradEndDateChange() {
      $("#gradend_date_selected").addClass("t-valid");
      this.end_date_message = null;
    },

    initializeFlatPickr() {
      if (this.currentstep == 2) {
        debugger;
        if (document.getElementById("div_from_date_id")) {
          var config = {
            locale: null,
            maxDate: "today",
            altInput: true,
            altFormat: "F Y",
            //dateFormat: "d/m/Y",
            dateFormat: "m/Y", // Month and year format
            from: null,
            to: null,
            wrap: true
          };
          flatpickr(document.getElementById("div_from_date_id"), config);
        }

        if (document.getElementById("div_end_date_id")) {
          var config = {
            locale: null,
            maxDate: "today",
            altInput: true,
            minDate: "today",
            altFormat: "F Y",
            //dateFormat: "d/m/Y",
            dateFormat: "m/Y", // Month and year format
            from: null,
            to: null,
            wrap: true
          };
          flatpickr(document.getElementById("div_end_date_id"), config);
        }
        //this.StartDateChange();
      }
    },
    getguid() {
      var d = new Date().getTime();
      if (
        typeof performance !== "undefined" &&
        typeof performance.now === "function"
      ) {
        d += performance.now(); //use high-precision timer if available
      }
      var newGuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
        /[xy]/g,
        function(c) {
          var r = (d + Math.random() * 16) % 16 | 0;
          d = Math.floor(d / 16);
          return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
        }
      );
      return newGuid;
    },
    Addnew() {
      this.Work_City = "";
      this.Work_Country = this.countryname;
      this.End_Date = "";
      this.Employer = "";
      this.Job_Title = "";
      this.Start_Date = "";
      this.description = "";
      this.currentwork = false;
      this.customer = {
        description: "",
        matched_substrings: [{ length: 3, offset: 0 }],
        place_id: "ChIJ1dI391YYrjsRL5RdGCCN974",
        reference: "ChIJ1dI391YYrjsRL5RdGCCN974",
        structured_formatting: {
          main_text: "",
          main_text_matched_substrings: [{ length: 3, offset: 0 }],
          secondary_text: "Bengaluru, Karnataka, India"
        },
        terms: [
          { offset: 0, value: "Yelahanka" },
          { offset: 11, value: "Bengaluru" },
          { offset: 22, value: "Karnataka" },
          { offset: 33, value: this.countryname }
        ],
        types: ["sublocality_level_1", "sublocality", "political", "geocode"]
      };
      this.Add_work = true;
      this.Work_id = this.Work_id + 1;
      this.currentstep = 2;
    },
    ReverseWork() {
      debugger;
      var revarray = this.work.reverse();
    },
    addeddescs() {
      var self = this;
      if (self.School_desc.includes(self.Schooldesc)) {
        // self.opeining =self.opeining+ item;
        self.School_desc = self.School_desc.replace(self.Schooldesc, "").trim();
      } else {
        self.School_desc = self.School_desc + "\n \u2022" + self.Schooldesc;
      }
    },
    AddnewEd() {
      this.School_loc = "";
      this.School_name = "";
      this.School_degree = "";
      this.Field_study = "";
      this.Grad_startdate = "";
      this.Grad_Enddate = "";
      this.School_desc = "";
      this.currentstudy = false;
      this.Add_ed = true;
      this.customer_ed = {
        description: "",
        matched_substrings: [{ length: 3, offset: 0 }],
        place_id: "ChIJ1dI391YYrjsRL5RdGCCN974",
        reference: "ChIJ1dI391YYrjsRL5RdGCCN974",
        structured_formatting: {
          main_text: "",
          main_text_matched_substrings: [{ length: 3, offset: 0 }],
          secondary_text: "Bengaluru, Karnataka, India"
        },
        terms: [
          { offset: 0, value: "Yelahanka" },
          { offset: 11, value: "Bengaluru" },
          { offset: 22, value: "Karnataka" },
          { offset: 33, value: this.countryname }
        ],
        types: ["sublocality_level_1", "sublocality", "political", "geocode"]
      };
      this.Ed_id = this.Ed_id + 1;
      this.currentstep = 5;
    },
    skillrepeat(item) {
      var found = false;
      this.skill.forEach(t => {
        if (t.text.includes(item)) {
          found = true;
          return;
        }
      });
      return found;
    },
    removeskillrepeat(attr) {
      var i = this.skill.length;
      while (i--) {
        if (this.skill[i] && this.skill[i].text.includes(attr)) {
          this.skill.splice(i, 1);
        }
      }
    },
    Addskill(item) {
      var self = this;
      if (self.skillrepeat(item)) {
        self.removeskillrepeat(item);
      } else {
        var skilljson = {
          text: item,
          rate: 0
        };
        self.skill.push(skilljson);
      }

      // if (self.skill.includes(item)) {
      //   self.skill = self.skill.replace(item, "").trim();
      // } else {
      //   self.skill = self.skill + "\u2022" + item;
      // }
    },
    Addaccomplish(item) {
      var self = this;
      if (self.accomplishments.includes(item)) {
        // self.opeining =self.opeining+ item;
        self.accomplishments = self.accomplishments.replace(item, "").trim();
      } else {
        self.accomplishments = self.accomplishments + "\u2022" + item;
      }
    },
    Addsummary(item) {
      var self = this;
      if (self.summary.includes(item)) {
        // self.opeining =self.opeining+ item;
        self.summary = self.summary.replace(item, "").trim();
      } else {
        self.summary = self.summary + "\u2022" + item;
      }
    },
    Addaffiliation(item) {
      var self = this;
      if (self.affiliations.includes(item)) {
        // self.opeining =self.opeining+ item;
        self.affiliations = self.affiliations.replace(item, "").trim();
      } else {
        self.affiliations = self.affiliations + "\u2022" + item;
      }
    },
    addworkdesc(item) {
      var self = this;
      if (self.description.includes(item)) {
        // self.opeining =self.opeining+ item;
        self.description = self.description.replace(item, "").trim();
      } else {
        self.description = self.description + "\u2022" + item;
      }
    },
    GetJobTitle() {
      var uid = JSON.parse(localStorage.getItem("loggedinuserobj"));
      var self = this;
      Axios({
        method: "get",
        // url: rest_service.PythonAPI + "/search",
        url: rest_service.baseURL + "/CV/GetAllJobtitle",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + uid.returnedToken
        }
      })
        .then(function(response) {
          if (response.data.result) {
            response.data.result.forEach(e => {
              self.jobtitlelist.push(e.title);
            });
          } else {
            return null;
          }
        })
        .catch(function(error) {
          console.log(error);

          return error;
        });
    },
    previewFiles(event) {
      this.isCorrupt = true;
      var self = this;
      var fileIn = event.target.files[0];
      const fileReader = new FileReader();

      fileReader.onload = () => {
        const image = new Image();

        image.onerror = () => {
          // Image failed to load or is corrupted
          console.log("The selected image is corrupted.");
          self.isCorrupt = false;
          $("#fileUpload").val("");
          return prevent();
          //alert("corrupted");
        };

        image.onload = () => {
          // Image loaded successfully
          console.log("The selected image is valid.");
        };

        image.src = fileReader.result;
      };

      fileReader.readAsDataURL(fileIn);
      self.validateFile();
      if (self.isCorrupt) {
        var file = event.target.files[0];
        if (file) {
          let reader = new FileReader();
          reader.onload = function(event) {
            $("#imgPreview").attr("src", event.target.result);
            self.showselectedcv();
          };
          reader.readAsDataURL(file);
        }
      }
    },
    editworkv1(index, item) {
      debugger;
      this.Work_id = index;
      var found = this.work.find(el => el.id == this.Work_id);
      if (found != undefined) {
        this.work.forEach(e => {
          if (e.id === this.Work_id) {
            this.Work_City = e.city;
            this.Work_Country = e.country;
            this.customer = {
              description: e.city,
              matched_substrings: [{ length: 3, offset: 0 }],
              place_id: "ChIJ1dI391YYrjsRL5RdGCCN974",
              reference: "ChIJ1dI391YYrjsRL5RdGCCN974",
              structured_formatting: {
                main_text: e.city,
                main_text_matched_substrings: [{ length: 3, offset: 0 }],
                secondary_text: "Bengaluru, Karnataka, India"
              },
              terms: [
                { offset: 0, value: "Yelahanka" },
                { offset: 11, value: "Bengaluru" },
                { offset: 22, value: "Karnataka" },
                { offset: 33, value: e.country }
              ],
              types: [
                "sublocality_level_1",
                "sublocality",
                "political",
                "geocode"
              ]
            };

            var format = this.parseDate(e.startdate);
            if (format == 2) {
              this.mmyyyy = true;
            }
            this.End_Date = e.enddate;
            if (this.End_Date == "Present" || this.End_Date == "Current") {
              this.currentwork = true;
            } else {
              this.currentwork = false;
            }
            this.Employer = e.employer;
            this.Job_Title = e.jobtitle;
            this.Start_Date = e.startdate;
            this.description = e.description;
          }
        });
        this.editwork = true;
        this.Add_work = true;
        this.currentstep = this.currentstep - 2;
      }
    },
    parseDate(dateString) {
      if (
        dateString == "" ||
        dateString == "Current" ||
        dateString == "Present"
      ) {
        return 0;
      } else {
        const parts = dateString.split("/");
        if (parts.length === 3) {
          // Format is dd/mm/yyyy
          return 3;
        } else if (parts.length === 2) {
          // Format is mm/yyyy
          return 2;
        }
      }
    },

    editeducationv1(index, item) {
      this.Ed_id = index;
      var found = this.Education.find(el => el.id == this.Ed_id);
      if (found != undefined) {
        this.Education.forEach(e => {
          if (e.id === this.Ed_id) {
            this.Field_study = e.field;
            this.School_degree = e.degree;
            var format = this.parseDate(e.grad_startdate);
            if (format == 2) {
              this.grad_mmyyyy = true;
            }
            this.Grad_startdate = e.grad_startdate;
            this.School_name = e.school_name;
            this.Grad_Enddate = e.grad_enddate;
            if (
              this.Grad_Enddate == "Present" ||
              this.Grad_Enddate == "Current"
            ) {
              this.currentstudy = true;
            } else {
              this.currentstudy = false;
            }
            this.School_desc = e.description;
            this.School_loc = e.school_location;
            this.customer_ed = {
              description: e.school_location,
              matched_substrings: [{ length: 3, offset: 0 }],
              place_id: "ChIJ1dI391YYrjsRL5RdGCCN974",
              reference: "ChIJ1dI391YYrjsRL5RdGCCN974",
              structured_formatting: {
                main_text: "Yelahanka",
                main_text_matched_substrings: [{ length: 3, offset: 0 }],
                secondary_text: "Bengaluru, Karnataka, India"
              },
              terms: [
                { offset: 0, value: "Yelahanka" },
                { offset: 11, value: "Bengaluru" },
                { offset: 22, value: "Karnataka" },
                { offset: 33, value: "India" }
              ],
              types: [
                "sublocality_level_1",
                "sublocality",
                "political",
                "geocode"
              ]
            };
          }
        });
        this.editeducation = true;
        this.Add_ed = true;
        this.currentstep = this.currentstep - 1;
      }
    },
    getCountry() {
      debugger;
      var self = this;
      //  this.browser_country = "IN";
      let urlip =
        "https://api.ipgeolocation.io/ipgeo?apiKey=a86929715b35444b916015f1f1112bac";
      var config = {
        method: "get",
        url: "https://api.ipify.org/?format=json"
      };
      Axios(config)
        .then(function(response) {
          if (response && response.data && response.data.ip) {
            console.log("IP=>", JSON.stringify(response.data));
            //url = url+response.data.ip;
            let cnfg = {
              method: "get",
              url: urlip + "&ip=" + response.data.ip
            };

            Axios(cnfg)
              .then(response => {
                if (response && response.data && response.data.country_name) {
                  if (response.data.country_name) {
                    debugger;
                    // self.browser_country = response.data.country_code2;
                    self.countryname = response.data.country_name;
                    self.Country = self.countryname;
                  }
                }
              })
              .catch(e => {
                console.log("Could not detect any country!", e);
              });
          }
        })
        .catch(function(error) {
          console.log("could not get the ip", error);
        });
    },
    formatDate(date) {
      const options = { day: "2-digit", month: "2-digit", year: "numeric" };
      return date.toLocaleDateString("en-GB", options); // Adjust the locale as needed
    },
    reformat_ddmmyyyy(dateString) {
      const originalDateFormat = "YYYY-MM-DD"; // Replace with the detected format
      const dateParts = dateString.split("-").map(Number); // Split the string and convert to numbers
      const day = dateParts[0];
      const month = dateParts[1] - 1; // Months are zero-based
      const year = dateParts[2];

      const parsedDate = new Date(year, month, day);

      if (isNaN(parsedDate)) {
        // Handle parsing errors
      } else {
        const dd = String(parsedDate.getDate()).padStart(2, "0"); // Day
        const mm = String(parsedDate.getMonth() + 1).padStart(2, "0"); // Month (add 1 as months are zero-based)
        const yyyy = parsedDate.getFullYear(); // Year

        const formattedDate = `${mm}/${yyyy}`;
        return formattedDate;
      }
    },
    reformat_ddmmyyyy2(dateString) {
      const originalDateFormat = "YYYY-MM-DD"; // Replace with the detected format
      const dateParts = dateString.split("/").map(Number); // Split the string and convert to numbers
      const day = dateParts[0];
      const month = dateParts[1] - 1; // Months are zero-based
      const year = dateParts[2];

      const parsedDate = new Date(year, month, day);

      if (isNaN(parsedDate)) {
        // Handle parsing errors
      } else {
        const dd = String(parsedDate.getDate()).padStart(2, "0"); // Day
        const mm = String(parsedDate.getMonth() + 1).padStart(2, "0"); // Month (add 1 as months are zero-based)
        const yyyy = parsedDate.getFullYear(); // Year

        const formattedDate = `${mm}/${yyyy}`;
        return formattedDate;
      }
    },
    reformat_yyyymmdd(dateString) {
      const originalDateFormat = "YYYY-MM-DD"; // Replace with the detected format
      const dateParts = dateString.split("-").map(Number); // Split the string and convert to numbers
      const year = dateParts[0];
      const month = dateParts[1] - 1; // Months are zero-based
      const day = dateParts[2];

      const parsedDate = new Date(year, month, day);

      if (isNaN(parsedDate)) {
        // Handle parsing errors
      } else {
        const dd = String(parsedDate.getDate()).padStart(2, "0"); // Day
        const mm = String(parsedDate.getMonth() + 1).padStart(2, "0"); // Month (add 1 as months are zero-based)
        const yyyy = parsedDate.getFullYear(); // Year

        const formattedDate = `${mm}/${yyyy}`;
        return formattedDate;
      }
    },
    reformat_monthyear(inputDateString) {
      // Parse the input date string into a Date object
      const parsedDate = parse(inputDateString, "MMMM yyyy", new Date());

      // Format the Date object into 'dd/mm/yyyy' format
      const formattedDate = format(parsedDate, "MM/yyyy");

      console.log(formattedDate); // Output: '01/09/2023' (assuming the first day of the month)
      return formattedDate;
    },
    givedate(inputDate) {
      const parts = inputDate.split("/");
      const month = parseInt(parts[1], 10);
      const year = parseInt(parts[2], 10);
      const day = parseInt(parts[0], 10);
      const newDate = new Date(year, month - 1, day);
      return newDate;
    },
    givedate_mmyyyy(inputDate) {
      const parts = inputDate.split("/");
      const month = parseInt(parts[0], 10);
      const year = parseInt(parts[1], 10);
      const day = 1;
      const newDate = new Date(year, month - 1, day);
      return newDate;
    },
    reformat_mmyyyy(inputDate) {
      debugger;
      // Parse the "mm/yyyy" date string into a JavaScript Date object
      const parts = inputDate.split("/");
      const month = parseInt(parts[0], 10);
      const year = parseInt(parts[1], 10);

      // Get the current day (you can modify this if needed)
      const day = 1;

      // Create a new Date object in "dd/mm/yyyy" format
      const newDate = new Date(year, month - 1, day);

      // Format the date to "dd/mm/yyyy" format
      const formattedDate = newDate.toLocaleDateString("en-GB");

      return formattedDate;
    },

    detectdateformat(dateString) {
      debugger;
      const dateFormats = [
        {
          name: "YYYY-MM-DD",
          exp: /\d{4}-\d{2}-\d{2}/
        },
        {
          name: "month year",
          exp: /^(?:\w+|\w{3})\s\d{4}$/
        },
        {
          name: "mm/yyyy",
          exp: /^(0[1-9]|1[0-2])\/\d{4}$/
        },
        {
          name: "dd/mm/yyyy",
          exp: /^(0[1-9]|[1-2][0-9]|3[0-1])\/(0[1-9]|1[0-2])\/\d{4}$/
        },
        {
          name: "dd-mm-yyyy",
          exp: /^(0[1-9]|[1-2][0-9]|3[0-1])-(0[1-9]|1[0-2])-\d{4}$/
        }

        // Add more patterns for other formats
      ];

      let detectedDateFormat;

      for (const format of dateFormats) {
        if (format.exp.test(dateString)) {
          debugger;
          detectedDateFormat = format;
          break;
        }
      }

      if (detectedDateFormat) {
        debugger;
        if (detectedDateFormat.name === "mm/yyyy") {
          // return this.reformat_mmyyyy(dateString);
          return dateString;
        }
        if (detectedDateFormat.name === "dd/mm/yyyy") {
          return this.reformat_ddmmyyyy2(dateString);
        }
        if (detectedDateFormat.name === "dd-mm-yyyy") {
          return this.reformat_ddmmyyyy(dateString);
        }
        if (detectedDateFormat.name === "month year") {
          return this.reformat_monthyear(dateString);
        }
        if (detectedDateFormat.name === "YYYY-MM-DD") {
          return this.reformat_yyyymmdd(dateString);
        }
        // Parse and reformat the date based on detectedDateFormat
      } else {
        // Handle unsupported date formats
        return "";
      }
    },
    verifyworkdate_mmyyyy() {
      debugger;
      if (this.Start_Date != "" && this.End_Date != "") {
        var sdate = this.givedate_mmyyyy(this.Start_Date);
        var edate = this.givedate_mmyyyy(this.End_Date);
        if (sdate > edate) {
          this.End_Date = "";
        }
      }
    },
    verifyeddate_mmyyyy() {
      if (this.Grad_startdate != "" && this.Grad_Enddate) {
        var sdate = this.givedate_mmyyyy(this.Grad_startdate);
        var edate = this.givedate_mmyyyy(this.Grad_Enddate);
        if (sdate > edate) {
          this.Grad_Enddate = "";
        }
      }
    },
    verifywork_date() {
      if (this.Start_Date != "" && this.End_Date != "") {
        var sdate = this.givedate(this.Start_Date);
        var edate = this.givedate(this.End_Date);
        if (sdate > edate) {
          this.End_Date = "";
        }
      }
    },
    verifyeddate() {
      if (this.Grad_startdate != "" && this.Grad_Enddate) {
        var sdate = this.givedate(this.Grad_startdate);
        var edate = this.givedate(this.Grad_Enddate);
        if (sdate > edate) {
          this.Grad_Enddate = "";
        }
      }
    },
    submittocustomize() {
      var self = this;
      if (self.Job_desc != "") {
        self.loadermsg = "Personalizing....";
        self.loader = true;
        self.finished = false;
        var file = {
          work_experience: JSON.stringify(self.work),
          education: JSON.stringify(self.Education),
          skills: self.skill,
          job_description: self.Job_desc
        };
        Axios({
          method: "post",
          url: rest_service.PythonAPI + "/customize_cv_api",
          //url: "https://lin-resumebuilder.careercubicle.com/analyze_cv",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json"
          },
          data: file
        }).then(function(response) {
          if (response.data) {
            debugger;
            var Content = JSON.parse(response.data.content);
            self.skill = self.skill + Content.skills;
            self.summary = self.summary + Content.summary;
            self.Profession = Content.jobtitle;
            self.loadermsg = "Finished";
            self.finished = true;
            setTimeout(xy => {
              self.closeloader();
            }, 3000);
            self.currentstep = 17;
          } else {
            self.loader = false;
            return null;
          }
        });
      } else {
        self.err_jd = true;
      }
    },
    removeSpecialCharacters(str) {
      // Regular expression to remove special characters except letters, numbers, and spaces
      return str.replace(/[^\w\s]/gi, "").replace(/\s+/g, "");
    },
    submitfile() {
      var self = this;
      var tempFiles1 = document.getElementById("file-5").files[0];
      self.loadermsg = "Applying template...";
      self.loader = true;
      self.finished = false;
      const formData = new FormData();
      formData.append("file", tempFiles1);
      Axios({
        method: "post",
        url: rest_service.PythonAPI + "/analyze_cv",
        //url: "https://lin-resumebuilder.careercubicle.com/analyze_cv",
        headers: {
          Accept: "multipart/form-data"
        },
        data: formData
      })
        .then(function(response) {
          debugger;
          if (response.data) {
            var profile = response.data.profile;
            self.First_Name = profile.firstname;
            self.Last_Name = profile.surname;
            self.Email = profile.email;
            self.Linkedin = profile.linkedin;
            self.Address = profile.address;
            self.Pin_code = profile.pincode;
            self.Profession = profile.profession;
            self.Country = profile.country;
            self.City = profile.city;
            if (
              profile.phone != null &&
              profile.phone != "" &&
              profile.phone.length >= 10
            )
              var phonenum = self.removeSpecialCharacters(profile.phone);
            self.Phone = phonenum.substring(phonenum.length - 10);
            if (
              response.data.summary &&
              response.data.summary != "" &&
              response.data.summary != null &&
              response.data.summary != undefined
            ) {
              self.summary = response.data.summary;
            }
            if (response.data.skills != "") {
              const array = response.data.skills.split(",");
              array.forEach(item => {
                var skilljson = {
                  text: item,
                  rate: 0
                };
                self.skill.push(skilljson);
                // self.skill = self.skill + "<br>\u2022" + item;
              });
            }
            // self.skill = response.data.skills;
            debugger;
            var worklist = response.data.work_experience;

            for (var i = 0; i < worklist.length; i++) {
              self.mmyyyy = true;
              self.Work_City = worklist[i].city;
              self.Work_Country = worklist[i].country;
              if (
                worklist[i].enddate == "Present" ||
                worklist[i].enddate == "PRESENT" ||
                worklist[i].enddate == "Current" ||
                worklist[i].enddate == "CURRENT" ||
                worklist[i].enddate == "current" ||
                worklist[i].enddate == "present"
              ) {
                self.End_Date = "Current";
              } else {
                self.End_Date = self.detectdateformat(worklist[i].enddate);
              }
              self.Employer = worklist[i].employer;
              self.Job_Title = worklist[i].jobtitle;
              self.Start_Date = self.detectdateformat(worklist[i].startdate);
              self.description = worklist[i].description;
              self.Work_id = i + 1;

              var workobj = {
                id: self.Work_id,
                city: self.Work_City,
                country: self.Work_Country,
                enddate: self.End_Date,
                employer: self.Employer,
                jobtitle: self.Job_Title,
                startdate: self.Start_Date,
                description: self.description
              };
              self.work.push(workobj);
              self.tempwork.push(workobj);
            }

            var edlist = response.data.education;
            for (var j = 0; j < edlist.length; j++) {
              self.grad_mmyyyy = true;
              self.School_loc = edlist[j].school_location;
              self.School_name = edlist[j].school_name;
              self.School_degree = edlist[j].degree;
              self.Field_study = edlist[j].field;
              self.Grad_startdate = self.detectdateformat(
                edlist[j].grad_startdate
              );
              if (
                edlist[j].grad_enddate == "Present" ||
                edlist[j].grad_enddate == "PRESENT" ||
                edlist[j].grad_enddate == "CURRENT" ||
                edlist[j].grad_enddate == "Current" ||
                edlist[j].grad_enddate == "current" ||
                edlist[j].grad_enddate == "present"
              ) {
                self.Grad_Enddate = "Current";
              } else {
                self.Grad_Enddate = self.detectdateformat(
                  edlist[j].grad_enddate
                );
              }
              self.School_desc = edlist[j].description;
              self.Ed_id = j + 1;
              var edobj = {
                id: self.Ed_id,
                field: self.Field_study,
                degree: self.School_degree,
                grad_startdate: self.Grad_startdate,
                school_name: self.School_name,
                grad_enddate: self.Grad_Enddate,
                description: self.School_desc,
                school_location: self.School_loc
              };
              self.Education.push(edobj);
              self.tempEducation.push(edobj);
            }

            self.School_loc = "";
            self.School_name = "";
            self.School_degree = "";
            self.Field_study = "";
            self.Grad_startdate = "";
            self.Grad_Enddate = "";
            self.School_desc = "";
            self.Ed_id = self.Education.length + 1;
            self.Work_City = "";
            self.Work_Country = self.countryname;
            self.End_Date = "";
            self.Employer = "";
            //self.Job_Title = "";
            self.Start_Date = "";
            self.description = "";
            self.Work_id = self.work.length + 1;
            self.loadermsg = "Finished";
            self.finished = true;
            setTimeout(xy => {
              self.closeloader();
            }, 3000);
            self.currentstep = 1;
          } else {
            self.loader = false;
            return null;
          }
        })
        .catch(function(error) {
          self.loadermsg = "Try Again";
          console.log(error);
          self.previewResume();
          self.loader = false;
          self.currentstep = 1;
          return error;
        });
    },
    submitfilesave_asitis() {
      var self = this;
      var tempFiles1 = document.getElementById("file-5").files[0];
      self.loadermsg = "Saving File...";
      self.loader = true;
      self.finished = false;
      const formData = new FormData();
      formData.append("file", tempFiles1);
      Axios({
        method: "post",
        url: rest_service.PythonAPI + "/analyze_cv",
        //url: "https://lin-resumebuilder.careercubicle.com/analyze_cv",
        headers: {
          Accept: "multipart/form-data"
        },
        data: formData
      })
        .then(function(response) {
          if (response.data) {
            var profile = response.data.profile;
            self.First_Name = profile.firstname;
            self.Last_Name = profile.surname;
            self.Email = profile.email;
            self.Linkedin = profile.linkedin;
            self.Address = profile.address;
            self.Pin_code = profile.pincode;
            self.Profession = profile.profession;
            self.Country = profile.country;
            self.City = profile.city;
            if (
              profile.phone != null &&
              profile.phone != "" &&
              profile.phone.length >= 10
            )
              var phonenum = self.removeSpecialCharacters(profile.phone);
            self.Phone = phonenum.substring(phonenum.length - 10);
            // self.summary = response.data.summary;
            // self.skill = response.data.skills;
            if (
              response.data.summary &&
              response.data.summary != "" &&
              response.data.summary != null &&
              response.data.summary != undefined
            ) {
              self.summary = response.data.summary;
            }
            debugger;
            if (response.data.skills != "") {
              const array = response.data.skills.split(",");
              array.forEach(item => {
                var skilljson = {
                  text: item,
                  rate: 0
                };
                self.skill.push(skilljson);
                //self.skill = self.skill + "<br>\u2022" + item;
              });
            }
            debugger;
            var worklist = response.data.work_experience;

            for (var i = 0; i < worklist.length; i++) {
              self.mmyyyy = true;
              self.Work_City = worklist[i].city;
              self.Work_Country = worklist[i].country;
              if (
                worklist[i].enddate == "Present" ||
                worklist[i].enddate == "PRESENT" ||
                worklist[i].enddate == "Current" ||
                worklist[i].enddate == "CURRENT" ||
                worklist[i].enddate == "current" ||
                worklist[i].enddate == "present"
              ) {
                self.End_Date = "Current";
              } else {
                self.End_Date = self.detectdateformat(worklist[i].enddate);
              }
              self.Employer = worklist[i].employer;
              self.Job_Title = worklist[i].jobtitle;
              self.Start_Date = self.detectdateformat(worklist[i].startdate);
              self.description = worklist[i].description;
              self.Work_id = i + 1;
              debugger;
              var workobj = {
                id: self.Work_id,
                city: self.Work_City,
                country: self.Work_Country,
                enddate: self.End_Date,
                employer: self.Employer,
                jobtitle: self.Job_Title,
                startdate: self.Start_Date,
                description: self.description
              };
              self.work.push(workobj);
              self.tempwork.push(workobj);
            }

            var edlist = response.data.education;
            for (var j = 0; j < edlist.length; j++) {
              self.grad_mmyyyy = true;
              self.School_loc = edlist[j].school_location;
              self.School_name = edlist[j].school_name;
              self.School_degree = edlist[j].degree;
              self.Field_study = edlist[j].field;
              self.Grad_startdate = self.detectdateformat(
                edlist[j].grad_startdate
              );
              if (
                edlist[j].grad_enddate == "Present" ||
                edlist[j].grad_enddate == "PRESENT" ||
                edlist[j].grad_enddate == "CURRENT" ||
                edlist[j].grad_enddate == "Current" ||
                edlist[j].grad_enddate == "current" ||
                edlist[j].grad_enddate == "present"
              ) {
                self.Grad_Enddate = "Current";
              } else {
                self.Grad_Enddate = self.detectdateformat(
                  edlist[j].grad_enddate
                );
              }

              self.School_desc = edlist[j].description;
              self.Ed_id = j + 1;
              var edobj = {
                id: self.Ed_id,
                field: self.Field_study,
                degree: self.School_degree,
                grad_startdate: self.Grad_startdate,
                school_name: self.School_name,
                grad_enddate: self.Grad_Enddate,
                description: self.School_desc,
                school_location: self.School_loc
              };
              self.Education.push(edobj);
              self.tempEducation.push(edobj);
            }
            self.Work_id = self.work.length + 1;
            self.loadermsg = "";
            self.finished = true;
            self.saveResumeasItis();
          } else {
            self.loader = false;
            return null;
          }
        })
        .catch(function(error) {
          console.log(error);
          self.loadermsg = "This file cannot be saved";
          setTimeout(xy => {
            self.closeloader();
          }, 3000);
          return error;
        });
    },
    saveResumeasItis() {
      debugger;
      var fileName = document.getElementById("file-5").value;
      var content = "";
      if (/\.(doc)$/i.test(fileName)) {
        content = ".doc";
      }
      if (/\.(pdf)$/i.test(fileName)) {
        content = ".pdf";
      }
      if (/\.(txt)$/i.test(fileName)) {
        content = ".txt";
      }
      if (/\.(docx)$/i.test(fileName)) {
        content = ".docx";
      }
      if (/\.(html)$/i.test(fileName)) {
        content = ".html";
      }
      var self = this;
      var uid;
      if (localStorage.getItem("loggedinuserobj")) {
        uid = JSON.parse(localStorage.getItem("loggedinuserobj"));
      }
      self.loadermsg = "Saving file...";
      self.loader = true;
      self.finished = false;
      var resume = {};
      resume.profile = {};
      resume.profile.linkedin = self.Linkedin;
      resume.profile.address = self.Address;
      resume.profile.firstname = self.First_Name;
      resume.profile.surname = self.Last_Name;
      resume.profile.email = self.Email;
      resume.profile.pincode = self.Pin_code;
      resume.profile.profession = self.Profession;
      resume.profile.country = self.Country;
      resume.profile.city = self.City;
      resume.profile.phone = self.Phone;
      var acc = "None";
      var aff = "None";
      var add = "None";
      var int = "None";
      var cert = "None";
      var lang = "None";
      var soft = "None";
      var Extrainfo = {
        accomplishments_text: acc,
        affiliations_text: aff,
        additional_information_text: add,
        software_text: soft,
        languages_text: lang,
        certifications_text: cert,
        interests_text: int,
        add_your_own_json: self.add_your_own_json
      };
      //const html = JSON.stringify(pdfContent);
      var tempFiles1 = document.getElementById("file-5").files[0];
      const formData = new FormData();
      formData.append("file", tempFiles1);
      formData.append("UserEmail", uid.user.email);
      formData.append("Profile", JSON.stringify(resume.profile));
      formData.append("WorkExperience", JSON.stringify(self.work));
      formData.append("Education", JSON.stringify(self.Education));
      formData.append("Skills", JSON.stringify(self.skill));
      formData.append(
        "Purchased_Package_id",
        localStorage.getItem("package_uniqueid")
      );
      formData.append(
        "TimeZone",
        Intl.DateTimeFormat().resolvedOptions().timeZone
      );
      formData.append(
        "cvfilename",
        resume.profile.firstname + "_" + resume.profile.surname + "_"
      );
      formData.append("Template", self.template_name);
      formData.append("UniqueId", self.Unique_id);
      formData.append("ExtraFields", JSON.stringify(Extrainfo));
      formData.append("content", content);
      Axios({
        method: "post",
        url: rest_service.baseURL + "/S3proxy/SaveUploadFile",
        //url: "https://localhost:7101/api" + "/S3proxy/SaveUploadFile",
        data: formData,
        headers: {
          Accept: "multipart/form-data",
          Authorization: "Bearer " + uid.returnedToken
        }
      })
        .then(function(response) {
          if (response) {
            //self.closePopUp("goBack");
            self.loadermsg = "Saved";
            self.finished = true;
            setTimeout(xy => {
              self.closeloader();
            }, 3000);
            setTimeout(y => {
              self.navigate();
            }, 1000);
            debugger;
          } else {
            self.loader = false;
            return null;
          }
        })
        .catch(function(error) {
          self.loader = false;
          console.log(error);
          return error;
        });
    },
    navigate() {
      this.$router.push({
        path: "/dashboard"
      });
    },
    closeloader() {
      var self = this;
      self.loader = false;
      self.finished = false;
    },
    populatecitycountry() {
      var self = this;
      var urls =
        "https://maps.googleapis.com/maps/api/geocode/json?address=" +
        this.Pin_code +
        "&key=AIzaSyCI9dR-Xj_nDADm1U_3-v8dzOAJDzkgpRQ";
      Axios({
        method: "get",
        // url: rest_service.PythonAPI + "/search",
        url: urls,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        }
      })
        .then(function(response) {
          if (response.data) {
            const data = response.data;
            if (data.results.length > 0) {
              self.cities = data.results[0].postcode_localities;
              const addressComponents = data.results[0].address_components;
              self.City = addressComponents.find(component =>
                component.types.includes("locality")
              ).long_name;
              self.Country = addressComponents.find(component =>
                component.types.includes("country")
              ).long_name;
              // Use city and country data
            } else {
              self.City = "";
              self.Country = "";
            }
          } else {
            self.City = "";
            self.Country = "";
          }
        })
        .catch(function(error) {
          console.log(error);
          return error;
        });
    },
    validateResumeFile() {
      var fileName = document.getElementById("file-5").value;
      var tempFile = document.getElementById("file-5").files[0].name;
      var dot = fileName.lastIndexOf(".") + 1;
      var extFile = fileName.substr(dot, fileName.length).toLowerCase();
      var tempFiles1 = document.getElementById("file-5").files;
      if (!/\.(doc|pdf|rtf|txt|docx|htm|html)$/i.test(fileName)) {
        $("#file-5").val("");
        this.filename = "";
        return prevent();
      } else {
        this.filename = tempFile;
      }
    },
    validateFile() {
      var fileName = document.getElementById("fileUpload").value;
      var dot = fileName.lastIndexOf(".") + 1;
      var extFile = fileName.substr(dot, fileName.length).toLowerCase();
      var tempFiles1 = document.getElementById("fileUpload").files;
      if (!/\.(gif|jpg|jpeg|png|webp)$/i.test(fileName)) {
        $("#fileUpload").val("");
        return prevent();
      }
      //alert(this.fileCount > this.$store.state.helper.allowedFileSize? "larger":"smaller");
    },
    GetJobdesc(item) {
      var self = this;
      Axios({
        method: "get",
         url: rest_service.PythonAPI + "/job_description",
        //url: "https://resumebuilder.careercubicle.com/job_description",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        },
        params: {
          job_title: item
        }
      })
        .then(function(response) {
          if (response.data) {
            self.WorkDesc = response.data;
            var dataToStore = JSON.stringify(response.data);
          } else {
            return null;
          }
        })
        .catch(function(error) {
          console.log(error);
          return error;
        });
    },
    getSummary(item) {
      var self = this;
      Axios({
        method: "get",
         url: rest_service.PythonAPI + "/search_summary",
       // url: "https://resumebuilder.careercubicle.com" + "/search_summary",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        },
        params: {
          job_title: item
        }
      })
        .then(function(response) {
          if (response.data) {
            self.Summary_list = response.data;
            var dataToStore = JSON.stringify(response.data);
          } else {
            return null;
          }
        })
        .catch(function(error) {
          console.log(error);
          return error;
        });
    },
    getSkilllist(item) {
      var self = this;
      Axios({
        method: "get",
         url: rest_service.PythonAPI + "/search_skills",
        //url: "https://resumebuilder.careercubicle.com" + "/search_skills",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        },
        params: {
          job_title: item
        }
      })
        .then(function(response) {
          if (response.data) {
            self.Skill_list = response.data;
          } else {
            return null;
          }
        })
        .catch(function(error) {
          console.log(error);
          return error;
        });
    },
    getAccomplish(item) {
      var self = this;
      Axios({
        method: "get",
         url: rest_service.PythonAPI + "/accomplishments",
        //url: "https://resumebuilder.careercubicle.com" + "/accomplishments",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        },
        params: {
          job_title: item
        }
      })
        .then(function(response) {
          if (response.data) {
            debugger;
            self.acc_list = response.data;
            var dataToStore = JSON.stringify(response.data);
          } else {
            return null;
          }
        })
        .catch(function(error) {
          console.log(error);
          return error;
        });
    },
    getAffiliate(item) {
      var self = this;
      Axios({
        method: "get",
         url: rest_service.PythonAPI + "/affiliation",
        //url: "https://resumebuilder.careercubicle.com" + "/affiliation",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        },
        params: {
          job_title: item
        }
      })
        .then(function(response) {
          if (response.data) {
            self.aff_list = response.data;
            var dataToStore = JSON.stringify(response.data);
          } else {
            return null;
          }
        })
        .catch(function(error) {
          console.log(error);
          return error;
        });
    },
    validateKeyPress(event) {
      debugger;
      event = event ? event : window.event;
      // Get the keycode of the pressed key
      const keyCode = event.keyCode || event.which;

      // Allow letters (a-z and A-Z) and space (keycode 32)
      if (event.currentTarget._value.length >= 200) {
        event.preventDefault();
      } else if (
        (keyCode >= 65 && keyCode <= 90) || // Uppercase letters
        (keyCode >= 97 && keyCode <= 122) || // Lowercase letters
        keyCode === 32
      ) {
        return true; // Allow the key press
      } else {
        event.preventDefault(); // Prevent any other key presses
      }
    },
    Saveresume() {
      this.previewResume();
      if (this.template_name == "resume1.png") {
        this.$refs.resumeone.saveResume();
      }
      if (this.template_name == "resume2.png") {
        this.$refs.resumetwo.saveResume();
      }
      if (this.template_name == "resume3.png") {
        this.$refs.resumethree.saveResume();
      }
      if (this.template_name == "resume4.png") {
        this.$refs.resumefour.saveResume();
      }
      if (this.template_name == "resume5.png") {
        this.$refs.resumefive.saveResume();
      }
      if (this.template_name == "resume6.png") {
        this.$refs.resumesix.saveResume();
      }
      if (this.template_name == "resume7.png") {
        this.$refs.resumeseven.saveResume();
      }
      if (this.template_name == "resume8.png") {
        this.$refs.resumeeight.saveResume();
      }
      if (this.template_name == "resume9.png") {
        this.$refs.resumenine.saveResume();
      }
      if (this.template_name == "resume10.png") {
        this.$refs.resumetwelve.saveResume();
      }
    },
    previewResumeone() {
      this.previewResume();
      if (this.template_name == "resume1.png") $("#resumeprompt").modal("show");
      if (this.template_name == "resume2.png")
        $("#resumetwoprompt").modal("show");
      if (this.template_name == "resume3.png")
        $("#resumethreeprompt").modal("show");
      if (this.template_name == "resume4.png")
        $("#resumefourprompt").modal("show");
      if (this.template_name == "resume5.png")
        $("#resumefiveprompt").modal("show");
      if (this.template_name == "resume6.png")
        $("#resumesixprompt").modal("show");
      if (this.template_name == "resume7.png")
        $("#resumesevenprompt").modal("show");
      if (this.template_name == "resume8.png")
        $("#resumeeightprompt").modal("show");
      if (this.template_name == "resume9.png")
        $("#resumenineprompt").modal("show");
        if (this.template_name == "resume10.png")
        $("#resumetwelveprompt").modal("show");
    },
    showselectedcv() {
      this.previewResume();
      if (this.template_name == "resume1.png") {
        this.showResume = true;
        this.showResumetwo = false;
        this.showResumethree = false;
        this.showResumefour = false;
        this.showResumefive = false;
        this.showResumesix = false;
        this.showResumeseven = false;
        this.showResumeeight = false;
        this.showResumenine = false;
        this.showResumetwelve = false;
      }
      if (this.template_name == "resume2.png") {
        this.showResume = false;
        this.showResumetwo = true;
        this.showResumethree = false;
        this.showResumefour = false;
        this.showResumefive = false;
        this.showResumesix = false;
        this.showResumeseven = false;
        this.showResumeeight = false;
        this.showResumenine = false;
        this.showResumetwelve = false;
      }
      if (this.template_name == "resume3.png") {
        this.showResume = false;
        this.showResumetwo = false;
        this.showResumethree = true;
        this.showResumefour = false;
        this.showResumefive = false;
        this.showResumesix = false;
        this.showResumeseven = false;
        this.showResumeeight = false;
        this.showResumenine = false;
        this.showResumetwelve = false;
      }
      if (this.template_name == "resume4.png") {
        this.showResume = false;
        this.showResumetwo = false;
        this.showResumethree = false;
        this.showResumefour = true;
        this.showResumefive = false;
        this.showResumesix = false;
        this.showResumeseven = false;
        this.showResumeeight = false;
        this.showResumenine = false;
        this.showResumetwelve = false;
      }
      if (this.template_name == "resume5.png") {
        this.showResume = false;
        this.showResumetwo = false;
        this.showResumethree = false;
        this.showResumefour = false;
        this.showResumefive = true;
        this.showResumesix = false;
        this.showResumeseven = false;
        this.showResumeeight = false;
        this.showResumenine = false;
        this.showResumetwelve = false;
      }
      if (this.template_name == "resume6.png") {
        this.showResume = false;
        this.showResumetwo = false;
        this.showResumethree = false;
        this.showResumefour = false;
        this.showResumefive = false;
        this.showResumesix = true;
        this.showResumeseven = false;
        this.showResumeeight = false;
        this.showResumenine = false;
        this.showResumetwelve = false;
      }
      if (this.template_name == "resume7.png") {
        this.showResume = false;
        this.showResumetwo = false;
        this.showResumethree = false;
        this.showResumefour = false;
        this.showResumefive = false;
        this.showResumesix = false;
        this.showResumeseven = true;
        this.showResumeeight = false;
        this.showResumenine = false;
        this.showResumetwelve = false;
      }
      if (this.template_name == "resume8.png") {
        this.showResume = false;
        this.showResumetwo = false;
        this.showResumethree = false;
        this.showResumefour = false;
        this.showResumefive = false;
        this.showResumesix = false;
        this.showResumeseven = false;
        this.showResumeeight = true;
        this.showResumenine = false;
        this.showResumetwelve = false;
      }
      if (this.template_name == "resume9.png") {
        this.showResume = false;
        this.showResumetwo = false;
        this.showResumethree = false;
        this.showResumefour = false;
        this.showResumefive = false;
        this.showResumesix = false;
        this.showResumeseven = false;
        this.showResumeeight = false;
        this.showResumenine = true;
        this.showResumetwelve = false;
      }
      if (this.template_name == "resume10.png") {
        this.showResume = false;
        this.showResumetwo = false;
        this.showResumethree = false;
        this.showResumefour = false;
        this.showResumefive = false;
        this.showResumesix = false;
        this.showResumeseven = false;
        this.showResumeeight = false;
        this.showResumenine = false;
        this.showResumetwelve=true;
      }
    },
    previewResume() {
      var temp_resumeobj = {};
      temp_resumeobj.profile = {};
      temp_resumeobj.profile.linkedin = this.Linkedin;
      temp_resumeobj.profile.address = this.Address;
      temp_resumeobj.profile.firstname = this.First_Name;
      temp_resumeobj.profile.surname = this.Last_Name;
      temp_resumeobj.profile.email = this.Email;
      temp_resumeobj.profile.pincode = this.Pin_code;
      temp_resumeobj.profile.profession = this.Profession;
      temp_resumeobj.profile.country = this.Country;
      temp_resumeobj.profile.city = this.City;
      temp_resumeobj.profile.phone = this.Phone;
      temp_resumeobj.profile.website = this.Website;
      temp_resumeobj.profile.twitter = this.Twitter;
      temp_resumeobj.profile.color = this.hoveredColor;
      if (this.currentstep == 2 || this.currentstep == 3) {
        debugger;
        var workobj = {
          id: this.Work_id,
          city: this.Work_City,
          country: this.Work_Country,
          enddate: this.End_Date,
          employer: this.Employer,
          jobtitle: this.Job_Title,
          startdate: this.Start_Date,
          description: this.description
        };
        if (this.tempwork.length > 0) {
          var found = this.tempwork.find(el => el.id == this.Work_id);
          if (found != undefined) {
            this.tempwork.forEach(e => {
              if (e.id === this.Work_id) {
                e.city = this.Work_City;
                e.country = this.Work_Country;
                e.enddate = this.End_Date;
                e.employer = this.Employer;
                e.jobtitle = this.Job_Title;
                e.startdate = this.Start_Date;
                e.description = this.description;
              }
            });
          } else {
            this.tempwork.push(workobj);
          }
        } else {
          this.tempwork.push(workobj);
        }

        temp_resumeobj.workExperience = this.tempwork;
      } else {
        if (this.work.length > 0) {
          temp_resumeobj.workExperience = this.work;
        }
      }
      if (this.currentstep == 5) {
        var edobj = {
          id: this.Ed_id,
          field: this.Field_study,
          degree: this.School_degree,
          grad_startdate: this.Grad_startdate,
          school_name: this.School_name,
          grad_enddate: this.Grad_Enddate,
          description: this.School_desc,
          school_location: this.School_loc
        };
        if (this.tempEducation.length > 0) {
          var found = this.tempEducation.find(el => el.id == this.Ed_id);
          if (found != undefined) {
            this.tempEducation.forEach(e => {
              if (e.id === this.Ed_id) {
                e.field = this.Field_study;
                e.degree = this.School_degree;
                e.grad_startdate = this.Grad_startdate;
                e.school_name = this.School_name;
                e.grad_enddate = this.Grad_Enddate;
                e.description = this.School_desc;
                e.school_location = this.School_loc;
              }
            });
          } else {
            this.tempEducation.push(edobj);
          }
        } else {
          this.tempEducation.push(edobj);
        }

        temp_resumeobj.education = this.tempEducation;
      } else {
        if (this.Education.length > 0) {
          temp_resumeobj.education = this.Education;
        }
      }
      temp_resumeobj.skills = this.skill;
      temp_resumeobj.summary = this.summary;
      temp_resumeobj.color = this.hoveredColor;
      temp_resumeobj.Purchased_Package_id = localStorage.getItem(
        "package_uniqueid"
      );
      if (this.currentstep == 1) {
        var updatedFile = $("#imgPreview").prop("src");
        if (updatedFile != undefined) {
          this.temp_pic = updatedFile;
          let base64encoded = updatedFile.toString();
          const sIndex = base64encoded.indexOf(";") + "base64,".length + 1;
          base64encoded = base64encoded.substring(sIndex);
          this.pic = base64encoded;
        }
      }
      temp_resumeobj.pic = this.temp_pic;
      temp_resumeobj.Profile_pic = this.pic;
      var acc = "None";
      var aff = "None";
      var add = "None";
      var int = "None";
      var cert = "None";
      var lang = "None";
      var soft = "None";
      if (this.accomplishments != "") {
        acc = this.accomplishments;
      }
      if (this.affiliations != "") {
        aff = this.affiliations;
      }
      if (this.additionals != "") {
        add = this.additionals;
      }
      if (this.language != "") {
        lang = this.language;
      }
      if (this.software != "") {
        soft = this.software;
      }
      if (this.intrest != "") {
        int = this.intrest;
      }
      if (this.certificate != "") {
        cert = this.certificate;
      }
      if (!this.isown) {
        this.add_your_own_json = [];
      }
      var Extrainfo = {
        accomplishments_text: acc,
        affiliations_text: aff,
        additional_information_text: add,
        software_text: soft,
        languages_text: lang,
        certifications_text: cert,
        interests_text: int,
        add_your_own_json: this.add_your_own_json
      };
      temp_resumeobj.extraFields = Extrainfo;
      if (this.currentstep == 17) {
        this.isfinal = true;
      }
      temp_resumeobj.UniqueId = this.Unique_id;
      temp_resumeobj.Template = this.template_name;
      temp_resumeobj.currentstep = this.currentstep;
      this.resumeobj = temp_resumeobj;
    },
    AddEddesc() {
      this.isEddesc = !this.isEddesc;
      if (this.isEddesc == true) {
        this.School_desc = "";
      }
    },
    AddSociallink() {
      this.issocial = !this.issocial;
    },
    haveResume(item) {
      if (item == "no") {
        this.previewResume();
        this.currentstep = 1;
        this.resumeAlready = false;
      }
      if (item == "yes") {
        this.resumeAlready = true;
        this.currentstep = 19;
      }
    },
    haveJobdesc(item) {
      if (item == "no") {
        this.currentstep = 17;
        this.isJobdesc = false;
      }
      if (item == "yes") {
        this.isJobdesc = true;
        this.currentstep = 21;
      }
    },
    nextstep(item) {
      var check = false;
      if (this.currentstep == 3 && this.editwork == false) {
        var found = this.work.find(el => el.id == this.Work_id);
        if (found != undefined) {
          this.work.forEach(e => {
            if (e.id === this.Work_id) {
              e.city = this.Work_City;
              e.country = this.Work_Country;
              e.enddate = this.End_Date;
              e.employer = this.Employer;
              e.jobtitle = this.Job_Title;
              e.startdate = this.Start_Date;
              e.description = this.description;
            }
          });
        } else {
          var workobj = {
            id: this.Work_id,
            city: this.Work_City,
            country: this.Work_Country,
            enddate: this.End_Date,
            employer: this.Employer,
            jobtitle: this.Job_Title,
            startdate: this.Start_Date,
            description: this.description
          };
          this.work.push(workobj);
        }
      }
      if (this.currentstep == 3 && this.editwork == true) {
        var found = this.work.find(el => el.id == this.Work_id);
        if (found != undefined) {
          this.work.forEach(e => {
            if (e.id === this.Work_id) {
              e.city = this.Work_City;
              e.country = this.Work_Country;
              e.enddate = this.End_Date;
              e.employer = this.Employer;
              e.jobtitle = this.Job_Title;
              e.startdate = this.Start_Date;
              e.description = this.description;
            }
          });
        }
        this.editwork = false;
      }
      if (this.currentstep == 5 && this.editeducation == false) {
        var found = this.Education.find(el => el.id == this.Ed_id);
        if (found != undefined) {
          this.Education.forEach(e => {
            if (e.id === this.Ed_id) {
              e.field = this.Field_study;
              e.degree = this.School_degree;
              e.grad_startdate = this.Grad_startdate;
              e.school_name = this.School_name;
              e.grad_enddate = this.Grad_Enddate;
              e.description = this.School_desc;
              e.school_location = this.School_loc;
            }
          });
        } else {
          var edobj = {
            id: this.Ed_id,
            field: this.Field_study,
            degree: this.School_degree,
            grad_startdate: this.Grad_startdate,
            school_name: this.School_name,
            grad_enddate: this.Grad_Enddate,
            description: this.School_desc,
            school_location: this.School_loc
          };
          this.Education.push(edobj);
        }
      }
      if (this.currentstep == 5 && this.editeducation == true) {
        var found = this.Education.find(el => el.id == this.Ed_id);
        if (found != undefined) {
          this.Education.forEach(e => {
            if (e.id === this.Ed_id) {
              e.field = this.Field_study;
              e.degree = this.School_degree;
              e.grad_startdate = this.Grad_startdate;
              e.school_name = this.School_name;
              e.grad_enddate = this.Grad_Enddate;
              e.description = this.School_desc;
              e.school_location = this.School_loc;
            }
          });
        }
        this.editeducation = false;
      }
      if (this.currentstep == 1) {
        var updatedFile = $("#imgPreview").prop("src");
        if (updatedFile != undefined) {
          this.temp_pic = updatedFile;
          let base64encoded = updatedFile.toString();
          const sIndex = base64encoded.indexOf(";") + "base64,".length + 1;
          base64encoded = base64encoded.substring(sIndex);
          this.pic = base64encoded;
        }
        if (this.validateprofile()) {
          check = true;
        }
      }
      //this.steps = [18, 1, 2, 3, 4, 5, 6, 7, 8, 9];
      this.steps = [18, 1, 4, 6, 7, 8, 9];
      if (this.Add_work) {
        let index = this.steps.indexOf(4);

        this.steps.splice(index, 0, 2);
        this.steps.splice(index + 1, 0, 3);
      }
      if (this.Add_ed) {
        let index = this.steps.indexOf(6);
        this.steps.splice(index, 0, 5);
      }
      if (this.resumeAlready) {
        this.steps.splice(1, 0, 19);
      }
      if (this.isaccomplishment) {
        this.steps.push(10);
      }
      if (this.isaffilation) {
        this.steps.push(11);
      }
      if (this.isadditional) {
        this.steps.push(12);
      }
      if (this.issoftware) {
        this.steps.push(13);
      }
      if (this.islang) {
        this.steps.push(14);
      }
      if (this.iscertificate) {
        this.steps.push(15);
      }
      if (this.isintrest) {
        this.steps.push(16);
      }
      if (this.isown) {
        this.steps.push(20);
      }
      this.steps.push(17);
      if (check == false) {
        for (var i = 0; i < this.steps.length; i++) {
          if (this.steps[i] == item) {
            if (this.steps[i + 2] == 17) {
              this.stepname = "Next: Finalize";
            } else {
              this.stepname = "Save & Continue";
            }
            this.currentstep = this.steps[i + 1];
          }
        }
        if (this.currentstep == 4) {
          this.tempwork = this.work;
        }
        if (this.currentstep == 6) {
          this.tempEducation = this.Education;
        }
      }
    },
    backfromjd() {
      this.actionMsg = "Do you want to go back with customizing your cv?";
      this.delete_what = "Jd";
      this.showCnfrmPopUp = true;
    },
    back(item) {
      if (this.currentstep == 1) {
        var updatedFile = $("#imgPreview").prop("src");
        if (updatedFile != undefined) {
          this.temp_pic = updatedFile;
          let base64encoded = updatedFile.toString();
          const sIndex = base64encoded.indexOf(";") + "base64,".length + 1;
          base64encoded = base64encoded.substring(sIndex);
          this.pic = base64encoded;
        }
      }
      // this.steps = [18, 1, 2, 3, 4, 5, 6, 7, 8, 9];
      this.steps = [18, 1, 4, 6, 7, 8, 9];
      if (this.Add_work) {
        let index = this.steps.indexOf(4);

        this.steps.splice(index, 0, 2);
        this.steps.splice(index + 1, 0, 3);
      }
      if (this.Add_ed) {
        let index = this.steps.indexOf(6);
        this.steps.splice(index, 0, 5);
      }
      debugger;
      if (this.resumeAlready) {
        this.steps.splice(1, 0, 19);
      }

      if (this.isaccomplishment) {
        this.steps.push(10);
      }
      if (this.isaffilation) {
        this.steps.push(11);
      }
      if (this.isadditional) {
        this.steps.push(12);
      }
      if (this.issoftware) {
        this.steps.push(13);
      }
      if (this.islang) {
        this.steps.push(14);
      }
      if (this.iscertificate) {
        this.steps.push(15);
      }
      if (this.isintrest) {
        this.steps.push(16);
      }
      if (this.isown) {
        this.steps.push(20);
      }
      this.steps.push(17);
      debugger;
      for (var i = this.steps.length; i > 0; i--) {
        if (this.steps[i] == item) {
          this.currentstep = this.steps[i - 1];
          if (i == this.steps.length - 1) {
            this.stepname = "Next: Finalize";
          } else {
            this.stepname = "Save & Continue";
          }
        }
      }
      if (this.currentstep == 9) {
        this.showselectedcv();
      }
    },
    Binddata(item) {
      var profile = JSON.parse(item.profile);
      this.First_Name = profile.firstname;
      this.Last_Name = profile.surname;
      this.Email = profile.email;
      this.Pin_code = profile.Pin_code;
      this.Profession = profile.profession;
      this.country = profile.country;
      this.city = profile.city;
      this.Phone = profile.phone;
      var work = JSON.parse(item.workExperience);
    }
  },
  watch: {
    Job_desc(val) {
      if (this.Job_desc != "") this.err_jd = false;
    },
    Job_Title(val) {
      this.filterName = this.Job_Title;
      this.GetJobdesc(this.filterName);
      this.showselectedcv();
    },
    filterName(val) {
      this.GetJobdesc(this.filterName);
      this.getSkilllist(this.filterName);
      this.getSummary(this.filterName);
      this.getAccomplish(this.filterName);
      this.getAffiliate(this.filterName);
    },
    Start_Date(val) {
      this.showselectedcv();
    },
    skill(val) {
      this.showselectedcv();
    },
    summary(val) {
      this.showselectedcv();
    },
    End_Date(val) {
      this.showselectedcv();
    },
    Grad_Enddate(val) {
      this.showselectedcv();
    },
    Grad_startdate(val) {
      this.showselectedcv();
    },
    mmyyyy(val) {
      if (this.mmyyyy) {
        if(this.End_Date!=''&&this.End_Date!=null&&this.End_Date!='Current'){
          var part = this.End_Date.split('/');
          var date = part[1]+'/'+part[2];
          this.End_Date=date;
        }
        if(this.Start_Date!=''&&this.Start_Date!=null){
          var part = this.Start_Date.split('/');
          var date = part[1]+'/'+part[2];
          this.Start_Date=date;
        }
        
      }
      else{
        if(this.End_Date!=''&&this.End_Date!=null&&this.End_Date!='Current'){
          var part = this.End_Date.split('/');
          var date = '01/'+part[0]+'/'+part[1];
          this.End_Date=date;
        }
        if(this.Start_Date!=''&&this.Start_Date!=null){
          var part = this.Start_Date.split('/');
          var date = '01/'+part[0]+'/'+part[1];
          this.Start_Date=date;
        }
      }
    },
    grad_mmyyyy(val) {
      if (this.grad_mmyyyy) {
        if(this.Grad_Enddate!=''&&this.Grad_Enddate!=null&&this.Grad_Enddate!='Current'){
          var part = this.Grad_Enddate.split('/');
          var date = part[1]+'/'+part[2];
          this.Grad_Enddate=date;
        }
        if(this.Grad_startdate!=''&&this.Grad_startdate!=null){
          var part = this.Grad_startdate.split('/');
          var date = part[1]+'/'+part[2];
          this.Grad_startdate=date;
        }
        
      }
      else{
        if(this.Grad_Enddate!=''&&this.Grad_Enddate!=null&&this.Grad_Enddate!='Current'){
          var part = this.Grad_Enddate.split('/');
          var date = '01/'+part[0]+'/'+part[1];
          this.Grad_Enddate=date;
        }
        if(this.Grad_startdate!=''&&this.Grad_startdate!=null){
          var part = this.Grad_startdate.split('/');
          var date = '01/'+part[0]+'/'+part[1];
          this.Grad_startdate=date;
        }
      }
    },
    School_desc(val) {
      this.showselectedcv();
    },
    currentstudy(val) {
      if (this.currentstudy) {
        this.Grad_Enddate = "Current";
      } else {
        this.Grad_Enddate = "";
      }
    },
    currentwork(val) {
      if (this.currentwork) {
        this.End_Date = "Current";
      } else {
        this.End_Date = "";
      }
    },
    currentstep(val) {
      if (this.currentstep == 17) {
        this.showselectedcv();
      }
    }
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
/* theme */
.gray-bg {
  background: #f6f8f7;
}
.white-bg {
  background: #fff;
}
.theme1-bg {
  background: #e56653;
}
body {
  padding: 0px;
  margin: 0px;
  font-family: "Montserrat", sans-serif;
  font-size: 16px;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* Chrome, Safari */
  text-rendering: optimizeLegibility;
  /* Firefox */
  font-weight: 400;
}
img {
  max-width: 100%;
}
h1 {
  font-size: 28px;
  font-weight: 700;
}
h1,
h2,
h3,
h4,
h5,
h6 {
  word-break: break-word;
  line-height: 1.4;
}
p {
  word-break: break-word;
}
button,
input,
optgroup,
select,
textarea {
  font-family: "Montserrat", sans-serif;
}
button:focus {
  outline: none !important;
}
ul,
li {
  list-style: none;
  padding: 0;
  margin: 0;
}
a,
a:hover {
  text-decoration: none;
}
.custom-checkbox {
  display: block;
  position: relative;
  padding-left: 32px;
  margin-bottom: 0 !important;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  line-height: 22px;
}
.custom-checkbox input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}
.custom-checkbox input:checked ~ .checkmark {
  background-color: #e56653;
  border-color: #e56653;
}
.custom-checkbox .checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 20px;
  width: 20px;
  border: 1px solid #dcdcdc;
  border-radius: 5px;
}
.custom-checkbox .checkmark:after {
  content: "";
  position: absolute;
  display: none;
  left: 7px;
  top: 4px;
  width: 4px;
  height: 8px;
  border: solid white;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}
.custom-checkbox input:checked ~ .checkmark:after {
  display: block;
}
[type="radio"]:checked,
[type="radio"]:not(:checked) {
  position: absolute;
  left: -9999px;
}
[type="radio"]:checked + label,
[type="radio"]:not(:checked) + label {
  position: relative;
  padding-left: 28px;
  cursor: pointer;
  line-height: 20px;
  display: inline-block;
  color: #a3a3a3;
}
[type="radio"]:checked + label {
  color: #fff;
}
[type="radio"]:checked + label:before,
[type="radio"]:not(:checked) + label:before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  width: 14px;
  height: 14px;
  border: 1px solid #4e4e4e;
  border-radius: 100%;
  background: none;
}
[type="radio"]:checked + label:before {
  border-color: #fff;
}
[type="radio"]:checked + label:after,
[type="radio"]:not(:checked) + label:after {
  content: "";
  width: 8px;
  height: 8px;
  background: #fff;
  position: absolute;
  top: 4px;
  left: 4px;
  border-radius: 100%;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
[type="radio"]:not(:checked) + label:after {
  opacity: 0;
  -webkit-transform: scale(0);
  transform: scale(0);
}
[type="radio"]:checked + label:after {
  opacity: 1;
  -webkit-transform: scale(1);
  transform: scale(1);
}
.secondary-btn,
.mainNav li a.secondary-btn {
  /* color: #e56653;
  border: 2px solid #e56653;
  padding: 5px 15px;
  border-radius: 20px;
  font-size: 16px;
  display: inline-block;
  transition: all 1s; */
  padding: 9px 15px;
  font-size: 14px;
  font-weight: 500;
  color: #1f85cd;
  border: 2px solid #1f85cd;
  border-radius: 0;
  text-decoration: none;
  transition: 0.5s cubic-bezier(0.4, 0, 0.2, 1);
  min-width: 115px;
  text-align: center;
  cursor: pointer;
}
.secondary-btn:hover,
.mainNav li a.secondary-btn:hover {
  background: #1f85cd;
  color: #fff;
  text-decoration: none;
}
.primary-btn {
  background: #f85656;
  color: #fff;
  font-size: 16px;
  padding: 5px 20px;
  border-radius: 30px;
  font-weight: 500;
  text-decoration: none;
  display: inline-block;
  border: 2px solid #f85656;
  transition: all 1s;
}
.primary-btn:hover,
.primary-btn:focus {
  background: #fff;
  color: #f85656;
  text-decoration: none;
  border-color: #f85656;
}
.white-btn {
  background: #fff;
  color: #f85656;
  font-size: 18px;
  padding: 6px 20px;
  border-radius: 20px;
  font-weight: 600;
  text-decoration: none;
  display: inline-block;
  border: 2px solid #fff;
}
.white-btn:hover,
.white-btn:focus,
.white-btn:active {
  background: none;
  color: #fff;
  text-decoration: none;
  border-color: #fff;
}
a.back-arrow {
  display: flex;
  align-items: center;
  color: #e56653;
  font-weight: 600;
}
a.back-arrow:hover {
  color: #1f85cd;
}
body {
  padding-top: 131px;
}
button:focus {
  outline: none;
}
a:hover {
  color: #ec4747;
  text-decoration: none;
}
/* top header */
.topHeader {
  background: #1f85cd;
  color: #fff;
  width: 100%;
  display: block;
  padding: 8px 0;
  position: fixed;
  top: 0;
  z-index: 9;
}
.topHeader ul {
  margin: 0;
  padding: 0;
}
.topHeader ul li {
  float: right;
  font-size: 18px;
  list-style-type: none;
  font-weight: 500;
  line-height: 36px;
}
.topHeader ul li a {
  color: #fff;
  text-decoration: none;
}
.topHeader ul li a.cart-hold {
  border-left: 0.2px solid #fff;
  padding-left: 20px;
  margin-left: 20px;
  font-size: 16px;
}
.topHeader ul li a.cart-hold .cartIcon {
  width: 25px;
  height: 24px;
  background: url(/assets/cart-white.svg);
  display: inline-block;
  position: relative;
  top: 5px;
}
.topHeader ul li a.cart-hold .cartIcon .cart-count {
  font-size: 11px;
  background: #ec4747;
  padding: 0.5px 5px;
  border-radius: 50%;
  text-align: center;
  position: absolute;
  line-height: 15px;
  top: -10px;
  right: -3px;
  font-weight: 400;
}
/* header */
header {
  z-index: 999;
  width: 100%;
  padding: 0px 0;
  position: fixed;
  top: 52px;
  float: left;
  left: 0;
  right: 0;
  background: #fff;
  transition: all 0.2s ease-in-out 0.2s;
  -webkit-box-shadow: 0 0 10px 0 #000;
  -moz-box-shadow: 0 0 10px 0 rgba(102, 102, 102, 0.3);
  box-shadow: 0 0 10px 0 #000;
}
header.fixed {
  -webkit-box-shadow: 0 0 10px 0 #000;
  -moz-box-shadow: 0 0 10px 0 rgba(102, 102, 102, 0.3);
  box-shadow: 0 0 10px 0 #000;
}
header .logo {
  display: inline-block;
  padding: 10px 0;
}
header .logo img {
  max-width: 85%;
  margin: 6px 0 0;
}
header .mainNav {
  float: right;
  display: table;
  margin-bottom: 0 !important;
  padding: 0;
}
header .mainNav li {
  display: table-cell;
  list-style-type: none;
  font-size: 16px;
  padding: 20px 10px;
  position: relative;
}
header .mainNav li a {
  color: #28292a;
  text-decoration: none;
  font-weight: 600;
  display: inline-block;
  width: 100%;
}
header .mainNav li a:hover {
  color: #1f85cd;
}
header .mainNav li a .arrorDown {
  width: 19px;
  height: 19px;
  display: inline-block;
  background: url(/assets/sprite1.png);
  background-position: -32px -1px;
  position: relative;
  top: 5px;
}
header .mainNav li .subMenu {
  -webkit-transition: all 0.6s;
  -moz-transition: all 0.6s;
  -ms-transition: all 0.6s;
  -o-transition: all 0.6s;
  transition: all 0.6s;
  max-height: 0;
  display: block;
  overflow: hidden;
  padding: 0;
  opacity: 0;
  position: absolute;
  background: #fff;
  min-width: 230px;
}
header .mainNav li .subMenu li {
  width: 100%;
  display: inline-block;
  padding: 0;
}
header .mainNav li .subMenu li a {
  padding: 8px 15px;
}
header .mainNav li .subMenu li a:hover {
  background: #1f85cd;
  color: #fff;
}
header .mainNav li:hover .subMenu {
  max-height: 400px;
  opacity: 1;
  min-width: 230px;
  top: 100%;
  overflow-y: auto;
}
header .mainNav li.active a {
  color: #1f85cd;
}
header .mainNav li:last-child .subMenu {
  right: 0;
}
header .topHeader {
  position: static;
  width: auto;
  float: right;
  background: none;
  display: none;
}
header .header-top-left {
  display: inline-block;
}
header .header-top-left .menu-toggle {
  display: none;
}
header .mainNav li.mobile-top {
  display: none;
}
header span.submenu-icon {
  display: none;
}
/* Banner */
.bannerHold {
  display: table;
  background: url(/assets/banner.jpg);
  background-size: cover;
  width: 100%;
  padding: 5% 0;
  background-attachment: fixed;
}
.bannerHold .bannerContent {
  background: rgba(61, 46, 131, 0.7);
  padding: 30px 15px;
}
.bannerHold .bannerContent h1 {
  font-size: 38px;
  font-weight: 700;
  color: #fff;
  max-width: 820px;
  margin: auto;
  margin-bottom: 20px;
}
.bannerHold .bannerContent p {
  color: #fff;
  max-width: 720px;
  margin: 0 auto 20px;
  font-size: 15px;
  font-weight: 500;
}
.bannerHold .bannerContent .home-cprw-logo {
  margin-left: 15px;
}
.bannerHold.banner-inner {
  padding: 5% 0;
  background: url(/assets/resume-banner.jpg);
}
.bannerHold.banner-inner .bannerContent h1 {
  font-size: 32px;
  max-width: 700px;
}
.bannerHold.banner-inner .bannerContent p {
  color: #fff;
  margin: 0 auto;
  font-size: 22px;
  font-weight: 600;
  max-width: 750px;
  line-height: 1.3;
}
/* buy now */
.sectionHolder {
  width: 100%;
  float: left;
  padding: 40px 0;
}
.sectionHolder h1 {
  font-size: 28px;
  font-weight: 700;
  margin-bottom: 20px;
}
.tabHold .nav-tabs .nav-link {
  background: #f6f8f7;
  color: #212223;
  font-size: 15px;
  font-weight: 600;
  border-color: #e1e3e5;
  border-radius: 0;
}
.tabHold .nav-tabs .nav-link.active {
  color: #e56653;
  border-color: #e56653;
}
.tabHold .cardHold:hover {
  border: 1px solid #1f85cd;
}
.tabHold .cardHold:hover .secondary-btn {
  background: #e56653;
  color: #fff;
  text-decoration: none;
}
.cardHold {
  border: 1px solid #e1e3e5;
  border-radius: 10px;
  padding: 15px 0;
  display: block;
  transition: all 1s;
}
.cardHold h2 {
  font-size: 20px;
  font-weight: bold;
  text-align: center;
  padding: 0px 15px 0 15px;
  line-height: 1.4;
}
.cardHold a.view {
  display: inline-block;
  font-size: 15px;
  color: #1f85cd;
  text-decoration: none;
  font-weight: 500;
}
.radioContent.red {
  width: 100%;
  display: inline-block;
  padding: 10px 15px;
  background: #e56653;
  color: #fff;
}
.radioContent.blue {
  width: 100%;
  display: inline-block;
  padding: 10px 15px;
  background: #1f85cd;
  color: #fff;
}
/* custom radio button */
.cus-radio {
  display: block;
  position: relative;
  padding-left: 35px;
  padding-right: 35px;
  margin-bottom: 0px;
  cursor: pointer;
  font-size: 18px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  font-weight: 600;
}
.cus-radio span:first-child {
  font-weight: normal;
  font-size: 16px;
}
.cus-radio input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}
.cus-radio .checkmark {
  position: absolute;
  top: 15px;
  left: 0;
  height: 22px;
  width: 22px;
  background-color: transparent;
  border: 2px solid #fff;
  border-radius: 50%;
}
.cus-radio input:checked ~ .checkmark {
  background-color: transparent;
}
.cus-radio .checkmark:after {
  content: "";
  position: absolute;
  display: none;
}
.cus-radio input:checked ~ .checkmark:after {
  display: block;
}
.cus-radio .checkmark:after {
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: white;
}
/* owl carousel dots */
.owl-dots {
  text-align: center;
  margin-top: 20px;
}
.owl-carousel button.owl-dot {
  margin: 0 2px;
}
.owl-carousel button.owl-dot span {
  width: 10px;
  height: 10px;
  border: 2px solid #a6a8aa;
  display: inline-block;
  border-radius: 50%;
}
.owl-carousel button.owl-dot.active span {
  background: #e56653;
  border-color: #e56653;
}
.whiteFont .owl-carousel button.owl-dot span {
  border: 2px solid #fff;
}
.whiteFont .owl-carousel button.owl-dot.active span {
  border: 2px solid #fff;
  background: #fff;
}
.whiteFont.mix-dots .owl-carousel button.owl-dot.active span {
  background: #e56653;
  border-color: #e56653;
}
/* how it works */
.sectionHolder h3 {
  font-size: 28px;
  font-weight: 700;
}
.sectionHolder h3.header {
  font-size: 20px;
  margin-bottom: 5px;
}
.sectionHolder h3.discription {
  font-size: 18px;
}
.how-works img {
  margin: 5px auto;
  width: auto !important;
}
.step1 {
  width: 70px;
  height: 70px;
  display: block;
  margin: auto;
  background: url(/assets/howitWork.png);
  background-position: 0 0;
}
.step2 {
  width: 70px;
  height: 70px;
  display: block;
  margin: auto;
  background: url(/assets/howitWork.png);
  background-position: -76px 0;
}
.step3 {
  width: 70px;
  height: 70px;
  display: block;
  margin: auto;
  background: url(/assets/howitWork.png);
  background-position: -164px 0;
}
.step4 {
  width: 70px;
  height: 70px;
  display: block;
  margin: auto;
  background: url(/assets/howitWork.png);
  background-position: -234px 0;
}
/* product details */
.productSlide.text-center {
  padding-top: 45px;
}
.productCard {
  border: 1px solid #c1c2c5;
  border-radius: 5px;
  padding: 0 15px 30px;
  margin-right: 1px;
}
.productCard h4 {
  font-size: 20px;
  font-weight: bold;
  margin: 20px 0;
}
.productCard p {
  font-size: 16px;
  font-weight: 500;
  color: #212223;
  display: block;
  display: -webkit-box;
  max-width: 100%;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  min-height: 72px;
}
.productCard .iconHold {
  width: 90px;
  height: 90px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: auto;
  border: 1px solid #c1c2c5;
  border-radius: 50%;
  position: relative;
  margin-top: -45px;
  background: #fff;
}
.productCard .iconHold img {
  max-width: 40px;
}
.productCard .iconHold .IT-resume-icon {
  width: 40px;
  height: 40px;
  display: block;
  margin: 24px auto;
  background: url(/assets/slider1.png);
  background-position: -4px -3px;
}
.productCard .iconHold .CareerChange-icon {
  width: 42px;
  height: 48px;
  display: block;
  margin: 20px auto;
  background: url(/assets/slider1.png);
  background-position: -61px -3px;
}
.productCard .iconHold .saleMarket-icon {
  width: 48px;
  height: 48px;
  display: block;
  margin: 20px auto;
  background: url(/assets/slider1.png);
  background-position: -111px -5px;
}
.feature-career-tips .productSlide {
  padding-top: 15px;
}
.feature-career-tips .productCard {
  background: #fff;
  min-height: 170px;
  padding: 30px 15px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
}
.feature-career-tips .productCard h5 {
  font-size: 18px;
  font-weight: 600;
  margin: 0 0 20px;
  min-height: 51px;
}
/* testimonial */
.sectionHolder.testimonial-bg h1 {
  margin-bottom: 0;
}
.sectionHolder.testimonial-bg #testimonial h4 {
  font-size: 18px;
  font-weight: 500;
}
.sectionHolder.testimonial-bg #testimonial .quotes {
  max-width: 850px;
  margin: auto;
  font-size: 18px;
  font-weight: 400;
}
.sectionHolder.testimonial-bg #testimonial .quotes p:before {
  content: "“";
  font-size: 50px;
  line-height: 0;
  height: 20px;
  position: relative;
  top: 15px;
  margin-right: 3px;
}
.sectionHolder.testimonial-bg #testimonial .quotes p:after {
  content: "”";
  font-size: 40px;
  font-size: 50px;
  line-height: 0;
  height: 20px;
  position: relative;
  top: 18px;
  margin-left: 6px;
}
/* FAQ */
.faqHold {
  font-size: 16px;
  font-weight: 500;
}
.faqHold .faqContent {
  padding: 0 0px 30px 0px;
}
.faqHold .faqContent .faqHeader {
  border: 0;
  background: transparent;
  font-size: 18px;
  font-weight: bold;
  position: relative;
  width: 100%;
  display: flex;
  align-items: flex-start;
  cursor: pointer;
  padding-left: 0;
  /*&:before {
		 content: "";
		 width: 35px;
		 height: 35px;
		 display: block;
		 position: absolute;
		 border-radius: 50%;
		 left: 0px;
		 background: $blue;
		 margin-top: -3px;
	}
	 &:after {
		 content: "";
		 width: 24px;
		 height: 20px;
		 display: block;
		 position: absolute;
		 border-radius: 50%;
		 left: 9px;
		 background: url(/assets/sprite1.png) no-repeat;
		 background-position: 6px -13px;
		 top: 7px;
		 transition: transform 0.5s ease-in-out;
		 transform: rotate(180deg);
		 background-size: 180px 180px;
	}
	*/
}
.faqHold .faqContent .faqHeader i.material-icons {
  transform: rotate(180deg);
  background: #3d2e83;
  width: 35px;
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  border-radius: 50%;
  line-height: normal;
  direction: inherit;
  white-space: normal;
  transition: transform 0.5s ease-in-out;
  margin: 0 15px 0 0;
  min-width: 35px;
}
.faqHold .faqContent .faqHeader.collapsed {
  /*&:after {
		 transform: rotate(0deg);
		 left: 3px;
		 top: 3px;
	}
	*/
}
.faqHold .faqContent .faqHeader.collapsed i.material-icons {
  transform: rotate(0deg);
}
.faqHold .card-body {
  padding: 0;
  padding-left: 52px;
}
/* count details */
.countHold .count-img {
  min-height: 58px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.countHold .count-img img {
  width: 52px;
}
.countHold h1 {
  font-size: 50px;
  font-weight: bold;
  text-align: center;
}
.countHold h5 {
  text-align: center;
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 0;
}
.count1 {
  width: 90px;
  height: 58px;
  background: url(/assets/counter.png);
  display: block;
  margin: auto;
  background-position: 0 5px;
}
.count2 {
  width: 70px;
  height: 58px;
  background: url(/assets/counter.png);
  display: block;
  margin: auto;
  background-position: -85px -1px;
}
.count3 {
  width: 65px;
  height: 58px;
  background: url(/assets/counter.png);
  display: block;
  margin: auto;
  background-position: -157px 3px;
}
/* article */
.sectionHolder.articlesHold {
  width: 100%;
  display: inline-block;
  background: url(/assets/article.jpg) no-repeat;
  background-size: cover;
}
.sectionHolder.articlesHold .articleContent {
  background: #fff;
  color: #212223;
  padding-left: 15px;
}
.sectionHolder.articlesHold .articleContent .articleContent-inner {
  padding: 15px;
}
.sectionHolder.articlesHold h3 {
  font-size: 20px;
}
.sectionHolder.articlesHold p {
  font-size: 16px;
  font-weight: 500;
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  max-height: 100px;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
}
/* contact */
.contantholder {
  width: 100%;
  display: inline-block;
}
.contantholder h3 {
  font-size: 26px;
  font-weight: bold;
}
.contantholder h3 a {
  font-size: 24px;
  font-weight: bold;
  color: #212223;
  text-decoration: none;
}
.contantholder h4 {
  font-size: 20px;
  font-weight: bold;
  display: inline-block;
  margin-right: 15px;
}
.mobHold {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.mobHold span.mobile-icon {
  width: 90px;
  height: 90px;
  display: inline-block;
  background: #e56653;
  border-radius: 50%;
  margin-right: 15px;
  border: 8px solid #f5c2ba;
  position: relative;
}
.mobHold span.mobile-icon .mobile-ico {
  width: 30px;
  height: 37px;
  background: url(/assets/sprite1.png);
  display: block;
  position: absolute;
  top: 50%;
  left: 50%;
  background-position: -2px -61px;
  margin-left: -15px;
  margin-top: -18px;
}
/* footer */
.footerHold {
  background: #09041f;
  padding: 30px 0;
}
.footerHold ul {
  padding: 0;
  margin: 0;
}
.footerHold ul li {
  list-style-type: none;
  margin-bottom: 2px;
}
.footerHold ul li a {
  color: #fff;
  font-size: 15px;
  font-weight: 300;
}
.footerHold ul li a:hover {
  color: #e56653;
  text-decoration: none;
}
.footerHold ul li.columnHeader {
  font-size: 15px;
  color: #fff;
  font-weight: 600;
}
.footerHold ul.social-icon li {
  display: inline-block;
}
.footerHold ul.social-icon li a {
  width: 40px;
  height: 40px;
  display: block;
  border-radius: 50%;
  margin-left: 5px;
}
.footerHold ul.social-icon li a.twitter {
  background: #57595d url(/assets/sprite1.png);
  background-position: -34px -161px;
}
.footerHold ul.social-icon li a.twitter:hover {
  background: #fff url(/assets/sprite1.png);
  background-position: -1px -161px;
}
.footerHold ul.social-icon li a.linkedIn {
  background: #57595d url(/assets/sprite1.png);
  background-position: -32px -190px;
}
.footerHold ul.social-icon li a.linkedIn:hover {
  background: #fff url(/assets/sprite1.png);
  background-position: 3px -190px;
}
.footerHold ul.social-icon li a.facebook {
  background: #57595d url(/assets/sprite1.png);
  background-position: -31px -217px;
}
.footerHold ul.social-icon li a.facebook:hover {
  background: #fff url(/assets/sprite1.png);
  background-position: 4px -217px;
}
.footerHold hr {
  border-top: 1px solid #342e4e;
  margin: 20px 0;
}
.footer-mid p {
  font-size: 14px;
  color: #fff;
  font-weight: 500;
  margin-bottom: 0;
}
.footer-mid p a {
  color: #fff;
}
.footer-mid p a:hover,
.footer-mid p a:focus {
  color: #e56653;
}
.footer-mid p.location {
  padding-left: 30px;
  position: relative;
}
.footer-mid p.location:before {
  content: " ";
  width: 18px;
  height: 20px;
  display: block;
  position: absolute;
  background: url(/assets/sprite1.png);
  background-position: -9px -144px;
  left: 0;
}
.footer-mid p.phone {
  padding-left: 30px;
  position: relative;
}
.footer-mid p.phone:before {
  content: " ";
  width: 18px;
  height: 20px;
  display: block;
  position: absolute;
  background: url(/assets/sprite1.png);
  background-position: -9px -111px;
  left: 0;
}
.footerbottom {
  background-color: #040110;
  color: #75777b;
  text-align: center;
}
.footerbottom p {
  font-size: 13px;
  font-weight: 500;
  color: #57595d;
  margin: 0;
}
.footerbottom p a {
  color: #75777b;
  font-weight: 600;
}
.footerbottom p a:hover,
.footerbottom p a:focus {
  color: #e56653;
}
/* scroll top */
.scrollTop {
  width: 65px;
  height: 65px;
  display: block;
  position: fixed;
  bottom: 20px;
  background: #1f85cd;
  border-radius: 50%;
  right: 20px;
  cursor: pointer;
  opacity: 0;
  transition: all 0.4s ease-in-out 0s;
  z-index: 9;
}
.scrollTop:after {
  content: " ";
  background: url(/assets/top-arrow.svg);
  display: block;
  height: 65px;
  width: 65px;
  background-size: 100%;
}
.testimonial-bg {
  background: url(/assets/testimonial.jpg);
  background-size: cover;
}
.whiteFont {
  color: #fff;
}
/***************************/
.works-mobile {
  display: none !important;
}
#BuyNowAccordion .card {
  margin-bottom: 15px;
  border: 1px solid #e2e3e5;
  border-radius: 10px;
  overflow: hidden;
}
#BuyNowAccordion .card:last-child {
  margin-bottom: 0;
}
#BuyNowAccordion .card .card-header {
  border: 0;
  border-radius: 10px;
  padding: 0;
}
#BuyNowAccordion .card .card-header .btn-header-link {
  display: block;
  text-align: left;
  background: #f6f8f7;
  color: #e56653;
  padding: 15px 20px;
  font-weight: 600;
  box-shadow: none;
}
#BuyNowAccordion .card .card-header .btn-header-link:after {
  content: "";
  float: right;
  background: url(/assets/sprite1.png);
  background-position: -31px 0px;
  width: 24px;
  height: 20px;
  transition: all 0.5s;
  transform: rotate(180deg);
}
#BuyNowAccordion .card .card-header .btn-header-link.collapsed {
  background: #f6f8f7;
  color: #000;
  font-weight: 600;
  border: 0;
  border-radius: 10px;
  padding: 15px 20px;
}
#BuyNowAccordion .card .card-header .btn-header-link.collapsed:after {
  content: "";
  transform: rotate(0);
}
#BuyNowAccordion .card .collapsing {
  background: #f6f8f7;
  line-height: 30px;
}
#BuyNowAccordion .card .collapse {
  border: 0;
}
#BuyNowAccordion .card .collapse.show {
  background: #f6f8f7;
  line-height: 30px;
  color: #000;
}
.accordionHold {
  display: none;
}
.row.works-desktop {
  margin-top: 30px;
}
h3.footer-heading {
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  display: none;
}
.contentBox p {
  color: #000;
  font-weight: 500;
}
.contentBox ul,
.contentBox ol {
  display: flex;
  flex-wrap: wrap;
}
.contentBox ul li,
.contentBox ol li {
  max-width: 50%;
  width: 100%;
  color: #000;
  font-weight: 600;
  line-height: 24px;
  margin-bottom: 8px;
  background: url(/assets/bullet-arrow.png) no-repeat;
  padding-left: 25px;
  background-position: left 3px;
  background-size: 18px 18px;
}
.contentBox .text-center {
  margin-top: 30px;
}
.contentBox .text-center .secondary-btn {
  background: none;
  font-weight: 600;
  cursor: pointer;
}
.contentBox .text-center .secondary-btn:hover {
  background: #ec4747;
}
.contentBox h4 {
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 15px;
}
.contentBox.content-listing {
  border: 1px solid #ebeded;
  background: #f6f8f7;
  border-radius: 8px;
  padding: 25px 20px;
  margin-bottom: 30px;
}
.imgBox img {
  max-width: 100%;
}
.resume-page h1 {
  color: #1f85cd;
}
.resume-page h2.top-head {
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 15px;
}
.sectionHolder h4.text-center {
  font-size: 18px;
  font-weight: 700;
}
.sectionHolder .blog-box {
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #efefef;
  display: block;
  color: #000;
  margin-bottom: 30px;
  background: #fff;
}
.sectionHolder .blog-box img {
  height: 150px;
  width: 100%;
  object-fit: cover;
}
.sectionHolder .blog-box .blog-content {
  padding: 20px 20px 10px;
}
.sectionHolder .blog-box .blog-content h4 {
  font-size: 18px;
  font-weight: 600;
  min-height: 44px;
}
.sectionHolder .blog-box .blog-content p {
  font-weight: 500;
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  max-height: 95px;
}
.sectionHolder .blog-box .blog-content .blog-footer {
  display: flex;
  justify-content: space-between;
}
.sectionHolder .blog-box .blog-content .blog-footer .blog-author {
  display: flex;
  align-items: center;
}
.sectionHolder .blog-box .blog-content .blog-footer .blog-author img {
  width: 50px;
  height: 50px;
  border-radius: 50%;
}
.sectionHolder .blog-box .blog-content .blog-footer .blog-author span {
  font-weight: 600;
  margin-left: 8px;
  font-size: 12px;
}
.sectionHolder .blog-box .blog-content .blog-footer .blog-date {
  display: flex;
  align-items: center;
}
.sectionHolder .blog-box .blog-content .blog-footer .blog-date img {
  max-width: 26px;
  height: auto;
  width: auto;
  object-fit: contain;
}
.sectionHolder .blog-box .blog-content .blog-footer .blog-date span {
  font-weight: 600;
  color: #e56653;
  margin-left: 8px;
  font-size: 12px;
}
.sectionHolder .blog-box .blog-content span.read-more-link {
  color: #e56653;
  font-weight: 600;
  display: inline-block;
  padding-bottom: 5px;
}
.sectionHolder .cart-block .top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 15px;
}
.sectionHolder .cart-block .top h4 {
  font-weight: 700;
  font-size: 20px;
  margin: 0;
}
.sectionHolder .cart-block .top a {
  color: #e56653;
  font-weight: 500;
}
.sectionHolder .cart-block .cart-box {
  border: 1px solid #f5f5f7;
  border-radius: 5px;
  padding: 20px;
  margin-bottom: 15px;
}
.sectionHolder .cart-block .cart-box .top h4 {
  font-size: 18px;
  font-weight: 600;
}
.sectionHolder .cart-block .cart-box .top > div {
  display: flex;
  align-items: center;
}
.sectionHolder .cart-block .cart-box .top .price {
  font-size: 16px;
}
.sectionHolder .cart-block .cart-box .top .price b {
  margin: 0 20px 0 5px;
}
.sectionHolder .cart-block .cart-box .top a {
  height: 18px;
}
.sectionHolder .cart-block .cart-box .top a i {
  color: #999;
  font-size: 18px;
  font-weight: 600;
}
.sectionHolder .cart-block .cart-box p {
  margin: 0;
  font-weight: 500;
}
.sectionHolder .cart-block .cart-box .price-mobile {
  display: none;
}
.sectionHolder .cart-block .cart-box:hover,
.sectionHolder .cart-block .cart-box.active {
  background: #1f85cd;
  border-color: #1f85cd;
  color: #fff;
}
.sectionHolder .cart-block .cart-box:hover .top a i,
.sectionHolder .cart-block .cart-box.active .top a i {
  color: #fff;
}
.sectionHolder .cart-block .con-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 215px;
  color: #1f85cd;
  border-color: #1f85cd;
  font-weight: 600;
  padding: 5px 15px 5px 8px;
}
.sectionHolder .cart-block .con-btn:hover {
  background: #1f85cd;
  color: #fff;
}
.sectionHolder .cart-block.order-summary .summary-block {
  background: #f6f8f7;
  border: 1px solid #eff1f1;
  border-radius: 5px;
  padding: 25px;
}
.sectionHolder .cart-block.order-summary .summary-block p {
  border-bottom: 1px solid #e3e5e6;
  color: #000;
  font-weight: 500;
  padding-bottom: 8px;
}
.sectionHolder .cart-block.order-summary .summary-block .form-group label {
  color: #000;
  font-weight: 500;
}
.sectionHolder .cart-block.order-summary .summary-block .form-check {
  border-bottom: 2px solid #e3e5e6;
  padding-bottom: 15px;
  margin-bottom: 15px;
}
.sectionHolder .cart-block.order-summary .summary-block .form-check label {
  color: #000;
  font-weight: 500;
}
.sectionHolder .cart-block.order-summary .summary-block .form-check label a {
  color: #1f85cd;
  text-decoration: underline;
}
.sectionHolder .cart-block.order-summary .summary-block .bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.sectionHolder .cart-block.order-summary .summary-block .bottom .total {
  font-weight: 700;
}
.sectionHolder .cart-block.order-summary .summary-block .bottom .primary-btn {
  padding: 5px 20px;
  font-size: 14px;
}
.sectionHolder .contact-left h3 {
  margin-bottom: 20px;
}
.sectionHolder .contact-left p {
  display: flex;
  align-items: center;
  font-size: 16px;
  color: #000;
}
.sectionHolder .contact-left p a {
  color: #000;
}
.sectionHolder .contact-left p:nth-child(2) {
  align-items: flex-start;
}
.sectionHolder .contact-left p img {
  float: left;
  max-width: 30px;
  min-width: 30px;
  margin-right: 15px;
}
.sectionHolder .contact-left p span {
  display: flex;
  flex-wrap: wrap;
}
.sectionHolder .contact-form {
  background: #fff;
  padding: 40px;
  border-radius: 12px;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.2);
}
.sectionHolder .contact-form .form-group label {
  font-weight: 600;
  font-size: 16px;
}
.sectionHolder .contact-form .form-group .form-control {
  padding: 0.75rem 0.75rem;
  background: #e8ecf7;
  border-color: #ced1de;
}
.sectionHolder .contact-form button {
  cursor: pointer;
  background: #1f85cd;
  border-color: #1f85cd;
  padding: 10px 20px;
  font-size: 17px;
  font-weight: 600;
  min-width: 150px;
}
.sectionHolder .contact-form button:hover {
  color: #1f85cd;
  background: #fff;
}
.sectionHolder .map-area {
  margin-top: 30px;
}
.sectionHolder .map-area iframe {
  width: 100%;
  height: 380px;
  border: 1px solid #ddd !important;
  border-radius: 5px;
  padding: 5px;
}
.sectionHolder .terms-section .listgraphics li {
  padding: 10px 0 10px 22px;
  font-size: 16px;
  line-height: 1.4;
  background: url("/assets/bullet-arrow.png") no-repeat 0 13px transparent;
  background-size: 14px 14px;
}
.sectionHolder.latest-news .blog-box .blog-content p {
  font-weight: 500;
  -webkit-line-clamp: 3;
}
#cvPackages .cardHold {
  padding-bottom: 0;
  overflow: hidden;
}
#cvPackages .cardHold h2 {
  min-height: 84px;
}
#cvPackages .cardHold .buy-now-bg {
  background: #e56653;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
}
#cvPackages .cardHold .buy-now-bg .secondary-btn {
  border-color: #fff;
  color: #fff;
}
#cvPackages .cardHold .buy-now-bg .secondary-btn:hover {
  background: #fff;
  color: #e56653;
}
#cvPackages .cardHold:hover {
  border: 1px solid #1f85cd;
}
.pagignation {
  margin: 25px 0;
}
.pagignation ul {
  display: flex;
  align-items: center;
  justify-content: center;
}
.pagignation ul li {
  margin: 0 5px;
}
.pagignation ul li a {
  display: flex;
  border: 1px solid #ddd;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  color: #000;
  font-weight: 500;
  border-radius: 3px;
  font-size: 12px;
}
.pagignation ul li a:hover,
.pagignation ul li a.active {
  background: #1f85cd;
  border-color: #1f85cd;
  color: #fff;
}
.pagignation ul li:first-child a,
.pagignation ul li:last-child a {
  width: auto;
  height: auto;
  border: none;
  opacity: 0.5;
}
.pagignation ul li:first-child a:hover,
.pagignation ul li:last-child a:hover {
  background: none;
  border: none;
  color: #000;
}
.pagignation ul li.next a {
  opacity: 1;
}
.testimonial-sec .nav-tabs {
  border-bottom: none;
  justify-content: center;
  margin-bottom: 40px;
}
.testimonial-sec .testimonical-block {
  background: #fff;
  padding: 20px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  margin-bottom: 30px;
  display: flex;
}
.testimonial-sec .testimonical-block img {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  /*border: 2px solid $blue;
	*/
  margin-bottom: 15px;
  margin-right: 20px;
}
.testimonial-sec .testimonical-block p {
  font-style: italic;
  margin: 0;
}
.testimonial-sec .testimonical-block span {
  display: block;
  font-weight: 600;
  font-style: italic;
  margin: 15px 0 0;
}
.resume-sample {
  /*.sticky-sec {
		 &.fixed {
			 .resume-left-block {
				 position: sticky;
				 top: 150px;
			}
		}
	}
	*/
}
.resume-sample a.cat-select {
  display: none;
  align-items: center;
  justify-content: center;
  max-width: 200px;
  border: 2px solid #1f85cd;
  padding: 5px;
  border-radius: 30px;
  color: #1f85cd;
  font-weight: 600;
  font-size: 14px;
}
.resume-sample .resume-left-block {
  border: 1px solid #ebeded;
  background: #f6f8f7;
  border-radius: 8px;
  /*max-height: calc(100vh - 190px);
	 overflow: auto;
	*/
}
.resume-sample .resume-left-block .box {
  text-align: center;
  padding: 28px 25px;
  border-bottom: 1px solid #ebeded;
  /*.after-before-sec {
		 display: flex;
		 align-items: center;
		 justify-content: center;
		 i {
			 font-size: 20px;
			 margin-right: 8px;
			 color: #dadedd;
		}
		 & > div {
			 display: flex;
			 align-items: center;
			 justify-content: center;
			 color: $black;
			 font-weight: $fw-600;
			 font-size: 15px;
			 cursor: pointer;
			 &:first-child {
				 border-right: 1px solid $black;
				 padding-right: 10px;
				 margin-right: 10px;
			}
		}
	}
	 &.active {
		 background: $white;
		 .after-before-sec {
			 .active {
				 color: $theme1;
				 i {
					 color: $theme1;
				}
			}
		}
	}
	 */
}
.resume-sample .resume-left-block .box:last-child {
  border-bottom: none;
}
.resume-sample .resume-left-block .box h4 {
  font-size: 18px;
  font-weight: 700;
  margin: 0 0 12px;
}
.resume-sample .resume-left-block .box .after-before-sec {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  position: relative;
  padding: 4px;
  border: 1px solid lightgrey;
  border-radius: 30px;
  background: #fff;
}
.resume-sample .resume-left-block .box .after-before-sec > div {
  font-size: 15px;
  z-index: 1;
  min-width: 100px;
  line-height: 32px;
  font-weight: 600;
  cursor: pointer;
  border-radius: 30px;
  transition: color 0.25s ease-in-out;
  position: relative;
  color: #000;
  overflow: hidden;
}
.resume-sample .resume-left-block .box .after-before-sec > div i {
  display: none;
}
.resume-sample .resume-left-block .box .after-before-sec > div:after {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 30px;
  background: #e56653;
  transition: transform 0.25s ease-in-out;
  content: "";
  color: #fff;
  z-index: -1;
  transform: translateX(-110%);
}
.resume-sample .resume-left-block .box .after-before-sec > div.active {
  color: #fff;
}
.resume-sample .resume-left-block .box .after-before-sec > div.active:after {
  transform: translateX(0);
}
.resume-sample .resume-left-block .box.active {
  background: #fff;
}
.resume-sample .resume-sample-right {
  border: 1px solid #ebeded;
  background: #fff;
  border-radius: 8px;
  padding: 90px 30px 25px;
  position: relative;
}
.resume-sample .resume-sample-right .resume-icon {
  position: absolute;
  left: -15px;
  top: 25px;
}
.resume-sample .resume-sample-right div {
  border-bottom: 1px solid #000;
  padding-bottom: 20px;
  margin-bottom: 20px;
}
.resume-sample .resume-sample-right div > img {
  border-radius: 8px;
  border: 1px solid #dcdcdc;
}
.resume-sample .resume-sample-right div:last-child {
  border-bottom: none;
  padding-bottom: 0;
  margin-bottom: 0;
}
.resume-sample .resume-sample-right div p,
.resume-sample .resume-sample-right div ul,
.resume-sample .resume-sample-right div li {
  font-weight: 500;
  margin: 0;
}
.resume-sample .resume-sample-right div h4 {
  text-transform: uppercase;
  font-weight: 700;
  font-size: 16px;
  margin: 0 0 10px;
}
.resume-sample .resume-sample-right div h5 {
  font-weight: 600;
  font-size: 14px;
  margin: 0 0 2px;
}
.resume-sample .resume-sample-right div ul {
  margin: 10px 0 20px;
  padding-left: 15px;
}
.resume-sample .resume-sample-right div ul li {
  list-style: disc outside;
}
.shopping-cart {
  padding-bottom: 0;
}
.shopping-cart .cart-step {
  border: 1px solid #ebeded;
  background: #f6f8f7;
  border-radius: 8px;
  padding: 15px 25px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 0 25px;
}
.shopping-cart .cart-step > div {
  display: flex;
}
.shopping-cart .cart-step .step {
  text-align: center;
  font-weight: 700;
  font-size: 15px;
}
.shopping-cart .cart-step .step span {
  background: #1f85cd;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  border: 5px solid #aca6c8;
  font-weight: 700;
  font-size: 18px;
  margin: 0 auto 6px;
}
.shopping-cart .cart-step .step > div {
  display: flex;
  align-items: center;
}
.shopping-cart .cart-step .step > div .material-icons {
  display: none;
}
.shopping-cart .col-lg-4 .cart-step {
  justify-content: center;
}
.shopping-cart a.cat-select {
  display: none;
  align-items: center;
  justify-content: center;
  max-width: 200px;
  border: 2px solid #1f85cd;
  padding: 5px;
  border-radius: 30px;
  color: #1f85cd;
  font-weight: 600;
  font-size: 14px;
}
.shopping-cart .shopping-cart-left {
  border: 1px solid #ebeded;
  background: #f6f8f7;
  border-radius: 8px;
}
.shopping-cart .shopping-cart-left .box {
  padding: 25px 40px;
  border-bottom: 1px solid #ebeded;
  cursor: pointer;
}
.shopping-cart .shopping-cart-left .box:last-child {
  border-bottom: none;
}
.shopping-cart .shopping-cart-left .box h4 {
  font-weight: 700;
  font-size: 16px;
}
.shopping-cart .shopping-cart-left .box h5 {
  font-weight: 600;
  font-size: 16px;
}
.shopping-cart .shopping-cart-left .box.active {
  background: #fff;
}
.shopping-cart .shopping-cart-left .box.active h4 {
  color: #1f85cd;
}
.shopping-cart .shopping-cart-left .box.active h5 {
  color: #e56653;
}
.shopping-cart .shopping-cart-right h2 {
  font-weight: 700;
  font-size: 18px;
  margin: 0 0 15px;
}
.shopping-cart .shopping-cart-right .resume-service-box {
  margin-bottom: 15px;
}
.shopping-cart .shopping-cart-right .resume-service-box .resume-inner-box {
  border: 1px solid #ebeded;
  background: #f6f8f7;
  border-radius: 8px;
  padding: 0 15px;
  display: flex;
  align-items: center;
}
.shopping-cart .shopping-cart-right .resume-service-box .resume-inner-box > h5 {
  min-width: 230px;
  max-width: 230px;
}
.shopping-cart
  .shopping-cart-right
  .resume-service-box
  .resume-inner-box
  .primary-btn {
  padding: 5px 15px;
}
.shopping-cart .shopping-cart-right .resume-service-box .resume-inner-box h5 {
  font-size: 14px;
  font-weight: 600;
  margin: 0;
}
.shopping-cart
  .shopping-cart-right
  .resume-service-box
  .resume-inner-box
  h5
  span {
  display: block;
  color: #fff;
  margin: 3px 0 0;
}
.shopping-cart
  .shopping-cart-right
  .resume-service-box
  .resume-inner-box
  .cus-radio {
  margin: 0 18px;
}
.shopping-cart
  .shopping-cart-right
  .resume-service-box
  .resume-inner-box
  .cus-radio
  span {
  font-size: 14px;
  font-weight: 600;
}
.shopping-cart
  .shopping-cart-right
  .resume-service-box
  .resume-inner-box
  .cus-radio
  span:nth-child(2) {
  font-size: 12px;
}
.shopping-cart
  .shopping-cart-right
  .resume-service-box
  .resume-inner-box
  .cus-radio
  .checkmark {
  border-color: #1f85cd;
}
.shopping-cart
  .shopping-cart-right
  .resume-service-box
  .resume-inner-box
  .cus-radio
  .checkmark:after {
  background: #1f85cd;
}
.shopping-cart
  .shopping-cart-right
  .resume-service-box
  .resume-inner-box
  .cus-radio:first-child
  span:nth-child(2) {
  color: #e56653;
}
.shopping-cart
  .shopping-cart-right
  .resume-service-box
  .resume-inner-box
  .cus-radio:last-child
  span:nth-child(2) {
  color: #1f85cd;
}
.shopping-cart
  .shopping-cart-right
  .resume-service-box
  .resume-inner-box
  > div {
  display: flex;
}
.shopping-cart
  .shopping-cart-right
  .resume-service-box
  .resume-inner-box
  > div
  h5 {
  padding: 10px 20px;
  color: #fff;
}
.shopping-cart
  .shopping-cart-right
  .resume-service-box
  .resume-inner-box
  > div
  h5:last-child
  span {
  color: #fff;
}
.shopping-cart
  .shopping-cart-right
  .resume-service-box
  .resume-inner-box
  > div
  h5:first-child {
  background: #e56653;
}
.shopping-cart
  .shopping-cart-right
  .resume-service-box
  .resume-inner-box
  > div
  h5:last-child {
  background: #1f85cd;
}
.shopping-cart .shopping-cart-right .resume-service-box ul {
  background: #f6f8f7;
  padding: 8px 15px;
}
.shopping-cart .shopping-cart-right .resume-service-box ul li {
  max-width: 100%;
  width: 100%;
  color: #000;
  font-weight: 500;
  line-height: 24px;
  font-size: 13px;
  margin-bottom: 5px;
  background: url(/assets/bullet-arrow.png) no-repeat;
  padding-left: 25px;
  background-position: left 7px;
  background-size: 12px 12px;
}
.shopping-cart .shopping-cart-right .resume-service-box.resume-white {
  border: 1px solid #ebeded;
  background: #f6f8f7;
  border-radius: 8px;
  overflow: hidden;
}
.shopping-cart
  .shopping-cart-right
  .resume-service-box.resume-white
  .resume-inner-box {
  border: none;
  background: #fff;
  border-radius: 0;
  padding: 10px 15px 15px;
}
.shopping-cart .shopping-cart-right .career-services-box {
  border: 1px solid #ebeded;
  border-radius: 8px;
  text-align: center;
  padding: 25px 0 0;
}
.shopping-cart .shopping-cart-right .career-services-box h5 {
  font-size: 13px;
  font-weight: 700;
}
.shopping-cart .shopping-cart-right .career-services-box .primary-btn {
  margin: 15px 0;
}
.shopping-cart .shopping-cart-right .career-services-box ul {
  background: #f6f8f7;
  padding: 8px 15px;
}
.shopping-cart .shopping-cart-right .career-services-box ul li {
  max-width: 100%;
  width: 100%;
  color: #000;
  font-weight: 500;
  line-height: 24px;
  font-size: 13px;
  margin-bottom: 5px;
  background: url(/assets/bullet-arrow.png) no-repeat;
  padding-left: 25px;
  background-position: left 7px;
  background-size: 12px 12px;
  text-align: left;
}
.shopping-cart .payment-details-sec {
  background: #f6f8f7;
  padding: 60px 0;
  margin-top: 50px;
}
.shopping-cart .payment-details-sec .row {
  margin-left: -7.5px;
  margin-right: -7.5px;
}
.shopping-cart .payment-details-sec .row .col-md-3,
.shopping-cart .payment-details-sec .row .col-md-12,
.shopping-cart .payment-details-sec .row .col-sm-6 {
  padding-left: 7.5px;
  padding-right: 7.5px;
}
.shopping-cart .payment-details-sec .block {
  background: #fff;
  border: 1px solid #e3e4e7;
  border-radius: 8px;
  padding: 20px 15px;
  text-align: center;
  min-height: 187px;
}
.shopping-cart .payment-details-sec .block h3 {
  color: #1f85cd;
  font-size: 16px;
  margin-bottom: 15px;
}
.shopping-cart .payment-details-sec .block h4 {
  font-size: 13px;
  font-weight: 600;
}
.shopping-cart .payment-details-sec .block img {
  margin: 10px 0;
}
.shopping-cart .payment-details-sec .block a {
  color: #e56653;
}
.shopping-cart .payment-details-sec .block span {
  color: #e56653;
}
.shopping-cart .payment-details-sec .block p {
  font-weight: 600;
  margin: 0;
  font-size: 13px;
}
.shopping-cart .payment-details-sec .block.bottom-block {
  text-align: left;
  min-height: inherit;
  margin-top: 25px;
}
.shopping-cart .payment-details-sec .block.bottom-block .bottom-block-inner {
  display: flex;
}
.shopping-cart
  .payment-details-sec
  .block.bottom-block
  .bottom-block-inner
  > div {
  max-width: 280px;
  width: 100%;
  margin-right: 40px;
}
.shopping-cart
  .payment-details-sec
  .block.bottom-block
  .bottom-block-inner
  > div:nth-child(2) {
  max-width: 220px;
}
.shopping-cart
  .payment-details-sec
  .block.bottom-block
  .bottom-block-inner
  > div:nth-child(3) {
  max-width: 150px;
}
.shopping-cart
  .payment-details-sec
  .block.bottom-block
  .bottom-block-inner
  > div:last-child {
  margin-right: 0;
}
.inner-pages .top-heading {
  border: 1px solid #ebeded;
  background: #f6f8f7;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px;
}
.inner-pages .top-heading h2 {
  font-size: 20px;
  font-weight: 700;
  margin: 0;
}
.inner-pages .top-heading .primary-btn {
  padding: 5px 20px;
  font-size: 14px;
  font-weight: 600;
  text-align: center;
}
.inner-pages .left-testimonial {
  border: 1px solid #ebeded;
  background: #f6f8f7;
  border-radius: 8px;
  padding: 30px;
  text-align: center;
}
.inner-pages .left-testimonial .box p {
  font-weight: 600;
  font-size: 14px;
}
.inner-pages .left-testimonial .box span {
  color: #1f85cd;
  font-weight: 600;
  font-size: 13px;
}
.inner-pages .left-testimonial .primary-btn {
  padding: 5px 20px;
  font-size: 14px;
  font-weight: 600;
  margin-top: 20px;
}
.inner-pages .inner-left-sec {
  text-align: center;
  margin: 25px 0;
}
.inner-pages .inner-left-sec .purple-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 200px;
  font-size: 14px;
  padding: 4px 15px;
  margin: 20px auto 0;
  background: #1f85cd;
  border-color: #1f85cd;
}
.inner-pages .inner-left-sec .purple-btn i {
  margin-left: 5px;
}
.inner-pages .inner-left-sec .purple-btn:hover {
  color: #1f85cd;
  background: #fff;
}
.inner-pages .career-list {
  margin: 30px 0;
}
.inner-pages .career-list p {
  margin: 15px 0;
  font-weight: 500;
  font-size: 16px;
}
.inner-pages .career-list h6 {
  font-weight: 600;
  margin: 15px 0;
  font-size: 20px;
}
.inner-pages .career-list .contentBox {
  margin-top: 20px;
}
.inner-pages .career-list .contentBox ul li {
  max-width: 100%;
  font-weight: 500;
  font-size: 16px;
  background-position: left 5px;
  background-size: 13px 13px;
}
.inner-pages .career-list table.table {
  border: 1px solid #ebeded;
}
.inner-pages .career-list table.table td,
.inner-pages .career-list table.table th {
  border-top: 1px solid #ebeded;
  font-weight: 500;
  font-size: 16px;
  min-width: 200px;
}
.inner-pages .career-list table.table th {
  background: #f6f8f7;
  font-size: 16px;
  font-weight: 600;
}
.inner-pages .career-list table.table .contentBox {
  margin: 0;
}
.inner-pages .career-list table.table .contentBox ul li {
  font-size: 16px;
  background-position: left 5px;
}
.inner-pages .career-list table.table .contentBox h6 {
  font-size: 16px;
  margin: 0 0 10px;
}
.inner-pages .career-list table.table.last .contentBox h6 {
  display: none;
}
.how-to-order .top-heading {
  border-radius: 8px 8px 0 0;
}
.how-to-order .career-list {
  margin: 0 0 20px;
}
.how-to-order .career-list-top {
  margin: 0;
  border: 1px solid #ebeded;
  background: #fff;
  border-radius: 0 0 8px 8px;
  border-top: none;
}
.how-to-order .career-list-top p.top {
  padding: 20px;
  font-weight: 700;
}
.how-to-order .career-list-top p {
  margin: 0;
}
.how-to-order .career-list-top ul {
  margin-top: 20px;
}
.how-to-order .career-list-top ul li {
  display: flex;
  border-bottom: 1px solid #ebeded;
  margin-bottom: 25px;
  padding: 0 20px 25px;
}
.how-to-order .career-list-top ul li span {
  background: #1f85cd;
  width: 50px;
  height: 50px;
  min-width: 50px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  border: 5px solid #aca6c8;
  font-weight: 700;
  font-size: 18px;
  margin: 0 15px 0 0;
}
.how-to-order .career-list-top ul li h6 {
  margin: 0 0 10px;
  font-size: 16px;
  font-weight: 700;
}
.how-to-order .career-list-top ul li:last-child {
  margin-bottom: 0;
  border-bottom: none;
}
.how-to-order .how-order-text {
  margin-top: 25px;
}
.how-to-order .how-order-text p {
  margin: 15px 0;
  font-weight: 500;
  font-size: 16px;
}
.how-to-order .how-order-text h6 {
  font-weight: 600;
  margin: 15px 0;
}
.resume-analysis .top-heading {
  display: block;
}
.resume-analysis .top-heading p {
  margin: 8px 0 0;
  font-weight: 600;
}
.resume-analysis .career-list {
  padding: 20px;
}
.resume-analysis .career-list p {
  font-weight: 600;
  margin: 0 0 30px;
}
.resume-analysis .career-list p a {
  color: #e56653;
}
.resume-analysis .career-list .file-upload-sec {
  border: 1px solid #ebeded;
  background: #f6f8f7;
  border-radius: 8px;
  padding: 15px;
}
.resume-analysis .career-list .file-upload-sec .file-upload-inner {
  margin-bottom: 15px;
}
.resume-analysis .career-list .file-upload-sec .file-upload-inner > div {
  display: flex;
  align-items: center;
}
.resume-analysis
  .career-list
  .file-upload-sec
  .file-upload-inner
  > div
  > div
  div {
  display: flex;
  position: relative;
}
.resume-analysis
  .career-list
  .file-upload-sec
  .file-upload-inner
  > div
  > div
  div
  input[type="file"] {
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
  width: 100%;
  cursor: pointer;
}
.resume-analysis .career-list .file-upload-sec .file-upload-inner h6 {
  font-size: 14px;
  font-weight: 700;
  margin: 0 0 8px;
}
.resume-analysis .career-list .file-upload-sec .file-upload-inner h6 em {
  color: #e56653;
}
.resume-analysis
  .career-list
  .file-upload-sec
  .file-upload-inner
  span.small-text {
  font-size: 10px;
  color: #1f85cd;
  font-weight: 500;
}
.resume-analysis .career-list .file-upload-sec .file-upload-inner .btn {
  font-size: 12px;
  background: #cfcdcd;
  padding: 2px 8px;
  border-radius: 4px;
  border: 1px solid #cbccce;
  font-weight: 500;
  margin-right: 8px;
}
.resume-analysis .career-list .file-upload-sec .upload-icon {
  background: #e56653;
  width: 45px;
  height: 45px;
  min-width: 45px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  margin-right: 15px;
}
.resume-analysis .career-list .file-upload-sec .upload-icon img {
  max-width: 27px;
}
.resume-analysis .career-list .file-upload-sec .form-group {
  margin: 0;
}
.resume-analysis .career-list .bottom-btn {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin: 15px 0 0;
}
.resume-analysis .career-list .bottom-btn .primary-btn {
  padding: 5px 20px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
}
.resume-analysis .career-list .form-group label {
  font-weight: 700;
  font-size: 13px;
}
.resume-analysis .career-list .form-group label em {
  color: #e56653;
}
.services-resume .tabHold {
  margin: 30px 0 0;
}
.services-resume .tabHold .nav-tabs {
  border-bottom: none;
}
.services-resume .tabHold .nav-tabs .nav-link {
  font-size: 11px;
}
.services-resume .tab-content,
.services-resume .card-body {
  border: 1px solid #dee2e6;
  min-height: 200px;
  border-radius: 0px 8px 8px 8px;
}
.services-resume .tab-content .content,
.services-resume .card-body .content {
  padding: 25px;
}
.services-resume .tab-content h6,
.services-resume .card-body h6 {
  font-weight: 700;
  margin: 0 0 15px;
  font-size: 18px;
}
.services-resume .tab-content p,
.services-resume .card-body p {
  font-weight: 500;
  font-size: 16px;
}
.services-resume .tab-content .sample-executive,
.services-resume .card-body .sample-executive {
  border-top: 1px solid #ebeded;
  background: #f6f8f7;
  padding: 10px 20px;
  display: flex;
  align-items: center;
}
.services-resume .tab-content .sample-executive h6,
.services-resume .card-body .sample-executive h6 {
  margin: 0;
  font-size: 14px;
}
.services-resume .tab-content .sample-executive a,
.services-resume .card-body .sample-executive a {
  display: flex;
  align-items: center;
  margin: 0 30px;
  color: #000;
}
.services-resume .tab-content .sample-executive a img,
.services-resume .card-body .sample-executive a img {
  margin-right: 12px;
  max-width: 55px;
}
.services-resume .tab-content .contentBox,
.services-resume .card-body .contentBox {
  margin-bottom: 20px;
}
.services-resume .tab-content .contentBox ul li,
.services-resume .card-body .contentBox ul li {
  max-width: 100%;
  font-weight: 500;
  background-size: 14px 14px;
  background-position: left 4px;
}
.services-resume .tab-content .list li,
.services-resume .card-body .list li {
  font-weight: 500;
  font-size: 16px;
  background: url(/assets/bullet-arrow.png) no-repeat;
  padding-left: 24px;
  background-position: left 5px;
  background-size: 13px 13px;
  margin-bottom: 3px;
}
.services-resume .accordion {
  display: none;
}
.resume-counselling-panel h2 {
  font-size: 20px;
  font-weight: 700;
  margin: 0 0 20px;
}
.resume-counselling-panel .top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}
.resume-counselling-panel .top h2 {
  margin: 0;
}
.resume-counselling-panel .top a.back-arrow {
  display: flex;
  align-items: center;
  color: #e56653;
  font-weight: 600;
}
.resume-counselling-panel .top a.back-arrow:hover {
  color: #1f85cd;
}
.resume-counselling-panel .resume-panel {
  border: 1px solid #ebeded;
  background: #f6f8f7;
  border-radius: 8px;
  padding: 20px;
  display: flex;
  margin-bottom: 15px;
}
.resume-counselling-panel .resume-panel img {
  width: 120px;
  height: 120px;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid #e56653;
  margin-right: 20px;
}
.resume-counselling-panel .resume-panel h4 {
  font-weight: 700;
  font-size: 18px;
  margin: 0 0 10px;
}
.resume-counselling-panel .resume-panel p {
  font-weight: 500;
}
.resume-counselling-panel .resume-panel .primary-btn {
  font-size: 16px;
  padding: 5px 20px;
}
.blog-detail .blog-detail-inner > img {
  width: 100%;
  border-radius: 8px;
  max-height: 300px;
  object-fit: cover;
}
.blog-detail .blog-detail-inner .blog-footer {
  display: flex;
  margin: 20px 0;
}
.blog-detail .blog-detail-inner .blog-footer .blog-author {
  display: flex;
  align-items: center;
  margin-right: 50px;
}
.blog-detail .blog-detail-inner .blog-footer .blog-author img {
  width: 50px;
  height: 50px;
  border-radius: 50%;
}
.blog-detail .blog-detail-inner .blog-footer .blog-author span {
  font-weight: 600;
  margin-left: 8px;
  font-size: 14px;
}
.blog-detail .blog-detail-inner .blog-footer .blog-date {
  display: flex;
  align-items: center;
}
.blog-detail .blog-detail-inner .blog-footer .blog-date img {
  max-width: 26px;
  height: auto;
  width: auto;
  object-fit: contain;
}
.blog-detail .blog-detail-inner .blog-footer .blog-date span {
  font-weight: 600;
  color: #e56653;
  margin-left: 8px;
  font-size: 14px;
}
.blog-detail .blog-detail-inner h4 {
  font-weight: 700;
  font-size: 20px;
  margin: 0 0 20px;
}
.blog-detail .blog-detail-inner p {
  font-weight: 500;
}
.not-found-page {
  background: #1f85cd;
  text-align: center;
  padding: 6% 0;
}
.not-found-page .not-find-inner p {
  color: #fff;
  font-weight: 700;
  font-size: 20px;
  max-width: 745px;
  margin: 30px auto 30px;
}
.not-found-page .not-find-inner .white-btn {
  color: #1f85cd;
}
.not-found-page .not-find-inner .white-btn:hover {
  color: #fff;
}
.order-page {
  background: #fff;
  text-align: center;
  padding: 6% 0;
}
.order-page .order-page-inner img {
  max-width: 400px;
  width: 100%;
  margin: 0 auto;
}
.order-page .order-page-inner.failure-inner img {
  max-width: 300px;
}
.order-page .order-page-inner h1 {
  margin: 20px 0 0;
  font-size: 32px;
}
.order-page .order-page-inner p {
  color: #000;
  font-weight: 600;
  font-size: 15px;
  max-width: 745px;
  margin: 15px auto 30px;
}
.order-page .order-page-inner p a {
  color: #e56653;
}
.order-page .order-page-inner p a:hover {
  color: #1f85cd;
}
#toast-container > div {
  opacity: 1;
}
.contact-sec .contact-form {
  padding: 25px 40px;
}
.contact-sec .contact-form .form-group {
  margin-bottom: 0.75rem;
}
.contact-sec .contact-form .form-group .form-control {
  padding: 0.5rem 0.75rem;
}
.contact-sec .contact-form .form-group label {
  font-size: 14px;
  margin-bottom: 3px;
}
.contact-sec .why-wait h1 {
  margin: 0;
  color: #1f85cd;
  font-size: 42px;
}
.contact-sec .why-wait h5 {
  font-weight: 600;
  margin: 15px 0 30px;
  font-size: 24px;
}
.contact-sec .why-wait p {
  font-size: 18px;
  font-weight: 600;
}
.resume-desc {
  max-width: 1000px;
  margin: 50px auto 10px;
  text-align: center;
}
.resume-desc p {
  font-size: 20px;
  font-weight: 500;
}
/*----fixed buttons styles starts here*/
.fixed-links {
  background: #1f85cd;
  width: 150px;
  position: fixed;
  top: 60%;
  transform: translateY(-50%);
  right: 0px;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  z-index: 99;
  -moz-transition-property: all;
  -o-transition-property: all;
  -webkit-transition-property: all;
  transition-property: all;
  -moz-transition-duration: 0.5s;
  -o-transition-duration: 0.5s;
  -webkit-transition-duration: 0.5s;
  transition-duration: 0.5s;
  -moz-transition-timing-function: ease-in-out, ease-in-out, ease-in-out,
    ease-in-out;
  -o-transition-timing-function: ease-in-out, ease-in-out, ease-in-out,
    ease-in-out;
  -webkit-transition-timing-function: ease-in-out, ease-in-out, ease-in-out,
    ease-in-out;
  transition-timing-function: ease-in-out, ease-in-out, ease-in-out, ease-in-out;
}
.fixed-links.shadow.open {
  right: -150px;
}
.css-border-arrow {
  width: 0px;
  height: 0;
}
.border-blue {
  border-style: solid;
  border-width: 8px;
  border-color: #fff;
  left: -5px;
  position: relative;
}
.open .border-blue {
  left: 5px;
}
.fixed-links.shadow span.border-blue.css-border-arrow.right {
  border-top-color: transparent;
  border-bottom-color: transparent;
  border-left-color: transparent;
}
.fixed-links .arrow {
  position: absolute;
  cursor: pointer;
  border-radius: 5px 0 0 5px;
  left: -33px;
  background: #1f85cd;
  font-size: 20px;
  box-shadow: -5px 1px 15px 1px #000;
  -webkit-box-shadow: -5px 1px 15px 1px #000;
  -moz-box-shadow: -5px 1px 15px 1px rgba(227, 227, 227, 0.29);
  padding: 13px 10px;
}
.fixed-links a {
  color: #fff;
  text-decoration: none;
  line-height: normal;
  display: inline-block;
  cursor: pointer;
  padding: 8px 15px;
  border-color: #fff;
  font-weight: 600;
  font-size: 14px;
}
.fixed-links a:hover {
  background: #1f85cd;
  border-color: #fff;
}
.fixed-links.shadow.open .arrow span {
  transform: rotateZ(-180deg);
  transition: all 0.4s ease;
  display: block;
}
.fixed-links.shadow .arrow span {
  transform: rotateZ(0deg);
  transition: all 0.4s ease;
  display: block;
}
.fixed-links.shadow .arrow .bi-chevron-left::before {
  font-weight: 600 !important;
  color: #044b88 !important;
}
.fixed-links.shadow .col-12.border-bottom {
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
}
.fixed-links .call-no a {
  padding: 2px 0;
  text-align: center;
  display: block;
}
.fixed-links .banner-icon > div {
  padding: 20px 0 !important;
}
/*----fixed buttons styles endshere*/
.hired-sec {
  background: #1f85cd;
  color: #fff;
}
.hired-sec p {
  margin: 25px 0;
}
/*************************************Resume Builder CSS****************************************/
.builder-page {
  padding: 0;
}
.top-header {
  display: none;
  align-items: center;
  background: #1f85cd;
}
.top-header.fixed {
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 9;
}
.top-header .top-left {
  max-width: 330px;
  padding: 16px 25px;
  width: 100%;
}
.top-header .logo {
  display: inline-block;
}
/* .top-header .logo img {
  max-width: 200px;
} */
.top-header .top-right {
  margin-left: 20px;
}
.top-header .top-right a {
  color: #fff;
}
.top-header .top-right a i {
  font-size: 32px;
}
.resume-builder-main {
  display: flex;
}
/* .resume-builder-main .resume-builder-left {
  color: #000;
   padding: 30px 20px; 
  transition: all 0.5s;
  max-width: 320px;
  position: absolute;
  height: 100%;
  overflow: auto;
  left: 0;
   top: 78px; 
} */
.resume-builder-main .resume-builder-left .logo {
  margin-bottom: 40px;
}
.resume-builder-main .resume-builder-left .logo img {
  max-width: 100%;
}
.resume-builder-main .resume-builder-left h3 {
  font-size: 20px;
  font-weight: 600;
}
/* 
.resume-builder-main .resume-builder-left .resume-section ul {
  margin-top: 20px;
  position: relative;
  padding-left: 25px;
}
.resume-builder-main .resume-builder-left .resume-section ul:after,
.resume-builder-main .resume-builder-left .resume-section ul:before {
  content: "";
  background: #1f85cd;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  position: absolute;
  left: 0;
}
.resume-builder-main .resume-builder-left .resume-section ul:after {
  bottom: 34px;
}
.resume-builder-main .resume-builder-left .resume-section ul:before {
  top: 14px;
}
.resume-builder-main .resume-builder-left .resume-section ul li {
  position: relative;
  padding-bottom: 20px;
}
.resume-builder-main .resume-builder-left .resume-section ul li:before {
  content: "";
  width: 2px;
  background: #1f85cd;
  height: 100%;
  position: absolute;
  left: -20px;
  top: 25px;
}
.resume-builder-main .resume-builder-left .resume-section ul li a {
  color: #8d8d8d;
  display: flex;
  align-items: center;
  font-weight: 500;
  font-size: 16px;
  border: 2px solid #8d8d8d;
  border-radius: 30px;
  padding: 4px 10px 4px 4px;
}
.resume-builder-main .resume-builder-left .resume-section ul li a span {
  width: 30px;
  height: 30px;
  display: flex;
  margin-right: 8px;
  align-items: center;
  justify-content: center;
  background: #8d8d8d;
  border: 2px solid #8d8d8d;
  border-radius: 50%;
  color: #fff;
  font-weight: 600;
}
.resume-builder-main .resume-builder-left .resume-section ul li a:hover {
  background: #1f85cd;
  color: #fff;
  border-color: #1f85cd;
}
.resume-builder-main .resume-builder-left .resume-section ul li a:hover span {
  background: #fff;
  color: #000;
}
.resume-builder-main
  .resume-builder-left
  .resume-section
  ul
  li:last-child:before {
  display: none;
}
.resume-builder-main .resume-builder-left .resume-section ul li.active a {
  background: #1f85cd;
  border-color: #1f85cd;
  color: #fff;
}
.resume-builder-main .resume-builder-left .resume-section ul li.active a span {
  background: #fff;
  color: #1f85cd;
  border-color: #fff;
} */
.resume-builder-main .resume-builder-left .resume-btn-sec {
  display: flex;
  align-items: center;
  margin-top: 40px;
}
.resume-builder-main .resume-builder-left .resume-btn-sec a {
  display: flex;
  align-items: center;
  font-size: 15px;
}
.resume-builder-main .resume-builder-left .resume-btn-sec a i {
  margin-right: 5px;
}
.resume-builder-main .resume-builder-left .resume-btn-sec a.download-btn {
  color: #1f85cd;
  margin-left: 10px;
}
.resume-builder-main .resume-builder-left .resume-btn-sec a.download-btn:hover {
  color: #e56653;
}
.resume-builder-main .resume-builder-right {
  /* padding: 50px 30px 50px 350px; */
  width: 100%;
  transition: all 0.5s;
}
.resume-builder-main .resume-builder-right h3 {
  font-size: 24px;
  font-weight: 700;
}
.resume-builder-main .resume-builder-right p {
  font-weight: 500;
  font-size: 15px;
}
.resume-builder-main .resume-builder-right .top {
  min-height: 104px;
}
.resume-builder-main .resume-builder-right .top.fixed {
  position: fixed;
  background: #fff;
  width: 100%;
  top: 0;
  min-height: inherit;
  padding: 15px 0;
  z-index: 9;
}
.resume-builder-main .resume-builder-right .top a {
  color: #1f85cd;
}
.resume-builder-main .resume-builder-right .top a i {
  font-size: 32px;
}
.resume-builder-main .resume-builder-right .content .content-top-inner {
  display: flex;
  justify-content: space-between;
  max-width: calc(100% - 370px);
}
.resume-builder-main .resume-builder-right .content .content-top-inner ul {
  display: flex;
  align-items: center;
}
.resume-builder-main .resume-builder-right .content .content-top-inner ul li {
  padding: 0 15px;
  border-right: 1px solid #1f85cd;
}
.resume-builder-main .resume-builder-right .content .content-top-inner ul li a {
  color: #1f85cd;
  font-weight: 600;
  font-size: 12px;
  display: flex;
  align-items: center;
}
.resume-builder-main
  .resume-builder-right
  .content
  .content-top-inner
  ul
  li
  a
  img {
  margin-right: 10px;
}
.resume-builder-main
  .resume-builder-right
  .content
  .content-top-inner
  ul
  li:last-child {
  border-right: none;
  padding-right: 0;
}
.resume-builder-main .resume-builder-right .content .resume-build {
  display: flex;
  margin-top: 40px;
}
.resume-builder-main
  .resume-builder-right
  .content
  .resume-build
  .resume-block {
  border: 3px solid #e5dfde;
  border-radius: 15px;
  max-width: 50%;
  width: 100%;
  text-align: center;
  padding: 50px 30px;
  color: #000;
  margin-right: 20px;
  position: relative;
  overflow: hidden;
  display: block;
}
.resume-builder-main
  .resume-builder-right
  .content
  .resume-build
  > div
  .resume-block {
  max-width: 100%;
  width: 100%;
}
.resume-builder-main
  .resume-builder-right
  .content
  .resume-build
  .resume-block
  span {
  background: #e56653;
  color: #fff;
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 15px;
  border-radius: 50%;
}
.resume-builder-main
  .resume-builder-right
  .content
  .resume-build
  .resume-block
  .checkmark-active {
  background: #1f85cd;
  border-radius: 0;
  width: 80px;
  height: 55px;
  position: absolute;
  right: -32px;
  top: -26px;
  transform: rotate(45deg);
  display: none;
}
.resume-builder-main
  .resume-builder-right
  .content
  .resume-build
  .resume-block
  .checkmark-active
  i {
  margin: 25px 0 0;
  transform: rotate(-45deg);
  position: relative;
  padding-top: 5px;
  font-size: 20px;
}
.resume-builder-main
  .resume-builder-right
  .content
  .resume-build
  .resume-block
  h4 {
  margin: 0;
  font-size: 18px;
  font-weight: 700;
}
.resume-builder-main
  .resume-builder-right
  .content
  .resume-build
  .resume-block
  p {
  font-size: 14px;
  font-weight: 500;
  max-width: 200px;
  margin: 5px auto 0;
  line-height: 1.3;
}
.resume-builder-main
  .resume-builder-right
  .content
  .resume-build
  .resume-block:hover,
.resume-builder-main
  .resume-builder-right
  .content
  .resume-build
  .resume-block.active {
  border-color: #1f85cd;
  background: #ecebf3;
}
.resume-builder-main
  .resume-builder-right
  .content
  .resume-build
  .resume-block:hover
  .checkmark-active,
.resume-builder-main
  .resume-builder-right
  .content
  .resume-build
  .resume-block.active
  .checkmark-active {
  display: block;
}
.resume-builder-main .resume-builder-right .content .form-section {
  display: flex;
  margin-top: 20px;
}
.resume-builder-main .resume-builder-right .content .form-section .left-form {
  background: #eff6fa;
  padding: 20px;
  width: calc(100% - 340px);
  border-radius: 8px;
}
.resume-builder-main
  .resume-builder-right
  .content
  .form-section
  .left-form
  .form-group
  label {
  font-weight: 500;
  font-size: 14px;
}
.resume-builder-main
  .resume-builder-right
  .content
  .form-section
  .left-form
  .form-group
  .form-control {
  border-radius: 6px;
  font-weight: 500;
  font-size: 15px;
  padding: 8px 12px;
}
.resume-builder-main
  .resume-builder-right
  .content
  .form-section
  .left-form
  .form-group
  .search {
  display: flex;
}
.resume-builder-main
  .resume-builder-right
  .content
  .form-section
  .left-form
  .form-group
  .search
  .search-btn {
  background: #1f85cd;
  border: none;
  padding: 7px 10px;
  margin-left: 15px;
  cursor: pointer;
}
.resume-builder-main
  .resume-builder-right
  .content
  .form-section
  .left-form
  .form-check {
  font-weight: 500;
  font-size: 14px;
}
.resume-builder-main
  .resume-builder-right
  .content
  .form-section
  .left-form
  .checkbox-sec
  .form-check {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
}
.resume-builder-main
  .resume-builder-right
  .content
  .form-section
  .left-form
  .checkbox-sec
  .form-check
  input {
  margin-right: 12px;
  border-radius: 0;
}
.resume-builder-main
  .resume-builder-right
  .content
  .form-section
  .left-form
  .checkbox-sec
  .form-check
  label {
  margin: 0;
}
.resume-builder-main
  .resume-builder-right
  .content
  .form-section
  .left-form
  .add-social-links {
  font-weight: 500;
  font-size: 14px;
  color: #e56653;
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
.resume-builder-main
  .resume-builder-right
  .content
  .form-section
  .left-form
  .add-social-links
  i {
  margin-right: 5px;
}
.resume-builder-main
  .resume-builder-right
  .content
  .form-section
  .left-form
  .add-social-links.add {
  color: #1f85cd;
}
.resume-builder-main
  .resume-builder-right
  .content
  .form-section
  .left-form
  .delete-icon {
  color: #1f85cd;
}
.resume-builder-main
  .resume-builder-right
  .content
  .form-section
  .left-form
  .popular-search
  h6 {
  display: flex;
  align-items: center;
  font-weight: 600;
  margin-bottom: 15px;
}
.resume-builder-main
  .resume-builder-right
  .content
  .form-section
  .left-form
  .popular-search
  h6
  img {
  margin-right: 15px;
}
.resume-builder-main
  .resume-builder-right
  .content
  .form-section
  .left-form
  .popular-search
  ul {
  padding-left: 37px;
}
.resume-builder-main
  .resume-builder-right
  .content
  .form-section
  .left-form
  .popular-search
  ul
  li {
  padding-bottom: 12px;
}
.resume-builder-main
  .resume-builder-right
  .content
  .form-section
  .left-form
  .popular-search
  ul
  li
  a {
  color: #000;
  font-weight: 600;
  font-size: 12px;
  line-height: normal;
  display: block;
}
.resume-builder-main
  .resume-builder-right
  .content
  .form-section
  .left-form
  .popular-search
  ul
  li
  a:hover {
  color: #e56653;
}
.resume-builder-main
  .resume-builder-right
  .content
  .form-section
  .left-form
  .popular-search
  ul
  li
  a.see-more {
  color: #1f85cd;
  align-items: center;
  display: flex;
  font-weight: 700;
}
.resume-builder-main
  .resume-builder-right
  .content
  .form-section
  .left-form
  .popular-search
  ul
  li
  a.see-more
  i {
  font-size: 15px;
}
.resume-builder-main
  .resume-builder-right
  .content
  .form-section
  .left-form
  .popular-search
  ul
  li.active
  a {
  color: #e56653;
  text-decoration: underline;
}
.resume-builder-main
  .resume-builder-right
  .content
  .form-section
  .left-form
  .ready-use-example {
  border: 1px solid #ced0d3;
  background: #fff;
}
.resume-builder-main
  .resume-builder-right
  .content
  .form-section
  .left-form
  .ready-use-example
  h6 {
  font-weight: 600;
  padding: 15px;
  margin: 0;
}
.resume-builder-main
  .resume-builder-right
  .content
  .form-section
  .left-form
  .ready-use-example
  .box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #fff;
  padding: 7px 15px;
}
.resume-builder-main
  .resume-builder-right
  .content
  .form-section
  .left-form
  .ready-use-example
  .box.active,
.resume-builder-main
  .resume-builder-right
  .content
  .form-section
  .left-form
  .ready-use-example
  .box:hover {
  background: #f6f8f7;
}
.resume-builder-main
  .resume-builder-right
  .content
  .form-section
  .left-form
  .ready-use-example
  .box
  > div {
  display: flex;
}
.resume-builder-main
  .resume-builder-right
  .content
  .form-section
  .left-form
  .ready-use-example
  .box
  > div
  i {
  color: #de9c19;
  font-size: 18px;
}
.resume-builder-main
  .resume-builder-right
  .content
  .form-section
  .left-form
  .ready-use-example
  .box
  p {
  color: #000;
  font-weight: 600;
  font-size: 12px;
  line-height: normal;
  display: block;
  margin: 0 0 0 10px;
}
.resume-builder-main
  .resume-builder-right
  .content
  .form-section
  .left-form
  .ready-use-example
  .box
  p:last-child {
  color: #e56653;
  margin-top: 2px;
}
.resume-builder-main
  .resume-builder-right
  .content
  .form-section
  .left-form
  .ready-use-example
  .box
  a {
  background: #e56653;
  color: #fff;
  border-radius: 30px;
  padding: 5px 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  text-transform: uppercase;
  font-weight: 600;
  min-width: 57px;
}
.resume-builder-main
  .resume-builder-right
  .content
  .form-section
  .left-form
  .ready-use-example
  .box
  a
  i {
  font-size: 14px;
}
.resume-builder-main .resume-builder-right .content .form-section .right-form {
  min-width: 200px;
  text-align: center;
  margin-left: 20px;
  max-width: 320px;
}
.resume-builder-main
  .resume-builder-right
  .content
  .form-section
  .right-form
  .upload-img {
  margin-bottom: 20px;
}
.resume-builder-main
  .resume-builder-right
  .content
  .form-section
  .right-form
  .upload-img
  .img-box {
  background: #dbdbe3;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  /* padding: 50px; */
  margin-bottom: 15px;
}
.resume-builder-main
  .resume-builder-right
  .content
  .form-section
  .right-form
  .upload-img
  .img-box
  img {
  max-width: 200px;
  border-radius: 50%;
}
.resume-builder-main
  .resume-builder-right
  .content
  .form-section
  .right-form
  .upload-img
  .secondary-btn {
  border-color: #1f85cd;
  color: #1f85cd;
}
.resume-builder-main
  .resume-builder-right
  .content
  .form-section
  .right-form
  .upload-img
  .secondary-btn:hover {
  background: #1f85cd;
  color: #fff;
}
.resume-builder-main
  .resume-builder-right
  .content
  .form-section
  .right-form
  .template-preview {
  position: relative;
}
.resume-builder-main
  .resume-builder-right
  .content
  .form-section
  .right-form
  .template-preview
  img.shadow {
  position: absolute;
  left: 0;
  bottom: 0;
}
.resume-builder-main
  .resume-builder-right
  .content
  .form-section
  .right-form
  .template-preview
  .btns {
  max-width: 200px;
  width: 100%;
  margin: 0 auto;
  position: absolute;
  bottom: 30px;
  left: 50%;
  transform: translate(-50%, 0);
  filter: drop-shadow(5px 5px 10px #666);
}
.resume-builder-main
  .resume-builder-right
  .content
  .form-section
  .right-form
  .template-preview
  .btns
  .primary-btn {
  font-size: 14px;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
}
.resume-builder-main
  .resume-builder-right
  .content
  .form-section
  .right-form
  .template-preview
  .btns
  .primary-btn
  i {
  font-size: 16px;
  margin-right: 5px;
}
.resume-builder-main
  .resume-builder-right
  .content
  .form-section
  .right-form
  .template-preview
  .btns
  .primary-btn.preview {
  background: #1f85cd;
  border-color: #1f85cd;
  margin-bottom: 10px;
}
.resume-builder-main
  .resume-builder-right
  .content
  .form-section
  .right-form
  .template-preview
  .btns
  .primary-btn.preview:hover {
  background: #fff;
  color: #1f85cd;
}
.resume-builder-main
  .resume-builder-right
  .content
  .form-section
  .right-form
  .skill-add-sec
  h5 {
  text-align: left;
  font-weight: 700;
  font-size: 18px;
}
.resume-builder-main
  .resume-builder-right
  .content
  .form-section
  .right-form
  .skill-add-sec
  .box {
  display: flex;
  align-items: center;
  margin-top: 15px;
}
.resume-builder-main
  .resume-builder-right
  .content
  .form-section
  .right-form
  .skill-add-sec
  .box
  > div {
  display: flex;
  align-items: center;
  margin-right: 15px;
}
.resume-builder-main
  .resume-builder-right
  .content
  .form-section
  .right-form
  .skill-add-sec
  .box
  .del-hide {
  background: #e56653;
  border-radius: 50%;
  color: #fff;
  width: 15px;
  height: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  margin-right: 5px;
}
.resume-builder-main
  .resume-builder-right
  .content
  .form-section
  .right-form
  .skill-add-sec
  .box
  ul {
  display: flex;
  align-items: center;
  line-height: 18px;
}
.resume-builder-main
  .resume-builder-right
  .content
  .form-section
  .right-form
  .skill-add-sec
  .box
  ul
  li {
  padding: 0 1px;
}
.resume-builder-main
  .resume-builder-right
  .content
  .form-section
  .right-form
  .skill-add-sec
  .box
  ul
  li
  a
  i {
  font-size: 18px;
  color: #1f85cd;
}
.resume-builder-main
  .resume-builder-right
  .content
  .form-section
  .right-form
  .skill-add-sec
  .box
  .form-control {
  border-radius: 0;
  font-weight: 500;
  font-size: 14px;
}
.resume-builder-main
  .resume-builder-right
  .content
  .form-section
  .right-form
  .skill-add-sec
  .box
  .del-icon {
  min-width: 16px;
  margin-left: 15px;
}
.resume-builder-main
  .resume-builder-right
  .content
  .form-section
  .right-form
  .skill-add-sec
  .add-more {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  font-size: 12px;
  color: #1f85cd;
  font-weight: 700;
  margin: 20px 0 0;
}
.resume-builder-main
  .resume-builder-right
  .content
  .form-section
  .right-form
  .skill-add-sec
  .add-more
  i {
  font-size: 15px;
  margin-right: 5px;
}
.resume-builder-main
  .resume-builder-right
  .content.skills-page
  .form-section
  .left-form {
  width: calc(100% - 350px);
}
.resume-builder-main
  .resume-builder-right
  .content.skills-page
  .form-section
  .right-form {
  max-width: 350px;
}
.resume-builder-main .resume-builder-right .btn-sec {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 50px;
}
.resume-builder-main .resume-builder-right .btn-sec a {
  min-width: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 500;
}
.resume-builder-main .resume-builder-right .btn-sec .primary-btn {
  background: #1f85cd;
  border-color: #1f85cd;
  font-size: 15px;
}
.resume-builder-main .resume-builder-right .btn-sec .primary-btn:hover {
  background: #fff;
  color: #1f85cd;
}
.resume-builder-main .resume-builder-right .btn-sec .secondary-btn {
  border-color: #1f85cd;
  color: #1f85cd;
  font-size: 15px;
}
.resume-builder-main .resume-builder-right .btn-sec .secondary-btn i {
  margin-right: 5px;
}
.resume-builder-main .resume-builder-right .btn-sec .secondary-btn:hover {
  background: #1f85cd;
  color: #fff;
}
.resume-builder-main.active .resume-builder-left {
  left: 0;
  max-width: 135px;
}
.resume-builder-main.active .resume-builder-left h3 {
  display: none;
}
.resume-builder-main.active .resume-builder-left .resume-section ul li a {
  text-indent: -9999px;
  max-width: 43px;
}
.resume-builder-main.active .resume-builder-left .resume-section ul li a span {
  text-indent: 0;
  min-width: 30px;
}
.resume-builder-main.active .resume-builder-left .resume-btn-sec {
  display: block;
  text-align: center;
}
.resume-builder-main.active .resume-builder-left .resume-btn-sec a {
  text-indent: -9999px;
  margin: 0 0 10px;
}
.resume-builder-main.active .resume-builder-left .resume-btn-sec a i {
  text-indent: 0;
  margin: 0 auto;
}
.resume-builder-main.active .resume-builder-right {
  width: 100%;
  padding-left: 150px;
}

.add-own-check {
  display: flex;
}
.add-own-check input[type="checkbox"] {
  margin-right: 20px;
  margin-top: 0;
}
.resume-builder-main
  .resume-builder-right
  .content
  .form-section
  .left-form
  .form-group
  label {
  margin-bottom: 0.5rem;
}
.resume-builder-main .resume-builder-right .btn-sec a.btn-secondary {
  cursor: pointer;
  color: #1f85cd;
}
.resume-builder-main .resume-builder-choose {
  padding: 50px;
  max-width: 1280px;
  margin: 0 auto;
}
.resume-builder-main .resume-builder-choose h3 {
  text-align: center;
}
.resume-builder-main .resume-builder-right .content .resume-build > div {
  max-width: 50%;
  width: 100%;
}
.upload-icon {
  background: #f85656;
  color: #fff;
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 15px;
  border-radius: 50%;
}
.inputfile {
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
}
.resume-builder-main
  .resume-builder-right
  .content
  .resume-build
  .resume-block.custom-browse
  h4 {
  margin-bottom: 15px;
}
.format-names strong {
  font-weight: bold;
  padding-bottom: 6px;
  display: inline-block;
}
.resume-builder-main
  .resume-builder-right
  .content
  .resume-build
  .resume-block.custom-browse {
  margin: 0 auto;
  display: block;
}

@media (max-width: 1240px) {
  header .mainNav li {
    font-size: 15px;
    padding: 20px 6px;
  }
  header .mainNav li a .arrorDown {
    background-size: 240px 240px;
    background-position: -26px 2px;
  }
  .contantholder h3 a {
    font-size: 20px;
  }
  .contantholder h4 {
    font-size: 18px;
    margin-right: 10px;
  }
}
@media (max-width: 1200px) {
  a.logo {
    max-width: 200px;
  }
  header .logo img {
    max-width: 100%;
    margin: 7px 0 0;
  }
  .footerHold ul.social-icon li a {
    width: 35px;
    height: 35px;
  }
  .footerHold ul.social-icon li a.twitter {
    background-position: -28px -133px;
    background-size: 250px 250px;
  }
  .footerHold ul.social-icon li a.linkedIn {
    background-position: -28px -164px;
    background-size: 260px 260px;
  }
  .footerHold ul.social-icon li a.facebook {
    background-position: -24px -181px;
    background-size: 250px 250px;
  }
  .resume-analysis
    .career-list
    .file-upload-sec
    .file-upload-inner
    > div
    > div
    div {
    display: block;
  }
  .resume-analysis
    .career-list
    .file-upload-sec
    .file-upload-inner
    span.small-text {
    display: block;
  }
  .services-resume .tabHold .nav-tabs .nav-link {
    font-size: 10px;
    padding-left: 10px;
    padding-right: 10px;
  }
  .shopping-cart
    .shopping-cart-right
    .resume-service-box
    .resume-inner-box
    > h5 {
    min-width: 150px;
    max-width: 150px;
  }
  .shopping-cart
    .shopping-cart-right
    .resume-service-box
    .resume-inner-box
    .cus-radio {
    margin: 0 10px;
  }
}
@media (max-width: 1199px) {
  .shopping-cart .payment-details-sec .block {
    min-height: 230px;
  }
}
@media (max-width: 1100px) {
  a.logo {
    max-width: 160px;
  }
  header .mainNav li {
    font-size: 14px;
  }
  .secondary-btn,
  .mainNav li a.secondary-btn {
    padding: 5px 12px;
    font-size: 13px;
  }
  .topHeader ul li {
    font-size: 16px;
  }
  .faqHeader:after {
    background-size: 230px 230px;
    background-position: 3px -20px;
  }
  .mobHold span.mobile-icon {
    width: 75px;
    height: 75px;
    border: 6px solid #f5c2ba;
  }
  .mobHold span.mobile-icon .mobile-ico {
    background-size: 250px 250px;
    background-position: 1px -48px;
  }
  .contantholder h4 {
    margin: 0 0 10px !important;
    display: block;
    text-align: center;
  }
  .theme1-bg .col-12.col-lg-10.col-sm-10.col-md-10 {
    text-align: center;
  }
  .footer-mid .d-flex.w-100.align-items-center img {
    max-width: 80px !important;
  }
}
@media (max-width: 1060px) {
  .contantholder h3 a {
    font-size: 18px;
  }
}
@media (max-width: 991px) {
  .bannerContent h1 {
    font-size: 32px;
  }
  .sectionHolder .col-12.col-lg-5 img {
    display: block;
    margin: 0 auto;
  }
  .articlesHold .row.align-items-center {
    flex-direction: row-reverse;
    flex-wrap: wrap-reverse;
    margin-left: 0;
    margin-right: 0;
  }
  .articlesHold .row.align-items-center img {
    max-height: inherit;
    object-fit: cover;
  }
  .sectionHolder.articlesHold h3 {
    min-height: 44px;
  }
  .sectionHolder.articlesHold p {
    min-height: 72px;
    -webkit-line-clamp: 3;
  }
  .sectionHolder.articlesHold .articleContent {
    padding-left: 0;
  }
  .sectionHolder.articlesHold .articleContent .articleContent-inner {
    padding: 25px 0;
  }
  .sectionHolder.articlesHold .articleContent a.secondary-btn {
    margin: 0 auto;
    display: block;
    text-align: center;
    max-width: 130px;
  }
  .mobHold {
    justify-content: center;
  }
  .footerHold ul {
    margin: 0 0 20px;
  }
  .footer-mid .d-flex.w-100.align-items-center {
    margin: 20px auto 0;
    justify-content: center;
  }
  body {
    padding-top: 67px;
  }
  header {
    top: 0;
  }
  .topHeader {
    display: none;
  }
  header .logo {
    padding: 0;
  }
  header .logo img {
    margin: 0;
  }
  header .topHeader {
    display: block;
  }
  header .topHeader .cartIcon {
    width: 25px;
    height: 24px;
    background: url(/assets/cart-blue.svg);
    display: inline-block;
    position: relative;
    top: 5px;
  }
  header .topHeader a.cart-hold {
    color: #3d2e83;
  }
  header .topHeader span.cart-count {
    color: #fff;
    font-size: 11px;
    background: #ec4747;
    padding: 0.5px 5px;
    border-radius: 50%;
    text-align: center;
    position: absolute;
    line-height: 15px;
    top: -12px;
    right: -3px;
    font-weight: 400;
  }
  header .container-fluid {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 15px;
  }
  header .header-top-left {
    display: flex;
    align-items: center;
  }
  header .header-top-left .menu-toggle {
    display: block;
    background: url(/assets/Hamburger-menu.svg);
    width: 32px;
    height: 23px;
    margin-right: 10px;
  }
  header ul.mainNav {
    float: none;
    width: 100%;
    display: block;
    position: fixed;
    top: 0;
    background: #fff;
    z-index: 99;
    max-height: 100vh;
    overflow: auto;
    min-height: 100vh;
    left: -100%;
    -moz-transition-property: all;
    -o-transition-property: all;
    -webkit-transition-property: all;
    transition-property: all;
    -moz-transition-duration: 0.3s;
    -o-transition-duration: 0.3s;
    -webkit-transition-duration: 0.3s;
    transition-duration: 0.3s;
    -moz-transition-timing-function: ease-in-out, ease-in-out, ease-in-out,
      ease-in-out;
    -o-transition-timing-function: ease-in-out, ease-in-out, ease-in-out,
      ease-in-out;
    -webkit-transition-timing-function: ease-in-out, ease-in-out, ease-in-out,
      ease-in-out;
    transition-timing-function: ease-in-out, ease-in-out, ease-in-out,
      ease-in-out;
  }
  header ul.mainNav.active {
    left: 0;
  }
  header ul.mainNav li {
    font-size: 16px;
    display: block;
    padding: 15px 20px;
  }
  header ul.mainNav li a.secondary-btn {
    max-width: 200px;
    text-align: center;
  }
  header ul.mainNav li a span.arrorDown {
    display: none;
  }
  header ul.mainNav li.mobile-top {
    display: block;
    padding: 20px;
    position: sticky;
    top: 0;
    z-index: 1;
    background: #fff;
  }
  header ul.mainNav li.mobile-top .m-top-inner {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
  }
  header ul.mainNav li.mobile-top .m-top-inner a.close {
    float: none;
    width: auto;
    opacity: 1;
    text-shadow: none;
    color: #3d2e83;
  }
  header ul.mainNav li a {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  header ul.mainNav ul.subMenu {
    position: relative;
    transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
    transition-duration: 0.4s;
    transition-duration: 0.2s;
    display: none;
    overflow: visible;
    opacity: 1;
    max-height: inherit;
  }
  header ul.mainNav ul.subMenu.active {
    display: block;
  }
  header span.submenu-icon {
    display: block;
    height: 24px;
    position: absolute;
    right: 15px;
    top: 15px;
    cursor: pointer;
    z-index: 1;
  }
  .cart-block.order-summary {
    margin-top: 30px;
  }
  .resume-sample a.cat-select {
    display: flex;
    width: 100%;
    max-width: 100%;
  }
  .resume-sample .resume-left-block {
    display: none;
  }
  .resume-sample .resume-sample-right {
    margin-top: 30px;
  }
  .resume-analysis .career-list {
    margin-bottom: 20px;
  }
  .services-resume .tab-content {
    margin-bottom: 20px;
  }
  .services-resume .tab-content .list {
    margin-bottom: 20px;
  }
  .shopping-cart a.cat-select {
    display: flex;
    width: 100%;
    max-width: 100%;
  }
  .shopping-cart .col-lg-4 .cart-step {
    margin-bottom: 0;
  }
  .shopping-cart .col-lg-8 .cart-step {
    margin-top: 30px;
  }
  .shopping-cart .shopping-cart-left {
    display: none;
    border-top-left-radius: 0px;
    border-top-right-radius: 0px;
    margin: -6px 0px 0px;
  }
  .shopping-cart .shopping-cart-right {
    margin-top: 20px;
  }
  .shopping-cart .shopping-cart-right .career-services-box {
    margin-bottom: 15px;
  }
  .shopping-cart .cart-step .step > div .material-icons {
    display: block;
  }
  .shopping-cart .payment-details-sec .block {
    min-height: 195px;
    margin-bottom: 15px;
  }
  .shopping-cart .payment-details-sec .block.bottom-block {
    margin-top: 15px;
  }
  .shopping-cart .payment-details-sec .block.bottom-block .bottom-block-inner {
    flex-wrap: wrap;
  }
  .shopping-cart
    .payment-details-sec
    .block.bottom-block
    .bottom-block-inner
    > div {
    max-width: 50%;
    margin: 0 0 20px;
  }
  .blog-detail .blog-detail-inner {
    margin-bottom: 30px;
  }
  .sectionHolder .contact-form {
    margin-top: 20px;
  }
  div#LatestNews {
    margin-bottom: 15px;
  }
  div#LatestNews a.blog-box {
    margin-bottom: 0;
  }
  .sectionHolder .why-wait p {
    font-size: 16px;
  }
}
@media (max-width: 767px) {
  .bannerHold .bannerContent h1 {
    font-size: 24px;
  }
  .bannerHold .bannerContent .home-cprw-logo {
    margin: 15px 15px 0;
  }
  .sectionHolder h1 {
    font-size: 24px;
  }
  .sectionHolder .blog-box {
    margin-bottom: 15px;
  }
  #testimonial h4 {
    margin-bottom: 15px !important;
  }
  .faqHold {
    font-size: 14px;
  }
  .faqHeader {
    font-size: 16px;
  }
  .faqHold + a.primary-btn {
    display: block;
    margin: 0 auto;
    text-align: center;
    max-width: 135px;
  }
  .countHold h1 {
    font-size: 36px;
  }
  .countHold h5 {
    font-size: 18px;
  }
  .countHold .col-12.col-sm-4.col-lg-4.col-md-4.text-center {
    margin-bottom: 30px;
  }
  .articlesHold .row.align-items-center img {
    max-height: inherit;
  }
  .footerHold {
    text-align: center;
  }
  .footerHold .col-12.col-col-lg-3.col-md-3.col-sm-3.mb-3 img {
    max-width: 190px !important;
  }
  .footerHold ul.social-icon li a {
    width: 40px;
    height: 40px;
  }
  .footerHold ul.social-icon li a.twitter {
    background-position: -34px -161px;
    background-size: 300px 300px;
  }
  .footerHold ul.social-icon li a.linkedIn {
    background-size: 300px 300px;
    background-position: -32px -190px;
  }
  .footerHold ul.social-icon li a.facebook {
    background-size: 300px 300px;
    background-position: -31px -217px;
  }
  .footer-mid p.phone {
    margin: 0 auto 20px;
    max-width: 275px;
  }
  .footer-mid p.location {
    max-width: 335px;
    margin: 0 auto;
  }
  .footerHold hr {
    display: none;
  }
  .scrollTop {
    width: 60px;
    height: 60px;
  }
  .scrollTop:after {
    height: 60px;
    width: 60px;
  }
  .footerHold .col-12.col-col-lg-3.col-md-3.mb-3 img {
    max-width: 190px !important;
    margin-bottom: 20px;
  }
  .works-desktop {
    display: none;
  }
  .works-mobile {
    display: block !important;
  }
  .tabHold {
    display: none;
  }
  .accordionHold {
    display: block;
  }
  .cardHold {
    border: none;
    border-radius: 0;
    background: #fff;
  }
  .cardHold > div {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .cardHold > div:first-child {
    padding: 0 15px 15px;
  }
  .cardHold h2 {
    font-size: 15px;
    padding: 0;
    margin: 0;
  }
  .cardHold h2 br {
    display: none;
  }
  .cardHold a.view {
    font-size: 14px;
    margin: 0 !important;
  }
  .accordionHold .card-body {
    padding: 10px;
  }
  .radioContent.blue,
  .radioContent.red {
    padding: 10px;
  }
  .cus-radio {
    padding-right: 0;
    text-align: left;
  }
  h3.footer-heading {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 15px;
  }
  h3.footer-heading i {
    margin-left: 5px;
  }
  ul.social-icon {
    display: none;
  }
  .footer-botton-links {
    display: none;
  }
  h3.footer-heading.active i.material-icons {
    transition: ease all 0.5s;
    -webkit-transform: rotate(180deg);
    -moz-transform: rotate(180deg);
    -ms-transform: rotate(180deg);
    -o-transform: rotate(180deg);
    transform: rotate(180deg);
  }
  .footer-botton-links {
    overflow: auto;
    max-height: 200px;
    margin-bottom: 20px;
  }
  .imgBox {
    margin: 25px 0;
  }
  .imgBox img {
    width: 100%;
  }
  .contentBox ul {
    display: block;
  }
  .contentBox ul li {
    max-width: 100%;
  }
  #cvPackages .cardHold {
    border: 1px solid #e1e3e5;
    border-radius: 10px;
  }
  #cvPackages .cardHold h2 {
    margin-bottom: 5px;
    min-height: 30px;
  }
  #cvPackages .cardHold a.view {
    margin: 0 0 1rem !important;
    display: block;
  }
  .bannerHold.banner-inner .bannerContent h1 {
    font-size: 24px;
  }
  .bannerHold.banner-inner .bannerContent p {
    font-size: 16px;
  }
  .sectionHolder .cart-block > h4 {
    text-align: center;
    margin-bottom: 10px;
  }
  .sectionHolder .cart-block .cart-box .top .price {
    display: none;
  }
  .sectionHolder .cart-block .cart-box .price-mobile {
    display: block;
    margin-top: 10px;
  }
  .sectionHolder .cart-block .con-btn {
    margin: 0 auto;
  }
  .testimonial-sec .tabHold {
    display: block;
  }
  .testimonial-sec .tabHold .nav-tabs .nav-item {
    margin-bottom: 1px;
    margin-right: 1px;
  }
  .testimonial-sec .tabHold .nav-tabs .nav-link {
    font-size: 13px;
    padding: 0.4rem 0.5rem;
    line-height: 1.3;
  }
  .testimonial-sec .testimonical-block {
    display: block;
    text-align: center;
  }
  .inner-pages .top-heading {
    display: block;
    text-align: center;
  }
  .inner-pages .top-heading h2 {
    margin: 0 0 15px;
  }
  .inner-pages .career-list table.table td,
  .inner-pages .career-list table.table th {
    display: block;
  }
  .inner-pages .career-list table.table.last tr:first-child {
    display: none;
  }
  .inner-pages .career-list table.table.last tr td {
    padding: 0;
  }
  .inner-pages .career-list table.table.last .contentBox h6 {
    background: #f6f8f7;
    font-size: 16px;
    font-weight: 600;
    padding: 0.75rem;
    display: block;
  }
  .inner-pages .career-list table.table.last ul {
    padding: 0.75rem;
  }
  .inner-pages .career-list .faqHold + a.primary-btn {
    max-width: 100%;
  }
  .inner-pages .career-list a.primary-btn {
    max-width: 130px;
    display: block;
    margin: 0 auto;
    text-align: center;
  }
  .services-resume .tabHold,
  .services-resume .tab-content {
    display: none;
  }
  .services-resume .tab-content,
  .services-resume .card-body {
    padding: 0;
    border: none;
  }
  .services-resume .tab-content .sample-executive,
  .services-resume .card-body .sample-executive {
    flex-wrap: wrap;
    justify-content: center;
  }
  .services-resume .tab-content .sample-executive > h6,
  .services-resume .card-body .sample-executive > h6 {
    width: 100%;
    text-align: center;
    margin: 0 0 10px;
  }
  .services-resume .tab-content .sample-executive a,
  .services-resume .card-body .sample-executive a {
    margin: 0 15px;
  }
  .services-resume .tab-content .list,
  .services-resume .card-body .list {
    margin-bottom: 15px;
  }
  .services-resume .accordion {
    display: block;
    margin-bottom: 20px;
  }
  .services-resume .accordion .card {
    border: 1px solid #ebeded;
    border-radius: 8px;
    margin-top: 15px;
  }
  .services-resume .accordion .card .card-header {
    padding: 5px 20px;
    border-bottom: 1px solid #ebeded;
    background: #f6f8f7;
    border-radius: 8px 8px 0 0;
  }
  .services-resume .accordion .card .card-header button {
    padding: 0;
    padding: 5px 0;
    color: #e56653;
    font-weight: 600;
    text-decoration: none;
  }
  .services-resume .accordion .card .card-header button.collapsed {
    color: #000;
  }
  .resume-counselling-panel .resume-panel {
    display: block;
    text-align: center;
  }
  .resume-counselling-panel .resume-panel img {
    margin: 0 0 15px 0;
  }
  .resume-sample .resume-sample-right {
    padding: 90px 20px 25px;
  }
  .shopping-cart .cart-step {
    flex-wrap: wrap;
    justify-content: center;
    padding: 15px;
  }
  .shopping-cart .cart-step .step {
    padding: 0 20px;
  }
  .shopping-cart .cart-step img {
    margin-top: 20px;
  }
  .shopping-cart .shopping-cart-right .resume-service-box .resume-inner-box {
    flex-wrap: wrap;
    padding: 0;
  }
  .shopping-cart
    .shopping-cart-right
    .resume-service-box
    .resume-inner-box
    > h5 {
    max-width: 100%;
    width: 100%;
    margin: 0 0 10px;
    padding: 10px 15px 0;
  }
  .shopping-cart
    .shopping-cart-right
    .resume-service-box
    .resume-inner-box
    > div {
    justify-content: space-between;
    width: 100%;
  }
  .shopping-cart
    .shopping-cart-right
    .resume-service-box
    .resume-inner-box
    > div
    h5 {
    width: 50%;
  }
  .shopping-cart
    .shopping-cart-right
    .resume-service-box
    .resume-inner-box
    .cus-radio {
    margin: 0;
    min-width: 140px;
  }
  .shopping-cart
    .shopping-cart-right
    .resume-service-box
    .resume-inner-box
    .primary-btn {
    padding: 8px 12px;
    font-size: 14px;
    width: 100%;
    text-align: center;
    margin: 20px 0 0;
  }
  .shopping-cart
    .shopping-cart-right
    .resume-service-box.resume-white
    .resume-inner-box
    > h5 {
    padding: 0;
  }
  .shopping-cart .payment-details-sec .block {
    min-height: 210px;
    padding: 20px 10px;
  }
  .resume-analysis .career-list .file-upload-sec .file-upload-inner .btn {
    font-size: 14px;
    padding: 7px 15px;
  }
  .not-found-page {
    padding: 40px 0;
  }
  .not-found-page .not-find-inner img {
    max-width: 250px;
  }
  .not-found-page .not-find-inner p {
    font-size: 16px;
    margin: 15px auto 20px;
  }
  .order-page .order-page-inner h1 {
    font-size: 28px;
  }
  .sectionHolder .contact-form {
    margin-top: 20px;
    padding: 25px;
  }
  .sectionHolder .why-wait p {
    font-size: 13px;
  }
  .sectionHolder .why-wait h5 {
    margin: 5px 0 10px;
    font-size: 18px;
  }
  .feature-career-tips .productCard h5 {
    font-size: 16px;
    min-height: 68px;
  }
  .contact-sec .why-wait h1 {
    font-size: 32px;
  }
  .hired-sec {
    text-align: center;
  }
  .hired-sec img {
    margin-top: 30px;
  }
}
@media (max-width: 575px) {
  .shopping-cart .payment-details-sec .block {
    min-height: inherit;
    padding: 20px;
  }
  .shopping-cart
    .payment-details-sec
    .block.bottom-block
    .bottom-block-inner
    > div {
    max-width: 100%;
  }
  .feature-career-tips .productCard h5 {
    min-height: 50px;
  }
}
@media (max-width: 479px) {
  .footer-mid .d-flex.w-100.align-items-center p {
    text-align: left;
  }
  .mobHold {
    font-size: 16px;
  }
  .mobHold span.mobile-icon {
    width: 70px;
    height: 70px;
    border: 5px solid #f5c2ba;
  }
  .contantholder h3 a {
    font-size: 16px;
  }
  .cardHold > div:first-child {
    display: block;
  }
}

.loader-overlay {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  visibility: visible;
  z-index: 1099;
  background: rgba(255, 255, 255, 0.8)
    url("https://builder.zety.com/resume/images/rwzv2/zty/loading.gif")
    no-repeat -9999px -9999px;
}
.progress-bar-wrapper {
  position: absolute;
  top: 46%;
  left: 50%;
  z-index: 1100;
  transform: translate(-50%, -46%);
  width: 268px;
  text-align: center;
}
.progress-text {
  font-size: 18px;
  color: #07142b;
  text-transform: capitalize;
  font-weight: 700;
  width: 100%;
  margin-top: 8px;
  height: auto;
}
.progress-bar {
  width: 100%;
  height: 10px;
  position: relative;
  margin-top: 10px;
}
.progress-bar .progress-linear {
  background: #d7d2cf;
  width: 100%;
  height: 100%;
}
.progress-bar .progress-gradient {
  position: absolute;
  left: 0;
  top: 0;
  width: 0;
  height: 100%;
  background: linear-gradient(
    to right,
    #05aa8b 0%,
    #2c6eaf 22%,
    #15a587 60%,
    #f8c908 100%
  );
}
.progress-bar .progress-gradient {
  background: linear-gradient(to right, #3ad1b8 0%, #1b8d86 60%, #006a7b 100%);
}
.progress-bar .progress-animate {
  width: 0; /* Initial width */
  height: 10px; /* Height of the loader */
  background-color: #007bff; /* Loader color */
  animation: increaseWidth 23s ease-in-out infinite; /* Animation */
}

@keyframes increaseWidth {
  0% {
    width: 0;
  }
  50% {
    width: 50%; /* Increase width to 50% at 50% of the animation duration */
  }
  100% {
    width: 100%; /* Increase width to 100% at the end of the animation duration */
  }
}

.datepickerhold.form-group {
  padding: 0 15px;
  width: 100%;
}
.btn-area-sec {
  margin: 15px 0;
  color: #fff;
  text-align: right;
}
.btn-area-sec a.btn-primary {
  min-width: 120px;
  margin-right: 5px;
}
.btn-area-sec a.btn-primary:hover {
  color: #1f85cd;
}
.form-group.input-button-mines {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 10px 0 0 !important;
}
.form-group.input-button-mines a.btn-primary {
  min-width: 50px;
  margin: 0 0 0 15px;
  color: #fff;
}
.form-group.input-button-mines a.btn-primary:hover {
  color: #1f85cd;
}
.prview-box select.form-control {
  height: auto !important;
  margin: 0 20px;
  max-width: 200px;
}
.left-form .form-group .v-autocomplete {
  position: relative;
}
</style>